import { createCustomElement } from '@angular/elements';
import * as i4 from '@angular/common';
import { CommonModule, AsyncPipe, NgTemplateOutlet, NgComponentOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, input, Component, ViewEncapsulation, ChangeDetectionStrategy, output, computed, inject, ElementRef, Injectable, Inject, Optional, Injector, runInInjectionContext, LOCALE_ID, Pipe, signal, ViewContainerRef, Directive, viewChild, contentChild, ChangeDetectorRef, model, DestroyRef, HostBinding, Input, ViewChild, TemplateRef, linkedSignal, contentChildren, NgZone, forwardRef, ContentChild, NgModule, viewChildren } from '@angular/core';
import * as i1$2 from '@angular/forms';
import { FormGroupDirective, FormGroup, FormArray, FormControlName, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, FormControl, Validators, ReactiveFormsModule, FormBuilder, NgControl } from '@angular/forms';
import * as i1$1 from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbDate, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, throttleTime, of, take, tap, share, switchMap, distinctUntilChanged, Subject, map, catchError, ReplaySubject, takeUntil } from 'rxjs';
import * as i1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { explicitEffect } from 'ngxtension/explicit-effect';
import * as i2 from '@ng-select/ng-select';
import { NgSelectModule, NgItemLabelDirective } from '@ng-select/ng-select';
import { normalizePassiveListenerOptions } from '@angular/cdk/platform';
import { AngularNodeViewRenderer, AngularNodeViewComponent, TiptapDraggableDirective, TiptapEditorDirective } from 'ngx-tiptap';
import Image$1, { Image } from '@tiptap/extension-image';
import { Plugin, NodeSelection, PluginKey } from 'prosemirror-state';
import { getSchemaTypeNameByName, getMarkType, getNodeType, mergeAttributes, Node, getMarkRange, Extension, Mark, Editor } from '@tiptap/core';
import { TextAlign as TextAlign$1 } from '@tiptap/extension-text-align';
import * as i2$1 from '@angular/material/icon';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import * as i5 from 'ngx-float-ui';
import { NgxFloatUiDirective, NgxFloatUiPlacements, NgxFloatUiModule } from 'ngx-float-ui';
import { Highlight } from '@tiptap/extension-highlight';
import { Blockquote } from '@tiptap/extension-blockquote';
import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { ListItem } from '@tiptap/extension-list-item';
import { Paragraph as Paragraph$1 } from '@tiptap/extension-paragraph';
import { HorizontalRule } from '@tiptap/extension-horizontal-rule';
import * as i1$3 from '@angular/material/dialog';
import { MatDialogClose, MatDialogModule, MatDialogTitle, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { Italic } from '@tiptap/extension-italic';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { Link } from '@tiptap/extension-link';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Youtube } from '@tiptap/extension-youtube';
import { History } from '@tiptap/extension-history';
import { Strike } from '@tiptap/extension-strike';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import { TextStyle } from '@tiptap/extension-text-style';
import { Color as Color$1 } from '@tiptap/extension-color';
import { Underline } from '@tiptap/extension-underline';
import { Document } from '@tiptap/extension-document';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import { Gapcursor } from '@tiptap/extension-gapcursor';
import { HardBreak } from '@tiptap/extension-hard-break';
import { Text } from '@tiptap/extension-text';
import { Placeholder as Placeholder$1 } from '@tiptap/extension-placeholder';
import * as i2$2 from '@angular/platform-browser';
import * as i2$3 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

const BUI_BUTTON_GROUP = new InjectionToken('BuiButtonGroupComponent');
class ButtonGroupComponent {
    constructor() {
        this.disabled = input(false, { transform: coerceBooleanProperty });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: ButtonGroupComponent, isStandalone: true, selector: "bui-button-group", inputs: { disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-button-group": "true", "class.disabled": "disabled()" } }, providers: [
            { provide: BUI_BUTTON_GROUP, useExisting: ButtonGroupComponent },
        ], ngImport: i0, template: `
		<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-button-group',
                    template: `
		<ng-content></ng-content>`,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        { provide: BUI_BUTTON_GROUP, useExisting: ButtonGroupComponent },
                    ],
                    host: {
                        '[class.bui-button-group]': 'true',
                        '[class.disabled]': 'disabled()',
                    },
                }]
        }] });

class SpinnerComponent {
    constructor() {
        this.diameter = input.required();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: SpinnerComponent, isStandalone: true, selector: "bui-spinner", inputs: { diameter: { classPropertyName: "diameter", publicName: "diameter", isSignal: true, isRequired: true, transformFunction: null } }, ngImport: i0, template: "<mat-spinner\r\n\t\tcolor=\"primary\"\r\n\t\t[diameter]=\"diameter()\"\r\n\t\tmode=\"indeterminate\"\r\n></mat-spinner>\r\n", styles: [".mat-mdc-progress-spinner svg>circle{stroke:currentColor}\n"], dependencies: [{ kind: "ngmodule", type: MatProgressSpinnerModule }, { kind: "component", type: i1.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-spinner', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        MatProgressSpinnerModule,
                    ], template: "<mat-spinner\r\n\t\tcolor=\"primary\"\r\n\t\t[diameter]=\"diameter()\"\r\n\t\tmode=\"indeterminate\"\r\n></mat-spinner>\r\n", styles: [".mat-mdc-progress-spinner svg>circle{stroke:currentColor}\n"] }]
        }] });

class ButtonComponent {
    _onButtonClick(_event) {
        if (this.disabled()) {
            _event.preventDefault();
            _event.stopPropagation();
            return false;
        }
    }
    constructor() {
        this.type = input('button');
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.tabindexInput = input(null, { alias: 'tabindex' });
        this.variant = input('default');
        this.color = input('default');
        this.loading = input(false);
        this.throttledClick = output();
        this.disabled = computed(() => {
            const disabled = this.disabledInput();
            const buttonGroupDisabled = this.buttonGroupComponent?.disabled();
            return disabled || buttonGroupDisabled;
        });
        this.tabindex = computed(() => {
            const tabindex = this.tabindexInput();
            const disabled = this.disabled();
            return tabindex || (disabled ? -1 : null);
        });
        this.classes = computed(() => ['variant--' + this.variant(), 'color--' + this.color()]);
        this.buttonGroupComponent = inject(BUI_BUTTON_GROUP, { optional: true });
        this.element = inject(ElementRef);
        this.nativeElement = this.element.nativeElement;
        fromEvent(this.nativeElement, 'click')
            .pipe(throttleTime(300), takeUntilDestroyed())
            .subscribe(() => this.throttledClick.emit());
    }
    focus() {
        this.nativeElement?.focus();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: ButtonComponent, isStandalone: true, selector: "button[bui-button]", inputs: { type: { classPropertyName: "type", publicName: "type", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, tabindexInput: { classPropertyName: "tabindexInput", publicName: "tabindex", isSignal: true, isRequired: false, transformFunction: null }, variant: { classPropertyName: "variant", publicName: "variant", isSignal: true, isRequired: false, transformFunction: null }, color: { classPropertyName: "color", publicName: "color", isSignal: true, isRequired: false, transformFunction: null }, loading: { classPropertyName: "loading", publicName: "loading", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { throttledClick: "throttledClick" }, host: { listeners: { "click": "_onButtonClick($event)" }, properties: { "class.bui-button": "true", "attr.type": "type()", "attr.disabled": "disabled() || null", "class.disabled": "disabled()", "attr.tabindex": "tabindex()", "class": "classes()" } }, ngImport: i0, template: "@if (loading()) {\r\n\t<bui-spinner [diameter]=\"20\"></bui-spinner>\r\n} @else {\r\n\t<ng-content></ng-content>\r\n}", dependencies: [{ kind: "component", type: SpinnerComponent, selector: "bui-spinner", inputs: ["diameter"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'button[bui-button]', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        SpinnerComponent,
                    ], host: {
                        '[class.bui-button]': 'true',
                        '[attr.type]': 'type()',
                        '[attr.disabled]': 'disabled() || null',
                        '[class.disabled]': 'disabled()',
                        '[attr.tabindex]': 'tabindex()',
                        '(click)': '_onButtonClick($event)',
                        '[class]': 'classes()',
                    }, template: "@if (loading()) {\r\n\t<bui-spinner [diameter]=\"20\"></bui-spinner>\r\n} @else {\r\n\t<ng-content></ng-content>\r\n}" }]
        }], ctorParameters: () => [] });

const BUI_MESSAGE_RESOLVER = new InjectionToken('BuiMessageResolver');

class MessageService {
    constructor(messageResolver) {
        this.messageResolver = messageResolver;
    }
    resolve(key, replacements) {
        if (!this.messageResolver) {
            return of(`{{${key}}}`);
        }
        return this.messageResolver.resolve(key, replacements);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MessageService, deps: [{ token: BUI_MESSAGE_RESOLVER, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MessageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MessageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [BUI_MESSAGE_RESOLVER]
                }, {
                    type: Optional
                }] }] });

class MsgKeyPipe {
    constructor() {
        this.msgService = inject(MessageService);
        this.injector = inject(Injector);
    }
    static { this.cache = {}; }
    static { this.observableCache = {}; }
    transform(key) {
        let locale;
        runInInjectionContext(this.injector, () => {
            locale = inject(LOCALE_ID)
                .toString();
        });
        if (locale !== MsgKeyPipe.lastLocale) {
            MsgKeyPipe.lastLocale = locale;
            MsgKeyPipe.cache = {};
        }
        if (MsgKeyPipe.cache[key]) {
            return of(MsgKeyPipe.cache[key]);
        }
        if (!MsgKeyPipe.observableCache[key]) {
            MsgKeyPipe.observableCache[key] = this.msgService.resolve(key)
                .pipe(take(1), tap(message => {
                MsgKeyPipe.cache[key] = message;
                delete MsgKeyPipe.observableCache[key];
            }), share());
        }
        return MsgKeyPipe.observableCache[key];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MsgKeyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.1", ngImport: i0, type: MsgKeyPipe, isStandalone: true, name: "msgKey" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MsgKeyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'msgKey',
                }]
        }] });

var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition[TooltipPosition["TOP_RIGHT"] = 0] = "TOP_RIGHT";
    TooltipPosition[TooltipPosition["TOP_LEFT"] = 1] = "TOP_LEFT";
    TooltipPosition[TooltipPosition["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
    TooltipPosition[TooltipPosition["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
})(TooltipPosition || (TooltipPosition = {}));

class TooltipComponent {
    constructor() {
        this.tooltip = input();
        this.visible = signal(false);
        this.isErrorTooltip = signal(false);
        this.left = signal(0);
        this.top = signal(0);
        this.width = signal(undefined);
        this.tooltipPosition = signal(TooltipPosition.TOP_RIGHT);
        this.tooltipPositionClass = computed(() => TOOLTIP_POSITION_CLASSES[this.tooltipPosition()]);
        this.effectiveVisible = computed(() => {
            const tooltip = this.tooltip();
            const visible = this.visible();
            return visible && !!tooltip;
        });
    }
    show() {
        this.visible.set(true);
    }
    hide() {
        this.visible.set(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: TooltipComponent, isStandalone: true, selector: "bui-tooltip", inputs: { tooltip: { classPropertyName: "tooltip", publicName: "tooltip", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-tooltip": "true", "class.bui-tooltip--visible": "effectiveVisible()", "class.bui-tooltip--is-error": "isErrorTooltip()", "class": "tooltipPositionClass()", "style.left.px": "left()", "style.top.px": "top()", "style.width.px": "width()" } }, ngImport: i0, template: "<dialog class=\"bui-tooltip__content\"\r\n        open\r\n        [innerHTML]=\"tooltip()\"></dialog>", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-tooltip', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.bui-tooltip]': 'true',
                        '[class.bui-tooltip--visible]': 'effectiveVisible()',
                        '[class.bui-tooltip--is-error]': 'isErrorTooltip()',
                        '[class]': 'tooltipPositionClass()',
                        '[style.left.px]': 'left()',
                        '[style.top.px]': 'top()',
                        '[style.width.px]': 'width()',
                    }, template: "<dialog class=\"bui-tooltip__content\"\r\n        open\r\n        [innerHTML]=\"tooltip()\"></dialog>" }]
        }], ctorParameters: () => [] });
const TOOLTIP_POSITION_CLASSES = {
    [TooltipPosition.TOP_RIGHT]: 'bui-tooltip--position--top-right',
    [TooltipPosition.TOP_LEFT]: 'bui-tooltip--position--top-left',
    [TooltipPosition.BOTTOM_RIGHT]: 'bui-tooltip--position--bottom-right',
    [TooltipPosition.BOTTOM_LEFT]: 'bui-tooltip--position--bottom-left',
};

const BUI_TOOLTIP_CONFIG = new InjectionToken('bui-tooltip-config');

class TooltipDirective {
    constructor() {
        this.tooltip = input(undefined, { alias: 'bui-tooltip' });
        this.disableTabindex = input(false, { transform: coerceBooleanProperty });
        this.tabindex = computed(() => this.disableTabindex() ? -1 : 0);
        this.maxWidth = 500;
        this.isErrorTooltip = false;
        this.config = inject(BUI_TOOLTIP_CONFIG, { optional: true }) ?? { enableHover: true };
        this.elementRef = inject(ElementRef); // Tooltip Trigger
        this.viewContainerRef = inject(ViewContainerRef); // Tooltip-Trigger ViewContainer
        this.createTooltipEffect();
    }
    createTooltipEffect() {
        this.tooltipEffect?.destroy();
        this.tooltipEffect = explicitEffect([this.tooltip], ([tooltip]) => {
            this.tooltipComponentRef?.setInput('tooltip', tooltip);
            this.positionTooltip();
        });
    }
    ngOnInit() {
        this.initTooltip();
    }
    ngOnDestroy() {
        this.tooltipComponentRef?.destroy();
    }
    onMouseEnter() {
        if (this.config.enableHover || this.isErrorTooltip) {
            this.showTooltip();
        }
    }
    onMouseLeave() {
        if (this.config.enableHover || this.isErrorTooltip) {
            this.hideTooltip();
        }
    }
    onEnterDown() {
        if (this.disableTabindex()) {
            return;
        }
        if (this.tooltipComponentRef?.instance.visible()) {
            this.hideTooltip();
        }
        else {
            this.showTooltip();
        }
    }
    onClick() {
        if (!this.config.enableHover) {
            this.onEnterDown();
        }
    }
    initTooltip() {
        this.tooltipComponentRef = this.viewContainerRef.createComponent(TooltipComponent);
        this.tooltipComponentRef.setInput('tooltip', this.tooltip());
    }
    showTooltip() {
        this.positionTooltip();
        this.tooltipComponentRef?.instance.show();
    }
    hideTooltip() {
        this.tooltipComponentRef?.instance.hide();
    }
    positionTooltip() {
        if (!this.tooltipComponentRef) {
            return;
        }
        const tooltipInstance = this.tooltipComponentRef.instance;
        const tooltipSpace = this.getTooltipSpace();
        const { top, right, bottom, left } = this.elementRef.nativeElement.getBoundingClientRect();
        tooltipInstance.tooltipPosition.set(tooltipSpace.position);
        tooltipInstance.width.set(tooltipSpace.width);
        tooltipInstance.left.set((right - left) / 2 + left);
        switch (tooltipSpace.position) {
            case TooltipPosition.TOP_RIGHT:
            case TooltipPosition.TOP_LEFT:
                tooltipInstance.top.set(top);
                break;
            case TooltipPosition.BOTTOM_RIGHT:
            case TooltipPosition.BOTTOM_LEFT:
                tooltipInstance.top.set(bottom);
        }
    }
    getTooltipSpace() {
        this.tooltipComponentRef.instance.width.set(undefined);
        const spaces = this.getAvailableSpaces();
        if (!spaces.length) {
            return {
                position: TooltipPosition.TOP_RIGHT,
                width: this.maxWidth,
            };
        }
        const sortedSpaces = spaces.sort((a, b) => b.width - a.width || a.position - b.position);
        return sortedSpaces[0];
    }
    getAvailableSpaces() {
        const triggerRect = this.elementRef.nativeElement.getBoundingClientRect();
        const tooltipStyles = window.getComputedStyle(this.tooltipComponentRef.location.nativeElement);
        const arrowStyles = window.getComputedStyle(this.tooltipComponentRef.location.nativeElement, '::before');
        const autoWidth = parseFloat(tooltipStyles.getPropertyValue('width'));
        const contentHeight = parseFloat(tooltipStyles.getPropertyValue('height'));
        const arrowTopHeight = parseFloat(arrowStyles.getPropertyValue('border-bottom-width'));
        const arrowBottomHeight = parseFloat(arrowStyles.getPropertyValue('border-top-width'));
        const tooltipHeight = contentHeight + arrowTopHeight + arrowBottomHeight;
        const windowHeight = window.innerHeight;
        const windowWidth = document.body.clientWidth;
        const fitsTop = tooltipHeight <= triggerRect.top;
        const fitsBottom = triggerRect.bottom + tooltipHeight <= windowHeight;
        const maxWidthRight = Math.min(windowWidth - triggerRect.right, this.maxWidth, autoWidth);
        const maxWidthLeft = Math.min(triggerRect.left, this.maxWidth, autoWidth);
        const result = [];
        if (fitsTop) {
            result.push({
                position: TooltipPosition.TOP_RIGHT,
                width: maxWidthRight,
            }, {
                position: TooltipPosition.TOP_LEFT,
                width: maxWidthLeft,
            });
        }
        if (fitsBottom) {
            result.push({
                position: TooltipPosition.BOTTOM_RIGHT,
                width: maxWidthRight,
            }, {
                position: TooltipPosition.BOTTOM_LEFT,
                width: maxWidthLeft,
            });
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TooltipDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "19.1.1", type: TooltipDirective, isStandalone: true, selector: "[bui-tooltip]", inputs: { tooltip: { classPropertyName: "tooltip", publicName: "bui-tooltip", isSignal: true, isRequired: false, transformFunction: null }, disableTabindex: { classPropertyName: "disableTabindex", publicName: "disableTabindex", isSignal: true, isRequired: false, transformFunction: null } }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()", "keydown.enter": "onEnterDown()", "click": "onClick()" }, properties: { "tabindex": "tabindex" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bui-tooltip]',
                    host: {
                        '[tabindex]': 'tabindex',
                        '(mouseenter)': 'onMouseEnter()',
                        '(mouseleave)': 'onMouseLeave()',
                        '(keydown.enter)': 'onEnterDown()',
                        '(click)': 'onClick()',
                    },
                }]
        }], ctorParameters: () => [] });

class GenericErrorControlNameDirective {
    constructor() {
        this.genericErrorControlName = input.required();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: GenericErrorControlNameDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "19.1.1", type: GenericErrorControlNameDirective, isStandalone: true, selector: "[genericErrorControlName]", inputs: { genericErrorControlName: { classPropertyName: "genericErrorControlName", publicName: "genericErrorControlName", isSignal: true, isRequired: true, transformFunction: null } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: GenericErrorControlNameDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[genericErrorControlName]',
                }]
        }] });

class UnassignableErrorsComponent {
    constructor() {
        this.errors = signal([]);
        this.hasErrors = computed(() => this.errors().length > 0);
        this.visibility = computed(() => this.errors().length ? 'block' : 'none');
        this.header = viewChild.required('header', { read: ElementRef });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: UnassignableErrorsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: UnassignableErrorsComponent, isStandalone: true, selector: "bui-unassignable-errors", host: { properties: { "class.bui-unassignable-errors": "true", "style.display": "visibility()" } }, viewQueries: [{ propertyName: "header", first: true, predicate: ["header"], descendants: true, read: ElementRef, isSignal: true }], ngImport: i0, template: "<header>{{ 'bui.unassignable-errors.title' | msgKey | async }}</header>\r\n<ul>\r\n\t@for (error of errors(); track error) {\r\n\t\t<li>{{ error }}</li>\r\n\t}\r\n</ul>\r\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: UnassignableErrorsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-unassignable-errors', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        MsgKeyPipe,
                    ], host: {
                        '[class.bui-unassignable-errors]': 'true',
                        '[style.display]': 'visibility()',
                    }, template: "<header>{{ 'bui.unassignable-errors.title' | msgKey | async }}</header>\r\n<ul>\r\n\t@for (error of errors(); track error) {\r\n\t\t<li>{{ error }}</li>\r\n\t}\r\n</ul>\r\n" }]
        }] });

class ValidationContextDirective {
    constructor() {
        this.name = input.required({ alias: 'buiValidationContext' });
        this.unassignableErrorsInput = input(undefined, { alias: 'unassignableErrors' });
        this.unassignableErrorsChild = contentChild(UnassignableErrorsComponent);
        this.formGroupDirective = inject(FormGroupDirective, { self: true });
        this.viewContainerRef = inject(ViewContainerRef);
        this.elRef = inject(ElementRef);
        this.cdr = inject(ChangeDetectorRef);
    }
    ngAfterContentInit() {
        this.unassignableErrorsComponent = this.unassignableErrorsInput() ?? this.unassignableErrorsChild();
        if (!this.unassignableErrorsComponent) {
            const unassignableErrorsRef = this.viewContainerRef.createComponent(UnassignableErrorsComponent);
            this.unassignableErrorsComponent = unassignableErrorsRef.instance;
            this.elRef.nativeElement.prepend(unassignableErrorsRef.hostView.rootNodes[0]);
            this.cdr.detectChanges();
        }
    }
    clearUnassignableErrors() {
        if (this.unassignableErrorsComponent) {
            this.unassignableErrorsComponent.errors.set([]);
        }
    }
    addValidationErrors(errors) {
        const unassignableErrors = [];
        if (typeof errors === 'string') {
            unassignableErrors.push(errors);
        }
        else if (Array.isArray(errors)) {
            unassignableErrors.push(...errors);
        }
        else {
            Object.entries(errors)
                .forEach(([controlName, controlErrors]) => {
                const errors = typeof controlErrors === 'string' ? [controlErrors] : controlErrors;
                let control = this.formGroupDirective.form.get(controlName);
                if (!control && this.name() && controlName.startsWith(this.name())) {
                    control = this.formGroupDirective.form.get(controlName.substring(this.name().length));
                }
                if (control) {
                    control.setErrors(Object.fromEntries(errors.map((error, index) => [controlName + index, error])));
                }
                else {
                    unassignableErrors.push(...errors);
                }
            });
        }
        if (this.unassignableErrorsComponent) {
            this.unassignableErrorsComponent.errors.set(unassignableErrors);
        }
    }
    scrollToFirstError() {
        if (this.unassignableErrorsComponent?.hasErrors()) {
            this.unassignableErrorsComponent.header()
                .nativeElement
                .scrollIntoView();
            return;
        }
        const supportsCheckVisibility = HTMLElement.prototype.checkVisibility !== undefined;
        if (!supportsCheckVisibility) {
            // Wir können nicht überprüfen, ob Elemente z.B. hidden oder wegen opacity unsichtbar sind.
            // Als Fallback zum ersten fehlerhaften Input scrollen, unabhängig von Sichtbarkeit
            this.elRef.nativeElement.querySelector('[formControlName].ng-invalid')
                ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }
        const errorElements = this.elRef.nativeElement.querySelectorAll('[formControlName].ng-invalid')
            .values();
        for (const errorEl of errorElements) {
            // Scrolle zum ersten sichtbaren fehlerhaften Input
            if (errorEl.checkVisibility()) {
                errorEl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }
        }
        let errorEl = this.elRef.nativeElement.querySelector('[formControlName].ng-invalid');
        if (errorEl) {
            // Wenn kein fehlerhafter Input sichtbar ist, scrolle "in die Nähe" des ersten fehlerhaften Inputs
            while (!errorEl.checkVisibility()) {
                errorEl = errorEl.firstElementChild ?? errorEl.nextElementSibling;
                if (!errorEl) {
                    let parent = errorEl.parentElement;
                    while (!parent?.nextElementSibling) {
                        parent = parent.parentElement;
                    }
                    errorEl = parent.nextElementSibling;
                }
            }
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
    markAllAsDirty() {
        this.markAsDirtyRecursive(this.formGroupDirective.form);
    }
    markAsDirtyRecursive(control) {
        control.markAsDirty({ onlySelf: true });
        if (control instanceof FormGroup || control instanceof FormArray) {
            Object.values(control.controls)
                .forEach(childControl => this.markAsDirtyRecursive(childControl));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ValidationContextDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.2.0", version: "19.1.1", type: ValidationContextDirective, isStandalone: true, selector: "[buiValidationContext]", inputs: { name: { classPropertyName: "name", publicName: "buiValidationContext", isSignal: true, isRequired: true, transformFunction: null }, unassignableErrorsInput: { classPropertyName: "unassignableErrorsInput", publicName: "unassignableErrors", isSignal: true, isRequired: false, transformFunction: null } }, queries: [{ propertyName: "unassignableErrorsChild", first: true, predicate: UnassignableErrorsComponent, descendants: true, isSignal: true }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ValidationContextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[buiValidationContext]',
                }]
        }], ctorParameters: () => [] });

class ValidationControlDirective extends TooltipDirective {
    constructor() {
        super();
        this.tooltip = model();
        this.isErrorTooltip = true;
        this.messageService = inject(MessageService);
        this.destroyRef = inject(DestroyRef);
        this.formControl = inject(FormControlName, { optional: true });
        this.validationContext = inject(ValidationContextDirective, { optional: true });
        this.genericErrorControlName = inject(GenericErrorControlNameDirective, { optional: true });
        this.parentValidationControl = inject(ValidationControlDirective, { optional: true, skipSelf: true });
        // Der im super-Constructor erstellte Effect referenziert das überschriebene input-Signal und muss neu erzeugt werden
        this.createTooltipEffect();
    }
    initTooltip() {
        if (this.parentValidationControl) {
            return;
        }
        super.initTooltip();
        this.tooltipComponentRef?.instance.isErrorTooltip.set(true);
    }
    ngAfterContentInit() {
        if (this.parentValidationControl) {
            return;
        }
        this.formControl?.statusChanges
            .pipe(takeUntilDestroyed(this.destroyRef), switchMap(() => this.getErrorMessage()), distinctUntilChanged())
            .subscribe((errorMessage) => this.tooltip.set(errorMessage ?? ''));
    }
    showTooltip() {
        if (this.parentValidationControl) {
            return;
        }
        super.showTooltip();
    }
    getErrorMessage() {
        const errorKey = this.getErrorKey();
        if (!errorKey) {
            return of(null);
        }
        if (typeof errorKey.details === 'string') {
            return of(errorKey.details);
        }
        return this.messageService.resolve(errorKey.key, errorKey.details);
    }
    getErrorKey() {
        if (!this.formControl?.invalid) {
            return null;
        }
        let prefix = this.genericErrorControlName?.genericErrorControlName();
        if (!prefix && !this.validationContext?.name()) {
            prefix = '' + this.formControl.name;
        }
        if (!prefix) {
            prefix = `${this.validationContext.name()}.${this.formControl.name}`;
        }
        const [name, details] = Object.entries(this.formControl.errors)[0];
        return {
            key: [
                prefix,
                'error',
                name,
            ].join('.'),
            details,
        };
    }
    positionTooltip() {
        if (!this.tooltipComponentRef) {
            return;
        }
        const tooltipInstance = this.tooltipComponentRef.instance;
        const tooltipSpace = this.getTooltipSpace();
        const { top, bottom, right } = this.elementRef.nativeElement.getBoundingClientRect();
        tooltipInstance.tooltipPosition.set(tooltipSpace.position);
        tooltipInstance.width.set(tooltipSpace.width);
        tooltipInstance.left.set(right);
        tooltipInstance.top.set(tooltipSpace.position === TooltipPosition.BOTTOM_LEFT ? bottom : top);
    }
    getAvailableSpaces() {
        const triggerRect = this.elementRef.nativeElement.getBoundingClientRect();
        const tooltipStyles = window.getComputedStyle(this.tooltipComponentRef.location.nativeElement);
        const autoWidth = parseFloat(tooltipStyles.getPropertyValue('width'));
        const tooltipHeight = parseFloat(tooltipStyles.getPropertyValue('height'));
        const windowHeight = window.innerHeight;
        const windowWidth = document.body.clientWidth;
        const fitsTop = tooltipHeight <= triggerRect.top;
        const fitsBottom = triggerRect.top + tooltipHeight <= windowHeight;
        const maxWidthRight = Math.min(windowWidth - triggerRect.right, this.maxWidth, autoWidth);
        const maxWidthLeft = Math.min(triggerRect.right, this.maxWidth, autoWidth);
        const result = [];
        if (fitsTop) {
            result.push(...[
                {
                    position: TooltipPosition.TOP_RIGHT,
                    width: maxWidthRight,
                }, {
                    position: TooltipPosition.TOP_LEFT,
                    width: maxWidthLeft,
                },
            ]);
        }
        if (fitsBottom) {
            result.push(...[
                {
                    position: TooltipPosition.BOTTOM_RIGHT,
                    width: maxWidthRight,
                }, {
                    position: TooltipPosition.BOTTOM_LEFT,
                    width: maxWidthLeft,
                },
            ]);
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ValidationControlDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "19.1.1", type: ValidationControlDirective, isStandalone: true, selector: "[buiValidationControl]", inputs: { tooltip: { classPropertyName: "tooltip", publicName: "tooltip", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { tooltip: "tooltipChange" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ValidationControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[buiValidationControl]',
                }]
        }], ctorParameters: () => [] });

// de: 30.12.2000
const DATE_FORMAT_DE = {
    delimiter: '.',
    dayIndex: 0,
    monthIndex: 1,
    yearIndex: 2,
};
// en-GB: 30/12/2000
const DATE_FORMAT_EN_GB = {
    delimiter: '/',
    dayIndex: 0,
    monthIndex: 1,
    yearIndex: 2,
};
// en-US: 12/30/2000
const DATE_FORMAT_EN_US = {
    delimiter: '/',
    dayIndex: 1,
    monthIndex: 0,
    yearIndex: 2,
};
// ISO 8601: yyyy-mm-dd
const DATE_FORMAT_ISO_8601 = {
    delimiter: '-',
    dayIndex: 2,
    monthIndex: 1,
    yearIndex: 0,
};
// hu: 2000.12.30
const DATE_FORMAT_HU = {
    delimiter: '.',
    dayIndex: 2,
    monthIndex: 1,
    yearIndex: 0,
};
// nl: 30-12-2000
const DATE_FORMAT_NL = {
    delimiter: '-',
    dayIndex: 0,
    monthIndex: 1,
    yearIndex: 2,
};
// se: 2000-12-30
const DATE_FORMAT_SE = {
    delimiter: '-',
    dayIndex: 2,
    monthIndex: 1,
    yearIndex: 0,
};

class DateFormatter extends NgbDateParserFormatter {
    constructor(locale) {
        super();
        switch (locale?.toString()) {
            case 'de':
            case 'de_DE':
            case 'de_AT':
            case 'de_CH':
            case 'fr_CH':
            case 'it_CH':
            case 'pl_PL':
            case 'cs_CZ':
            case 'no_NO':
            case 'fi_FI':
            case 'ro_RO':
            case 'ru_RU':
            case 'tr-TR':
                this.dateFormat = DATE_FORMAT_DE;
                break;
            case 'en':
            case 'en_GB':
            case 'fr_FR':
            case 'it_IT':
            case 'es_ES':
            case 'nl_BE':
            case 'fr_BE':
            case 'pt_PT':
            case 'el_GR':
                this.dateFormat = DATE_FORMAT_EN_GB;
                break;
            case 'hu_HU':
                this.dateFormat = DATE_FORMAT_HU;
                break;
            case 'nl_NL':
                this.dateFormat = DATE_FORMAT_NL;
                break;
            case 'sv_SE':
                this.dateFormat = DATE_FORMAT_SE;
                break;
            default:
                this.dateFormat = DATE_FORMAT_EN_US;
        }
    }
    parse(value) {
        if (!value) {
            return null;
        }
        const date = value.split(this.dateFormat.delimiter);
        return {
            day: parseInt(date[this.dateFormat.dayIndex], 10),
            month: parseInt(date[this.dateFormat.monthIndex], 10),
            year: parseInt(date[this.dateFormat.yearIndex], 10),
        };
    }
    format(date) {
        if (!date) {
            return '';
        }
        const parts = [];
        parts[this.dateFormat.dayIndex] = `${date.day}`.padStart(2, '0');
        parts[this.dateFormat.monthIndex] = `${date.month}`.padStart(2, '0');
        parts[this.dateFormat.yearIndex] = date.year;
        return parts.join(this.dateFormat.delimiter);
    }
    /**
     * @Deprecated  nur für die webcomponent gedacht
     * */
    forceFormat(format) {
        this.dateFormat = format;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DateFormatter, deps: [{ token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DateFormatter }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DateFormatter, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: String, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }] });

// MIN/MAX: aus DateUtil in webapps
const MIN_DATE = { day: 1, month: 1, year: 1970 };
const MAX_DATE = { day: 1, month: 1, year: 2099 };
// default -5:+100 Jahre aus jquery.datepicker in webapps
const DEFAULT_MIN_DATE = { day: 1, month: 1, year: new Date().getFullYear() - 5 };
const DEFAULT_MAX_DATE = MAX_DATE; // +100 Jahre liegt außerhalb des MAX_DATE
class DatePickerComponent {
    set value(value) {
        this._value = value ? this.dateToNgbDateStruct(value) : undefined;
    }
    set min(min) {
        let newMin = min ? this.dateToNgbDateStruct(min) : MIN_DATE;
        if (this.getNgbDateStamp(newMin) < this.getNgbDateStamp(MIN_DATE)) {
            newMin = MIN_DATE;
        }
        if (this.getNgbDateStamp(newMin) !== this.getNgbDateStamp(this._minDate)) {
            this._minDate = min ? this.dateToNgbDateStruct(min) : MIN_DATE;
            this._onValidatorChangeFn();
        }
    }
    set max(max) {
        let newMax = max ? this.dateToNgbDateStruct(max) : MAX_DATE;
        if (this.getNgbDateStamp(newMax) > this.getNgbDateStamp(MAX_DATE)) {
            newMax = MAX_DATE;
        }
        if (this.getNgbDateStamp(newMax) !== this.getNgbDateStamp(this._maxDate)) {
            this._maxDate = newMax;
            this._onValidatorChangeFn();
        }
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty(disabled);
    }
    set dateDisabledFn(dateDisabledFn) {
        this._dateDisabledFn = ((ngbDate) => {
            const date = this.ngbDateStructToDate(ngbDate);
            return dateDisabledFn(date);
        });
    }
    set customDayDataFn(customDayDataFn) {
        this._customDayDataFn = ((ngbDate, current) => {
            const date = this.ngbDateStructToDate(ngbDate);
            return customDayDataFn(date, current);
        });
    }
    constructor() {
        this._componentClass = true;
        this._minDate = DEFAULT_MIN_DATE;
        this._maxDate = DEFAULT_MAX_DATE;
        this._disabled = false;
        this._dateDisabledFn = () => false;
        this._customDayDataFn = () => {
        };
        /**
         * @Deprecated nur für die webcomponent gedacht
         * */
        this.name = '';
        this.translated = false;
        this.elementRef = inject(ElementRef);
        this.i18n = inject(NgbDatepickerI18n);
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
        this._onValidatorChangeFn = () => {
        };
        this.msgService = inject(MessageService);
    }
    ngAfterViewInit() {
        if (!this.datepicker) {
            return;
        }
        const previousToggle = this.datepicker.toggle;
        this.datepicker.toggle = () => {
            previousToggle.bind(this.datepicker)();
            if (!this.translated && this.datepicker?.isOpen()) {
                this.translateMessages();
            }
        };
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    registerOnValidatorChange(fn) {
        this._onValidatorChangeFn = fn;
    }
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
    }
    onChange(date) {
        this._value = date;
        this._onTouchedFn();
        this._onChangeFn(this._value ? this.ngbDateStructToDate(this._value) : undefined);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.inputElement?.nativeElement.dispatchEvent(new Event('change'));
        }, 1000);
    }
    selectToday() {
        this.onChange(this.dateToNgbDateStruct(new Date()));
    }
    isTodayInInputRange() {
        return this.validateValue(new Date()) === null;
    }
    validate(control) {
        return this.validateValue(control.value);
    }
    validateValue(date) {
        if (!date) {
            return null;
        }
        if (isNaN(date.getTime())) {
            return {
                format: {
                    actual: date,
                },
            };
        }
        const ngbDate = this.dateToNgbDateStruct(date);
        if (this.getNgbDateStamp(ngbDate) < this.getNgbDateStamp(this._minDate)) {
            return {
                min: {
                    min: this._minDate,
                    actual: ngbDate,
                },
            };
        }
        if (this.getNgbDateStamp(ngbDate) > this.getNgbDateStamp(this._maxDate)) {
            return {
                max: {
                    max: this._maxDate,
                    actual: ngbDate,
                },
            };
        }
        if (this._dateDisabledFn(NgbDate.from(ngbDate))) {
            return {
                dateDisabledFn: {
                    actual: ngbDate,
                },
            };
        }
        return null;
    }
    getNgbDateStamp(date) {
        return date.day + 31 * date.month + 31 * 12 * date.year;
    }
    ngbDateStructToDate(date) {
        return new Date(date.year, date.month - 1, date.day);
    }
    dateToNgbDateStruct(obj) {
        return {
            day: obj.getDate(),
            month: obj.getMonth() + 1,
            year: obj.getFullYear(),
        };
    }
    translateMessages() {
        const nativeEl = this.elementRef.nativeElement;
        const msgKeyBase = 'bui.date-picker.';
        const titles = {
            'Previous month': 'month.prev',
            'Next month': 'month.next',
            'Select month': 'select.month',
            'Select year': 'select.year',
        };
        for (const [title, key] of Object.entries(titles)) {
            this.msgService.resolve(`${msgKeyBase}${key}`)
                .pipe(take(1))
                .subscribe(msg => nativeEl.querySelector(`[title="${title}"]`).setAttribute('title', msg));
        }
    }
    isMuted(selected, date, currentMonth, disabled) {
        return !selected && (date.month !== currentMonth || disabled);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DatePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: DatePickerComponent, isStandalone: true, selector: "bui-date-picker", inputs: { value: "value", min: "min", max: "max", disabled: "disabled", dateDisabledFn: "dateDisabledFn", customDayTemplate: "customDayTemplate", customDayDataFn: "customDayDataFn", name: "name" }, host: { properties: { "class.bui-datepicker": "this._componentClass" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: DatePickerComponent,
                multi: true,
            },
            {
                provide: NgbDateParserFormatter,
                useClass: DateFormatter,
            },
            {
                provide: NG_VALIDATORS,
                useExisting: DatePickerComponent,
                multi: true,
            },
        ], viewQueries: [{ propertyName: "datepicker", first: true, predicate: ["d"], descendants: true }, { propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true }], ngImport: i0, template: "<input buiValidationControl\r\n       class=\"bui-datepicker__input\"\r\n       autocomplete=\"off\"\r\n       [attr.name]=\"name\"\r\n       ngbDatepicker\r\n       [footerTemplate]=\"footer\"\r\n       outsideDays=\"collapsed\"\r\n       [disabled]=\"_disabled\"\r\n       [markDisabled]=\"_dateDisabledFn\"\r\n       [maxDate]=\"_maxDate\"\r\n       [minDate]=\"_minDate\"\r\n       [dayTemplate]=\"customDayTemplate!\"\r\n       [dayTemplateData]=\"_customDayDataFn\"\r\n       [ngModel]=\"_value\"\r\n       (ngModelChange)=\"onChange($event)\"\r\n       #inputElement\r\n       #d=\"ngbDatepicker\"/>\r\n<button type=\"button\"\r\n        class=\"bui-datepicker__toggle\"\r\n        [disabled]=\"_disabled\"\r\n        (click)=\"datepicker?.toggle()\"></button>\r\n\r\n<ng-template #footer>\r\n\t<div class=\"bui-datepicker__footer\">\r\n\t\t<button type=\"button\"\r\n\t\t        bui-button\r\n\t\t        [disabled]=\"!isTodayInInputRange()\"\r\n\t\t        class=\"today\"\r\n\t\t        (click)=\"selectToday();datepicker?.toggle()\">\r\n\t\t\t{{ 'bui.date-picker.today' | msgKey | async }}\r\n\t\t</button>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #earlyDay\r\n             let-date\r\n             let-currentMonth=\"currentMonth\"\r\n             let-selected=\"selected\"\r\n             let-disabled=\"disabled\"\r\n             let-focused=\"focused\"\r\n             let-data=\"data\">\r\n\t<div ngbDatepickerDayView\r\n\t     [class.text-muted]=\"isMuted(selected, date, currentMonth, disabled)\"\r\n\t     [class.outside]=\"isMuted(selected, date, currentMonth, disabled)\"\r\n\t     [class.bg-primary]=\"selected\"\r\n\t     [class.text-white]=\"selected\"\r\n\t     [class.active]=\"focused\"\r\n\t     [class.earlyDay]=\"data.earlyDay\"\r\n\t     [title]=\"data.title\">\r\n\t\t{{ i18n.getDayNumerals(date) }}\r\n\t</div>\r\n</ng-template>\r\n", dependencies: [{ kind: "ngmodule", type: NgbDatepickerModule }, { kind: "directive", type: i1$1.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "contentTemplate", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "popperOptions", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: AsyncPipe, name: "async" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-date-picker', encapsulation: ViewEncapsulation.None, imports: [
                        NgbDatepickerModule,
                        FormsModule,
                        ButtonComponent,
                        ValidationControlDirective,
                        MsgKeyPipe,
                        AsyncPipe,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: DatePickerComponent,
                            multi: true,
                        },
                        {
                            provide: NgbDateParserFormatter,
                            useClass: DateFormatter,
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: DatePickerComponent,
                            multi: true,
                        },
                    ], template: "<input buiValidationControl\r\n       class=\"bui-datepicker__input\"\r\n       autocomplete=\"off\"\r\n       [attr.name]=\"name\"\r\n       ngbDatepicker\r\n       [footerTemplate]=\"footer\"\r\n       outsideDays=\"collapsed\"\r\n       [disabled]=\"_disabled\"\r\n       [markDisabled]=\"_dateDisabledFn\"\r\n       [maxDate]=\"_maxDate\"\r\n       [minDate]=\"_minDate\"\r\n       [dayTemplate]=\"customDayTemplate!\"\r\n       [dayTemplateData]=\"_customDayDataFn\"\r\n       [ngModel]=\"_value\"\r\n       (ngModelChange)=\"onChange($event)\"\r\n       #inputElement\r\n       #d=\"ngbDatepicker\"/>\r\n<button type=\"button\"\r\n        class=\"bui-datepicker__toggle\"\r\n        [disabled]=\"_disabled\"\r\n        (click)=\"datepicker?.toggle()\"></button>\r\n\r\n<ng-template #footer>\r\n\t<div class=\"bui-datepicker__footer\">\r\n\t\t<button type=\"button\"\r\n\t\t        bui-button\r\n\t\t        [disabled]=\"!isTodayInInputRange()\"\r\n\t\t        class=\"today\"\r\n\t\t        (click)=\"selectToday();datepicker?.toggle()\">\r\n\t\t\t{{ 'bui.date-picker.today' | msgKey | async }}\r\n\t\t</button>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #earlyDay\r\n             let-date\r\n             let-currentMonth=\"currentMonth\"\r\n             let-selected=\"selected\"\r\n             let-disabled=\"disabled\"\r\n             let-focused=\"focused\"\r\n             let-data=\"data\">\r\n\t<div ngbDatepickerDayView\r\n\t     [class.text-muted]=\"isMuted(selected, date, currentMonth, disabled)\"\r\n\t     [class.outside]=\"isMuted(selected, date, currentMonth, disabled)\"\r\n\t     [class.bg-primary]=\"selected\"\r\n\t     [class.text-white]=\"selected\"\r\n\t     [class.active]=\"focused\"\r\n\t     [class.earlyDay]=\"data.earlyDay\"\r\n\t     [title]=\"data.title\">\r\n\t\t{{ i18n.getDayNumerals(date) }}\r\n\t</div>\r\n</ng-template>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { _componentClass: [{
                type: HostBinding,
                args: ['class.bui-datepicker']
            }], value: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], disabled: [{
                type: Input
            }], dateDisabledFn: [{
                type: Input
            }], customDayTemplate: [{
                type: Input
            }], customDayDataFn: [{
                type: Input
            }], datepicker: [{
                type: ViewChild,
                args: ['d']
            }], inputElement: [{
                type: ViewChild,
                args: ['inputElement']
            }], name: [{
                type: Input
            }] } });

class DatePickerWebcomponent extends DatePickerComponent {
    constructor() {
        super(...arguments);
        this.dateFormatter = inject(NgbDateParserFormatter);
        this.hasEarlyDays = false;
        this.earlyDay = viewChild.required('earlyDay', { read: TemplateRef });
    }
    set value(value) {
        if (typeof value === 'string' && value != '') {
            value = this.stringToDate(value);
        }
        this._value = value ? super.dateToNgbDateStruct(value) : undefined;
    }
    set dateformat(dateformat) {
        if (dateformat === 'ISO8601') {
            this.dateFormatter.forceFormat(DATE_FORMAT_ISO_8601);
        }
    }
    set config(configString) {
        if (configString) {
            const config = JSON.parse(configString);
            let min;
            if (config.minDate) {
                min = this.stringToDate(config.minDate);
            }
            if (config.pastDaysSeelctable === false) {
                const today = new Date();
                if (!min || min < today) {
                    min = today;
                }
            }
            this.min = min;
            if (config.maxDate) {
                const unit = config.maxDate.slice(-1);
                const value = Number(config.maxDate.slice(1, -1));
                const maxDate = new Date();
                switch (unit) {
                    case 'd':
                        maxDate.setDate(maxDate.getDate() + value);
                        break;
                    case 'm':
                        maxDate.setMonth(maxDate.getMonth() + value);
                }
                this.max = maxDate;
            }
            let dateDisabledWeekdaysFn;
            let dateDisabledHolidaysFn;
            if (config.selectableWeekDays) {
                const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                dateDisabledWeekdaysFn = (date) => {
                    return !config.selectableWeekDays.includes(weekdays[date.getDay()]);
                };
            }
            if (config.holidays) {
                dateDisabledHolidaysFn = (date) => {
                    return config.holidays.includes(date.getTime());
                };
            }
            if (config.selectableWeekDays || config.holidays) {
                this.dateDisabledFn = (date) => dateDisabledWeekdaysFn?.(date) || dateDisabledHolidaysFn?.(date);
            }
            if (config.earlyDays) {
                this.hasEarlyDays = true;
                this.customDayDataFn = (date) => {
                    if (config.earlyDays.days.includes(date.getTime())) {
                        return { earlyDay: true, title: config.earlyDays.title };
                    }
                    return { earlyDay: false, title: '' };
                };
                if (this.earlyDay()) {
                    this.customDayTemplate = this.earlyDay();
                }
            }
        }
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        if (this.hasEarlyDays) {
            this.customDayTemplate = this.earlyDay();
        }
    }
    stringToDate(dateAsString) {
        let day, month, year;
        if (dateAsString.includes('.')) { // dd.mm.yyyy
            [day, month, year] = dateAsString.split('.');
        }
        else if (dateAsString.includes('/')) { // dd/mm/yyyy
            [day, month, year] = dateAsString.split('/');
        }
        else if (dateAsString.includes('-')) { // yyyy-mm-dd
            [year, month, day] = dateAsString.split('-');
        }
        else {
            this.validateValue(new Date(dateAsString));
            return undefined;
        }
        return new Date(Number(year), Number(month) - 1, Number(day));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DatePickerWebcomponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: DatePickerWebcomponent, isStandalone: true, selector: "ng-component", inputs: { value: "value", dateformat: "dateformat", config: "config" }, providers: [
            {
                provide: NgbDateParserFormatter,
                useClass: DateFormatter,
            },
        ], viewQueries: [{ propertyName: "earlyDay", first: true, predicate: ["earlyDay"], descendants: true, read: TemplateRef, isSignal: true }], usesInheritance: true, ngImport: i0, template: "<input buiValidationControl\r\n       class=\"bui-datepicker__input\"\r\n       autocomplete=\"off\"\r\n       [attr.name]=\"name\"\r\n       ngbDatepicker\r\n       [footerTemplate]=\"footer\"\r\n       outsideDays=\"collapsed\"\r\n       [disabled]=\"_disabled\"\r\n       [markDisabled]=\"_dateDisabledFn\"\r\n       [maxDate]=\"_maxDate\"\r\n       [minDate]=\"_minDate\"\r\n       [dayTemplate]=\"customDayTemplate!\"\r\n       [dayTemplateData]=\"_customDayDataFn\"\r\n       [ngModel]=\"_value\"\r\n       (ngModelChange)=\"onChange($event)\"\r\n       #inputElement\r\n       #d=\"ngbDatepicker\"/>\r\n<button type=\"button\"\r\n        class=\"bui-datepicker__toggle\"\r\n        [disabled]=\"_disabled\"\r\n        (click)=\"datepicker?.toggle()\"></button>\r\n\r\n<ng-template #footer>\r\n\t<div class=\"bui-datepicker__footer\">\r\n\t\t<button type=\"button\"\r\n\t\t        bui-button\r\n\t\t        [disabled]=\"!isTodayInInputRange()\"\r\n\t\t        class=\"today\"\r\n\t\t        (click)=\"selectToday();datepicker?.toggle()\">\r\n\t\t\t{{ 'bui.date-picker.today' | msgKey | async }}\r\n\t\t</button>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #earlyDay\r\n             let-date\r\n             let-currentMonth=\"currentMonth\"\r\n             let-selected=\"selected\"\r\n             let-disabled=\"disabled\"\r\n             let-focused=\"focused\"\r\n             let-data=\"data\">\r\n\t<div ngbDatepickerDayView\r\n\t     [class.text-muted]=\"isMuted(selected, date, currentMonth, disabled)\"\r\n\t     [class.outside]=\"isMuted(selected, date, currentMonth, disabled)\"\r\n\t     [class.bg-primary]=\"selected\"\r\n\t     [class.text-white]=\"selected\"\r\n\t     [class.active]=\"focused\"\r\n\t     [class.earlyDay]=\"data.earlyDay\"\r\n\t     [title]=\"data.title\">\r\n\t\t{{ i18n.getDayNumerals(date) }}\r\n\t</div>\r\n</ng-template>\r\n", styles: ["[ngbDatepickerDayView]{text-align:center;width:2rem;height:2rem;line-height:2rem;border-radius:.25rem;background:transparent}[ngbDatepickerDayView]:hover:not(.bg-primary),[ngbDatepickerDayView].active:not(.bg-primary){background-color:var(--bs-tertiary-bg);outline:1px solid var(--bs-border-color)}[ngbDatepickerDayView].outside{opacity:.5}[ngbDatepickerDayView].earlyDay{color:var(--color--feedback--error)}[ngbDatepickerDayView].earlyDay.bg-primary{color:var(--color--base--white);background-color:var(--color--feedback--error)}\n"], dependencies: [{ kind: "ngmodule", type: NgbDatepickerModule }, { kind: "directive", type: i1$1.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "contentTemplate", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "popperOptions", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: AsyncPipe, name: "async" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DatePickerWebcomponent, decorators: [{
            type: Component,
            args: [{ encapsulation: ViewEncapsulation.None, imports: [
                        NgbDatepickerModule,
                        FormsModule,
                        ButtonComponent,
                        ValidationControlDirective,
                        MsgKeyPipe,
                        AsyncPipe,
                    ], providers: [
                        {
                            provide: NgbDateParserFormatter,
                            useClass: DateFormatter,
                        },
                    ], template: "<input buiValidationControl\r\n       class=\"bui-datepicker__input\"\r\n       autocomplete=\"off\"\r\n       [attr.name]=\"name\"\r\n       ngbDatepicker\r\n       [footerTemplate]=\"footer\"\r\n       outsideDays=\"collapsed\"\r\n       [disabled]=\"_disabled\"\r\n       [markDisabled]=\"_dateDisabledFn\"\r\n       [maxDate]=\"_maxDate\"\r\n       [minDate]=\"_minDate\"\r\n       [dayTemplate]=\"customDayTemplate!\"\r\n       [dayTemplateData]=\"_customDayDataFn\"\r\n       [ngModel]=\"_value\"\r\n       (ngModelChange)=\"onChange($event)\"\r\n       #inputElement\r\n       #d=\"ngbDatepicker\"/>\r\n<button type=\"button\"\r\n        class=\"bui-datepicker__toggle\"\r\n        [disabled]=\"_disabled\"\r\n        (click)=\"datepicker?.toggle()\"></button>\r\n\r\n<ng-template #footer>\r\n\t<div class=\"bui-datepicker__footer\">\r\n\t\t<button type=\"button\"\r\n\t\t        bui-button\r\n\t\t        [disabled]=\"!isTodayInInputRange()\"\r\n\t\t        class=\"today\"\r\n\t\t        (click)=\"selectToday();datepicker?.toggle()\">\r\n\t\t\t{{ 'bui.date-picker.today' | msgKey | async }}\r\n\t\t</button>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #earlyDay\r\n             let-date\r\n             let-currentMonth=\"currentMonth\"\r\n             let-selected=\"selected\"\r\n             let-disabled=\"disabled\"\r\n             let-focused=\"focused\"\r\n             let-data=\"data\">\r\n\t<div ngbDatepickerDayView\r\n\t     [class.text-muted]=\"isMuted(selected, date, currentMonth, disabled)\"\r\n\t     [class.outside]=\"isMuted(selected, date, currentMonth, disabled)\"\r\n\t     [class.bg-primary]=\"selected\"\r\n\t     [class.text-white]=\"selected\"\r\n\t     [class.active]=\"focused\"\r\n\t     [class.earlyDay]=\"data.earlyDay\"\r\n\t     [title]=\"data.title\">\r\n\t\t{{ i18n.getDayNumerals(date) }}\r\n\t</div>\r\n</ng-template>\r\n", styles: ["[ngbDatepickerDayView]{text-align:center;width:2rem;height:2rem;line-height:2rem;border-radius:.25rem;background:transparent}[ngbDatepickerDayView]:hover:not(.bg-primary),[ngbDatepickerDayView].active:not(.bg-primary){background-color:var(--bs-tertiary-bg);outline:1px solid var(--bs-border-color)}[ngbDatepickerDayView].outside{opacity:.5}[ngbDatepickerDayView].earlyDay{color:var(--color--feedback--error)}[ngbDatepickerDayView].earlyDay.bg-primary{color:var(--color--base--white);background-color:var(--color--feedback--error)}\n"] }]
        }], propDecorators: { value: [{
                type: Input
            }], dateformat: [{
                type: Input
            }], config: [{
                type: Input
            }] } });

class OptionDirective {
    constructor() {
        this.value = input.required();
        this.label = input('');
        this.disabled = input(false, { transform: coerceBooleanProperty });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: OptionDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "19.1.1", type: OptionDirective, isStandalone: true, selector: "bui-option", inputs: { value: { classPropertyName: "value", publicName: "value", isSignal: true, isRequired: true, transformFunction: null }, label: { classPropertyName: "label", publicName: "label", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: OptionDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'bui-option' }]
        }] });
class SelectComponent {
    constructor() {
        this._value = {};
        this.items = input([]);
        this.valueKey = input('value');
        this.labelKey = input('label');
        this.placeholder = input();
        this.clearable = input(false, { transform: coerceBooleanProperty });
        this.searchable = input(true, { transform: coerceBooleanProperty });
        this.multiple = input(false, { transform: coerceBooleanProperty });
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.groupBy = input('');
        this.disabled = linkedSignal(() => this.disabledInput());
        this.filterInput = viewChild.required('filterInput');
        this.itemsComponent = viewChild.required('itemsComponent');
        this.options = contentChildren(OptionDirective);
        this.optionsAsItems = computed(() => {
            const options = this.options();
            if (options.length === 0) {
                return this.items();
            }
            const items = [];
            options.forEach(option => {
                items.push({
                    label: option.label(),
                    value: option.value(),
                    disabled: option.disabled(),
                });
            });
            return items;
        });
        this.ngZone = inject(NgZone);
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
        this.onScroll = () => {
            if (this.itemsComponent().isOpen) {
                this.ngZone.run(() => {
                    this.itemsComponent()
                        .dropdownPanel
                        .adjustPosition();
                });
            }
        };
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            window.addEventListener('scroll', this.onScroll, normalizePassiveListenerOptions({
                capture: true,
                passive: true,
            }));
        });
    }
    ngOnDestroy() {
        this.ngZone.runOutsideAngular(() => {
            window.removeEventListener('scroll', this.onScroll, true);
        });
    }
    onValueChange(value) {
        this._value = value;
        this._onChangeFn(value);
    }
    focusFilter() {
        this.searchable() && setTimeout(() => {
            this.filterInput()
                .nativeElement
                .focus();
        });
    }
    keydown(event) {
        this.itemsComponent()
            .handleKeyDown(event);
    }
    filter(event) {
        this.itemsComponent()
            .filter(event.target.value);
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    writeValue(value) {
        this._value = value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SelectComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: SelectComponent, isStandalone: true, selector: "bui-select", inputs: { items: { classPropertyName: "items", publicName: "items", isSignal: true, isRequired: false, transformFunction: null }, valueKey: { classPropertyName: "valueKey", publicName: "valueKey", isSignal: true, isRequired: false, transformFunction: null }, labelKey: { classPropertyName: "labelKey", publicName: "labelKey", isSignal: true, isRequired: false, transformFunction: null }, placeholder: { classPropertyName: "placeholder", publicName: "placeholder", isSignal: true, isRequired: false, transformFunction: null }, clearable: { classPropertyName: "clearable", publicName: "clearable", isSignal: true, isRequired: false, transformFunction: null }, searchable: { classPropertyName: "searchable", publicName: "searchable", isSignal: true, isRequired: false, transformFunction: null }, multiple: { classPropertyName: "multiple", publicName: "multiple", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, groupBy: { classPropertyName: "groupBy", publicName: "groupBy", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-select": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: SelectComponent,
                multi: true,
            },
        ], queries: [{ propertyName: "options", predicate: OptionDirective, isSignal: true }], viewQueries: [{ propertyName: "filterInput", first: true, predicate: ["filterInput"], descendants: true, isSignal: true }, { propertyName: "itemsComponent", first: true, predicate: ["itemsComponent"], descendants: true, isSignal: true }], ngImport: i0, template: "<div class=\"bui-select__max\">\r\n\t<div>{{ placeholder() ?? ('bui.select.placeholder' | msgKey | async) }}</div>\r\n\t<div *ngFor=\"let item of optionsAsItems()\">\r\n\t\t{{ item[labelKey()] }}\r\n\t</div>\r\n</div>\r\n<ng-select #itemsComponent\r\n           buiValidationControl\r\n           [items]=\"optionsAsItems()\"\r\n           [ngModel]=\"_value\"\r\n           (ngModelChange)=\"onValueChange($event)\"\r\n           [disabled]=\"disabled()\"\r\n           [multiple]=\"multiple()\"\r\n           [clearable]=\"clearable()\"\r\n           [clearAllText]=\"('bui.select.clearAll' | msgKey | async)!\"\r\n           [searchable]=\"false\"\r\n           (open)=\"focusFilter()\"\r\n           [bindLabel]=\"labelKey()\"\r\n           [bindValue]=\"valueKey()\"\r\n           [placeholder]=\"placeholder() ?? ('bui.select.placeholder' | msgKey | async)!\"\r\n           [groupBy]=\"groupBy()\"\r\n           [notFoundText]=\"('bui.select.notFound' | msgKey | async)!\"\r\n           (close)=\"itemsComponent.focus()\"\r\n           appendTo=\"body\">\r\n\t<ng-template ng-header-tmp\r\n\t             *ngIf=\"searchable()\">\r\n\t\t<ng-container *ngTemplateOutlet=\"filterTemplate\"></ng-container>\r\n\t</ng-template>\r\n\t<ng-template ng-option-tmp\r\n\t             let-item=\"item\">\r\n\t\t<span class=\"ng-option-label\"\r\n\t\t      [ngItemLabel]=\"item[labelKey()]\"\r\n\t\t      [title]=\"item[labelKey()]\"></span>\r\n\t</ng-template>\r\n</ng-select>\r\n<div class=\"bui-select__options\">\r\n\t<ng-content></ng-content>\r\n</div>\r\n\r\n<ng-template #filterTemplate>\r\n\t<input #filterInput\r\n\t       type=\"text\"\r\n\t       class=\"ng-select--filter-input\"\r\n\t       (keydown)=\"keydown($event)\"\r\n\t       (input)=\"filter($event)\">\r\n</ng-template>", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "ngmodule", type: NgSelectModule }, { kind: "component", type: i2.NgSelectComponent, selector: "ng-select", inputs: ["ariaLabelDropdown", "bindLabel", "bindValue", "ariaLabel", "markFirst", "placeholder", "fixedPlaceholder", "notFoundText", "typeToSearchText", "preventToggleOnRightClick", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "ngClass", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick", "keyDownFn"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i2.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "directive", type: i2.NgHeaderTemplateDirective, selector: "[ng-header-tmp]" }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "directive", type: NgItemLabelDirective, selector: "[ngItemLabel]", inputs: ["ngItemLabel", "escape"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-select', encapsulation: ViewEncapsulation.None, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: SelectComponent,
                            multi: true,
                        },
                    ], imports: [
                        CommonModule,
                        NgSelectModule,
                        FormsModule,
                        ValidationControlDirective,
                        MsgKeyPipe,
                        NgItemLabelDirective,
                    ], host: {
                        '[class.bui-select]': 'true',
                    }, template: "<div class=\"bui-select__max\">\r\n\t<div>{{ placeholder() ?? ('bui.select.placeholder' | msgKey | async) }}</div>\r\n\t<div *ngFor=\"let item of optionsAsItems()\">\r\n\t\t{{ item[labelKey()] }}\r\n\t</div>\r\n</div>\r\n<ng-select #itemsComponent\r\n           buiValidationControl\r\n           [items]=\"optionsAsItems()\"\r\n           [ngModel]=\"_value\"\r\n           (ngModelChange)=\"onValueChange($event)\"\r\n           [disabled]=\"disabled()\"\r\n           [multiple]=\"multiple()\"\r\n           [clearable]=\"clearable()\"\r\n           [clearAllText]=\"('bui.select.clearAll' | msgKey | async)!\"\r\n           [searchable]=\"false\"\r\n           (open)=\"focusFilter()\"\r\n           [bindLabel]=\"labelKey()\"\r\n           [bindValue]=\"valueKey()\"\r\n           [placeholder]=\"placeholder() ?? ('bui.select.placeholder' | msgKey | async)!\"\r\n           [groupBy]=\"groupBy()\"\r\n           [notFoundText]=\"('bui.select.notFound' | msgKey | async)!\"\r\n           (close)=\"itemsComponent.focus()\"\r\n           appendTo=\"body\">\r\n\t<ng-template ng-header-tmp\r\n\t             *ngIf=\"searchable()\">\r\n\t\t<ng-container *ngTemplateOutlet=\"filterTemplate\"></ng-container>\r\n\t</ng-template>\r\n\t<ng-template ng-option-tmp\r\n\t             let-item=\"item\">\r\n\t\t<span class=\"ng-option-label\"\r\n\t\t      [ngItemLabel]=\"item[labelKey()]\"\r\n\t\t      [title]=\"item[labelKey()]\"></span>\r\n\t</ng-template>\r\n</ng-select>\r\n<div class=\"bui-select__options\">\r\n\t<ng-content></ng-content>\r\n</div>\r\n\r\n<ng-template #filterTemplate>\r\n\t<input #filterInput\r\n\t       type=\"text\"\r\n\t       class=\"ng-select--filter-input\"\r\n\t       (keydown)=\"keydown($event)\"\r\n\t       (input)=\"filter($event)\">\r\n</ng-template>" }]
        }], ctorParameters: () => [] });

class SelectWebcomponent {
    constructor() {
        this.name = input();
        this.multiple = input(false, { transform: coerceBooleanProperty });
        this.disabled = input(false, { transform: coerceBooleanProperty });
        this.dataPlaceholder = input();
        this.filterclass = input();
        this.valueChange = output();
        this.originalItems = signal([]);
        this.items = computed(() => {
            if (!this.filterclass()) {
                return this.originalItems();
            }
            return this.originalItems()
                .filter(option => !option.class?.split(' ')
                .includes(this.filterclass()));
        });
        this.value = signal(null);
        this.hasValue = computed(() => this.value() !== null && this.value() !== undefined);
        this.elementRef = inject((ElementRef));
    }
    ngAfterContentInit() {
        this.parseOptions();
        this.elementRef.nativeElement.parseOptions = this.parseOptions.bind(this);
    }
    parseOptions() {
        const options = this.elementRef.nativeElement.querySelectorAll('option');
        if (options.length > 0) {
            const selected = new Set();
            const items = [];
            options.forEach(option => {
                const opt = option;
                const optGroup = opt.parentElement instanceof HTMLOptGroupElement
                    ? opt.parentElement
                    : undefined;
                items.push({
                    label: opt.textContent ?? '',
                    value: opt.value,
                    disabled: (opt.disabled || optGroup?.disabled) ?? false,
                    optGroup: optGroup?.label,
                    class: opt.className,
                });
                if (opt.selected) {
                    selected.add(opt.value);
                }
            });
            this.originalItems.set(items);
            const selectedArray = Array.from(selected);
            this.value.set(this.multiple() ? selectedArray : selectedArray[0]);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SelectWebcomponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: SelectWebcomponent, isStandalone: true, selector: "ng-component", inputs: { name: { classPropertyName: "name", publicName: "name", isSignal: true, isRequired: false, transformFunction: null }, multiple: { classPropertyName: "multiple", publicName: "multiple", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, dataPlaceholder: { classPropertyName: "dataPlaceholder", publicName: "dataPlaceholder", isSignal: true, isRequired: false, transformFunction: null }, filterclass: { classPropertyName: "filterclass", publicName: "filterclass", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { valueChange: "valueChange" }, ngImport: i0, template: `
		<bui-select [items]="items()"
		            [(ngModel)]="value"
		            (ngModelChange)="valueChange.emit($event)"
		            [multiple]="multiple()"
		            [disabled]="disabled()"
		            [placeholder]="dataPlaceholder()"
		            [searchable]="items().length > 7"
		            groupBy="optGroup"></bui-select>
		@if (multiple()) {
			@for (val of value(); track val) {
				<input type="hidden"
				       [name]="name()"
				       [value]="val"
				       [disabled]="disabled()"/>
			}
		} @else if (hasValue()) {
			<input type="hidden"
			       [name]="name()"
			       [value]="value()"
			       [disabled]="disabled()"/>
		}
		<div class="bui-select__options">
			<ng-content></ng-content>
		</div>
	`, isInline: true, styles: [":host{display:inline-block;max-width:100%}:host .bui-select{width:100%}:host .bui-select ::ng-deep .ng-placeholder{right:3px;left:3px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}:host .bui-select__options{display:none}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: NgSelectModule }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SelectComponent, selector: "bui-select", inputs: ["items", "valueKey", "labelKey", "placeholder", "clearable", "searchable", "multiple", "disabled", "groupBy"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SelectWebcomponent, decorators: [{
            type: Component,
            args: [{ template: `
		<bui-select [items]="items()"
		            [(ngModel)]="value"
		            (ngModelChange)="valueChange.emit($event)"
		            [multiple]="multiple()"
		            [disabled]="disabled()"
		            [placeholder]="dataPlaceholder()"
		            [searchable]="items().length > 7"
		            groupBy="optGroup"></bui-select>
		@if (multiple()) {
			@for (val of value(); track val) {
				<input type="hidden"
				       [name]="name()"
				       [value]="val"
				       [disabled]="disabled()"/>
			}
		} @else if (hasValue()) {
			<input type="hidden"
			       [name]="name()"
			       [value]="value()"
			       [disabled]="disabled()"/>
		}
		<div class="bui-select__options">
			<ng-content></ng-content>
		</div>
	`, encapsulation: ViewEncapsulation.Emulated, imports: [
                        CommonModule,
                        NgSelectModule,
                        FormsModule,
                        SelectComponent,
                    ], styles: [":host{display:inline-block;max-width:100%}:host .bui-select{width:100%}:host .bui-select ::ng-deep .ng-placeholder{right:3px;left:3px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}:host .bui-select__options{display:none}\n"] }]
        }], ctorParameters: () => [] });

function styleAttributeToObject(style) {
    if (!style) {
        return {};
    }
    return Object.fromEntries(style.split(';')
        .map(rule => rule.split(':')
        .map(part => part.trim())));
}
function objectToStyleAttribute(styles) {
    if (!styles) {
        return null;
    }
    return Object.entries(styles)
        .map(rule => rule.join(':'))
        .join(';') || null;
}
/**
 * Get the attributes of all currently selected marks and nodes of the given
 * type or name.
 *
 * Returns an array of Records, with an entry for each matching mark/node that
 * is currently selected.
 *
 * NOTE: This function will omit any non-matching nodes/marks in the result
 * array. It may be useful to run `editor.isActive(typeOrName)` separately if
 * you want to guarantee that all selected content is of the given type/name.
 *
 * Based directly on Tiptap's getAttributes
 * (https://github.com/ueberdosis/tiptap/blob/f387ad3dd4c2b30eaea33fb0ba0b42e0cd39263b/packages/core/src/helpers/getAttributes.ts),
 * but returns results for each of the matching marks and nodes, rather than
 * just the first. This enables us to handle situations where there are multiple
 * different attributes set for the different marks/nodes. See related issue
 * here: https://github.com/ueberdosis/tiptap/issues/3481
 */
function getAttributesForEachSelected(state, typeOrName) {
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === 'node') {
        return getAttributesForNodes(state, typeOrName);
    }
    if (schemaType === 'mark') {
        return getAttributesForMarks(state, typeOrName);
    }
    return [];
}
/**
 * Get the attributes of all currently selected marks of the given type or
 * name.
 *
 * Returns an array of Records, with an entry for each matching mark that is
 * currently selected.
 *
 * Based directly on Tiptap's getMarkAttributes
 * (https://github.com/ueberdosis/tiptap/blob/f387ad3dd4c2b30eaea33fb0ba0b42e0cd39263b/packages/core/src/helpers/getMarkAttributes.ts),
 * but returns results for each of the matching marks, rather than just the
 * first. See related: https://github.com/ueberdosis/tiptap/issues/3481
 */
function getAttributesForMarks(state, typeOrName) {
    const type = getMarkType(typeOrName, state.schema);
    const { from, to, empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) {
            marks.push(...state.storedMarks);
        }
        marks.push(...state.selection.$head.marks());
    }
    else {
        state.doc.nodesBetween(from, to, (node) => {
            marks.push(...node.marks);
        });
    }
    return marks
        .filter((markItem) => markItem.type.name === type.name)
        .map((mark) => ({ ...mark.attrs }));
}
/**
 * Get the attributes of all currently selected nodes of the given type or
 * name.
 *
 * Returns an array of Records, with an entry for each matching node that is
 * currently selected.
 *
 * Based directly on Tiptap's getNodeAttributes
 * (https://github.com/ueberdosis/tiptap/blob/f387ad3dd4c2b30eaea33fb0ba0b42e0cd39263b/packages/core/src/helpers/getNodeAttributes.ts),
 * but returns results for each of the matching nodes, rather than just the
 * first. See related: https://github.com/ueberdosis/tiptap/issues/3481
 */
function getAttributesForNodes(state, typeOrName) {
    const type = getNodeType(typeOrName, state.schema);
    const { from, to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, (node) => {
        nodes.push(node);
    });
    return nodes
        .reverse()
        .filter((nodeItem) => nodeItem.type.name === type.name)
        .map((node) => ({ ...node.attrs }));
}

const MIN_WIDTH = 15;
function getImgElement(element) {
    return element.tagName.toLowerCase() === 'img'
        ? element
        : element.firstChild;
}
const ResizableImageName = Image.name;
const ResizableImage = (injector) => Image.extend({
    addAttributes() {
        return {
            width: {
                default: null,
                renderHTML: (attributes) => ({
                    width: attributes['width'],
                }),
                parseHTML: (element) => getImgElement(element)
                    .getAttribute('width'),
            },
            aspectRatio: {
                default: null,
                renderHTML: (attributes) => {
                    if (!attributes['aspectRatio']) {
                        return {};
                    }
                    return {
                        style: `aspect-ratio: ${attributes['aspectRatio']}`,
                    };
                },
                parseHTML: (element) => getImgElement(element).style.aspectRatio,
            },
            src: {
                default: null,
                parseHTML: (element) => getImgElement(element)
                    .getAttribute('src'),
            },
            alt: {
                default: null,
                parseHTML: (element) => getImgElement(element).alt || null,
            },
            title: {
                default: null,
                parseHTML: (element) => getImgElement(element).title || null,
            },
        };
    },
    renderHTML({ HTMLAttributes }) {
        const allAttrs = mergeAttributes({ height: 'auto' }, this.options.HTMLAttributes, HTMLAttributes);
        const { style, ...imgAttrs } = allAttrs;
        const styles = styleAttributeToObject(style);
        const { 'text-align': textAlign, ...imgStyles } = styles;
        imgAttrs['style'] = objectToStyleAttribute(imgStyles);
        // Remove alt attribute if it's null or empty
        if (!imgAttrs['alt']) {
            delete imgAttrs['alt'];
        }
        return [
            'div',
            textAlign ? { style: `text-align: ${textAlign}` } : {},
            [
                'img',
                imgAttrs,
            ],
        ];
    },
    parseHTML() {
        return [
            {
                tag: 'div',
                getAttrs: node => node.querySelector(this.options.allowBase64 ? 'img[src]' : 'img[src]:not([src^="data:"])') ?? false,
            },
            {
                tag: 'span',
                getAttrs: node => node.querySelector(this.options.allowBase64 ? 'img[src]' : 'img[src]:not([src^="data:"])') ?? false,
            },
            {
                tag: this.options.allowBase64
                    ? 'img[src]'
                    : 'img[src]:not([src^="data:"])',
            },
        ];
    },
    addNodeView() {
        return AngularNodeViewRenderer(ResizableImageComponent, { injector });
    },
});
class ResizableImageComponent extends AngularNodeViewComponent {
    constructor() {
        super();
        this.resizerMouseDown = signal(false);
        this.selectedSignal = signal(false);
        this.selectedOrResizing = computed(() => {
            const mouseDown = this.resizerMouseDown();
            const selected = this.selectedSignal();
            return mouseDown || selected;
        });
        this.imageElement = viewChild.required('imageElement');
        this.resize$ = new Subject();
        this.onMouseUp = () => {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            this.resizerMouseDown.set(false);
        };
        this.onMouseMove = (event) => this.resize$.next(event);
        this.resize$
            .pipe(takeUntilDestroyed(), throttleTime(50))
            .subscribe((event) => {
            const originalRect = this.imageElement()
                .nativeElement
                .getBoundingClientRect();
            const width = event.clientX - originalRect.x;
            const height = event.clientY - originalRect.y;
            const finalWidth = Math.max(width, (originalRect.width / originalRect.height) * height, MIN_WIDTH);
            this.updateAttributes()({
                width: Math.round(finalWidth),
            });
        });
    }
    ngOnChanges(changes) {
        if ('selected' in changes) {
            const prev = changes['selected'].previousValue;
            const curr = changes['selected'].currentValue;
            if (prev !== curr) {
                this.selectedSignal.set(curr);
            }
        }
    }
    onLoad(event) {
        const currentTarget = event.currentTarget;
        const newAttrs = {};
        if (!this.node()['attrs']['width']) {
            newAttrs.width = currentTarget.naturalWidth;
        }
        if (!this.node()['attrs']['aspectRatio']) {
            newAttrs.aspectRatio = String(currentTarget.naturalWidth / currentTarget.naturalHeight);
        }
        if (newAttrs.width || newAttrs.aspectRatio) {
            this.updateAttributes()(newAttrs);
        }
    }
    onMouseDown() {
        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('mouseup', this.onMouseUp);
        this.resizerMouseDown.set(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ResizableImageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: ResizableImageComponent, isStandalone: true, selector: "ng-component", viewQueries: [{ propertyName: "imageElement", first: true, predicate: ["imageElement"], descendants: true, isSignal: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: `
		@if (extension().options.inline) {
			<span><ng-container *ngTemplateOutlet="content"></ng-container></span>
		} @else {
			<div style="width: 100%;"
			     [style.text-align]="node()['attrs']['textAlign']">
				<ng-container *ngTemplateOutlet="content"></ng-container>
			</div>
		}
		<ng-template #content>
			<div class="bui-wysiwyg__image-container">
				<img #imageElement
				     [src]="node()['attrs']['src']"
				     [alt]="node()['attrs']['alt']"
				     height="auto"
				     [width]="node()['attrs']['width'] || undefined"
				     class="bui-wysiwyg__image"
				     [class.ProseMirror-selectednode]="selectedOrResizing()"
				     [class.bui-wysiwyg__image--selected]="selectedOrResizing()"
				     [style.max-width]="node()['attrs']['width'] ? undefined : 'auto'"
				     [style.aspect-ratio]="node()['attrs']['aspectRation'] ?? undefined"
				     tiptapDraggable
				     (load)="onLoad($event)">

				@if (selectedOrResizing()) {
					<div class="bui-wysiwyg__image-resizer"
					     (mousedown)="onMouseDown()"></div>
				}
			</div>
		</ng-template>
	`, isInline: true, styles: [".bui-wysiwyg__image-container{display:inline-flex;position:relative}.bui-wysiwyg__image{display:block}.bui-wysiwyg__image --selected{outline:3px solid var(--color--highlight)}.bui-wysiwyg__image-resizer{position:absolute;bottom:-3px;right:-3px;width:12px;height:12px;background:var(--color--highlight);cursor:nwse-resize}.ProseMirror[contenteditable=false] .bui-wysiwyg__image-resizer{display:none}\n"], dependencies: [{ kind: "directive", type: TiptapDraggableDirective, selector: "[tiptapDraggable]" }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ResizableImageComponent, decorators: [{
            type: Component,
            args: [{ template: `
		@if (extension().options.inline) {
			<span><ng-container *ngTemplateOutlet="content"></ng-container></span>
		} @else {
			<div style="width: 100%;"
			     [style.text-align]="node()['attrs']['textAlign']">
				<ng-container *ngTemplateOutlet="content"></ng-container>
			</div>
		}
		<ng-template #content>
			<div class="bui-wysiwyg__image-container">
				<img #imageElement
				     [src]="node()['attrs']['src']"
				     [alt]="node()['attrs']['alt']"
				     height="auto"
				     [width]="node()['attrs']['width'] || undefined"
				     class="bui-wysiwyg__image"
				     [class.ProseMirror-selectednode]="selectedOrResizing()"
				     [class.bui-wysiwyg__image--selected]="selectedOrResizing()"
				     [style.max-width]="node()['attrs']['width'] ? undefined : 'auto'"
				     [style.aspect-ratio]="node()['attrs']['aspectRation'] ?? undefined"
				     tiptapDraggable
				     (load)="onLoad($event)">

				@if (selectedOrResizing()) {
					<div class="bui-wysiwyg__image-resizer"
					     (mousedown)="onMouseDown()"></div>
				}
			</div>
		</ng-template>
	`, encapsulation: ViewEncapsulation.None, imports: [
                        TiptapDraggableDirective,
                        NgTemplateOutlet,
                    ], styles: [".bui-wysiwyg__image-container{display:inline-flex;position:relative}.bui-wysiwyg__image{display:block}.bui-wysiwyg__image --selected{outline:3px solid var(--color--highlight)}.bui-wysiwyg__image-resizer{position:absolute;bottom:-3px;right:-3px;width:12px;height:12px;background:var(--color--highlight);cursor:nwse-resize}.ProseMirror[contenteditable=false] .bui-wysiwyg__image-resizer{display:none}\n"] }]
        }], ctorParameters: () => [] });

const Base64ImageName = 'base64image';
const Base64Image = (injector) => ResizableImage(injector)
    .extend({
    name: Base64ImageName,
    addOptions() {
        return {
            inline: false,
            allowBase64: true,
            HTMLAttributes: {},
        };
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                props: {
                    handleDOMEvents: {
                        drop(view, event) {
                            const effectAllowed = event.dataTransfer?.effectAllowed.toLowerCase() ?? '';
                            if (!(['all', 'uninitialized'].includes(effectAllowed) || effectAllowed.includes('link'))) {
                                return;
                            }
                            const images = extractImages(event.dataTransfer);
                            if (images.length === 0) {
                                event.preventDefault();
                                return;
                            }
                            event.preventDefault();
                            const { schema } = view.state;
                            const coordinates = view.posAtCoords({
                                left: event.clientX,
                                top: event.clientY,
                            });
                            images.forEach(image => {
                                const reader = new FileReader();
                                reader.onload = readerEvent => {
                                    const src = readerEvent.target.result;
                                    if (!src?.startsWith('data:image/')) {
                                        return;
                                    }
                                    const node = schema.nodes['base64image'].create({ src });
                                    const transaction = view.state.tr.insert(coordinates.pos, node);
                                    view.dispatch(transaction);
                                };
                                reader.readAsDataURL(image);
                            });
                        },
                        paste(view, event) {
                            const images = extractImages(event.clipboardData);
                            if (images.length === 0) {
                                return;
                            }
                            event.preventDefault();
                            const { schema } = view.state;
                            images.forEach(image => {
                                const reader = new FileReader();
                                reader.onload = readerEvent => {
                                    const src = readerEvent.target.result;
                                    if (!src?.startsWith('data:image/')) {
                                        return;
                                    }
                                    const node = schema.nodes['base64image'].create({ src });
                                    const transaction = view.state.tr.replaceSelectionWith(node);
                                    view.dispatch(transaction);
                                };
                                reader.readAsDataURL(image);
                            });
                        },
                    },
                },
            }),
        ];
    },
});
function extractImages(dataTransfer) {
    const files = dataTransfer?.files;
    if (!files?.length) {
        return [];
    }
    return Array.from(files)
        .filter(file => /image/i.test(file.type));
}

const TextAlign = TextAlign$1.extend({
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    textAlign: {
                        default: this.options.defaultAlignment,
                        parseHTML: element => {
                            const alignment = element.style.textAlign;
                            return this.options.alignments.includes(alignment) ? alignment : this.options.defaultAlignment;
                        },
                        renderHTML: attributes => {
                            if (!attributes['textAlign'] || attributes['textAlign'] === this.options.defaultAlignment) {
                                return {};
                            }
                            return { style: `text-align: ${attributes['textAlign']}` };
                        },
                    },
                },
            },
        ];
    },
});

// Cache the result of isMac() and isTouchDevice(), since they shouldn't change during a session.
let isMacResult;
/**
 * Return true if the user is using a Mac (as opposed to Windows, etc.) device.
 */
function isMac() {
    if (isMacResult === undefined) {
        // Ja, navigator.platform ist heute schon deprecated, aber wir brauchen einen Fallback für navigator.userAgentData in FF
        // und selbst MDN sagt "But there is one case where, among the options you could use,
        // navigator.platform may be the least-bad option: When you need to show users advice about whether
        // the modifier key for keyboard shortcuts is the command key rather than the control key"
        isMacResult = (navigator.userAgentData?.platform ?? navigator.platform).toLowerCase()
            .includes('mac');
    }
    return isMacResult;
}
/**
 * Return a human-readable version of which modifier key should be used for
 * keyboard shortcuts depending on Mac vs non-Mac platforms. Useful for visually
 * indicating which key to press.
 */
function getModShortcutKey() {
    // TODO: Ctrl/Strg je nach Sprache
    return isMac() ? '⌘' : 'Ctrl';
}

class AbstractMenuButtonComponent {
    constructor() {
        this.selected = signal(false);
        this.disabled = signal(false);
        this.editor = input.required();
        this.tooltipLabelKey = computed(() => `bui.wysiwyg.${this.tooltipLabel}.label`);
        this.tooltipShortcutHint = computed(() => {
            const keys = this.tooltipShortcutKeys;
            if (!keys) {
                return '';
            }
            return ` (${keys.map(key => key === 'mod' ? getModShortcutKey() : key)
                .join('+')})`;
        });
        explicitEffect([this.editor], ([editor]) => {
            this.onEditorUpdate();
            editor.on('update', () => this.onEditorUpdate());
            editor.on('selectionUpdate', () => this.onEditorUpdate());
        });
    }
    onEditorUpdate() {
        this.selected.set(this.isSelected());
        this.disabled.set(!this.editor().isEditable || !this.canRunCommand());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: AbstractMenuButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "19.1.1", type: AbstractMenuButtonComponent, isStandalone: true, inputs: { editor: { classPropertyName: "editor", publicName: "editor", isSignal: true, isRequired: true, transformFunction: null } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: AbstractMenuButtonComponent, decorators: [{
            type: Directive
        }], ctorParameters: () => [] });
const AbstractMenuButtonImports = [
    ButtonComponent,
    MatIcon,
    MsgKeyPipe,
    AsyncPipe,
];

class MenuButtonBase64ImageComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Base64Image';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'image';
        this.fileInput = viewChild.required('fileInput');
        this.accept = inject(BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE)
            .config().Base64Image?.accept ?? 'image/*';
    }
    onClick() {
        this.fileInput()
            .nativeElement
            .click();
    }
    isSelected() {
        return this.editor()
            .isActive(Base64ImageName);
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setImage({ src: 'http://example.com' });
    }
    onFileChange(event) {
        const files = event.target?.files;
        if (!files || !files.length) {
            return;
        }
        const file = files[0];
        const reader = new FileReader();
        reader.onloadend = (e) => {
            const base64 = e.target.result;
            this.editor()
                .chain()
                .focus()
                .setImage({
                src: base64,
            })
                .run();
            this.fileInput().nativeElement.value = '';
        };
        reader.readAsDataURL(file);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBase64ImageComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: MenuButtonBase64ImageComponent, isStandalone: true, selector: "bui-wysiwyg-base64image", viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true, isSignal: true }], usesInheritance: true, ngImport: i0, template: `
		<div class="bui-wysiwyg__toolbar-control"
		     [class.bui-wysiwyg__toolbar-control--active]="selected()">
			<button bui-button
			        [disabled]="disabled()"
			        [title]="(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()"
			        (throttledClick)="onClick()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		</div>
		<input #fileInput
		       type="file"
		       [accept]="accept"
		       style="display: none"
		       (change)="onFileChange($event)">
	`, isInline: true, dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBase64ImageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-wysiwyg-base64image',
                    imports: AbstractMenuButtonImports,
                    template: `
		<div class="bui-wysiwyg__toolbar-control"
		     [class.bui-wysiwyg__toolbar-control--active]="selected()">
			<button bui-button
			        [disabled]="disabled()"
			        [title]="(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()"
			        (throttledClick)="onClick()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		</div>
		<input #fileInput
		       type="file"
		       [accept]="accept"
		       style="display: none"
		       (change)="onFileChange($event)">
	`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });
const Base64ImageTool = {
    dependencies: [Base64Image],
    conflicts: ['ImageUpload'],
    control: MenuButtonBase64ImageComponent,
    optionMap: {
        [Base64ImageName]: Object.getOwnPropertyNames(Image.options),
    },
    config: {
        [TextAlign.name]: ((config) => ({
            ...config,
            types: [...(config.types ?? []), Base64ImageName],
        })),
    },
};

const BgColor = Highlight.extend({
    addAttributes() {
        if (!this.options.multicolor) {
            return {};
        }
        return {
            color: {
                default: null,
                parseHTML: element => element.getAttribute('data-color')
                    || element.getAttribute('style')
                        ?.match(/(^|;\s*)background-color:\s*([^;]+)/)?.[2],
                renderHTML: attributes => {
                    if (!attributes['color']) {
                        return {};
                    }
                    return {
                        'data-color': attributes['color'],
                        style: `background-color: ${attributes['color']}; color: inherit`,
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            { tag: 'mark' },
            {
                tag: 'span',
                getAttrs: element => !!element.style.backgroundColor && null,
                priority: 101, // mehr als TextStyle/Color (100)
            },
        ];
    },
});

class MenuButtonBGColorComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'BGColor';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'format_color_fill';
        this.floatUiTrigger = viewChild(NgxFloatUiDirective);
        this.moreColorsInput = viewChild('moreColorsInput');
        this.defaultBGColor = '';
        this.currentColor = signal('');
        this.colorStyle = computed(() => ({
            '--bui-wysiwyg--current-color': this.currentColor().length ? `#${this.currentColor()}` : 'transparent',
        }));
        this.swatchColors = [
            '1abc9c', '2ecc71', '3498db', '9b59b6', '4e5f70', 'f1c40f',
            '16a085', '27ae60', '2980b9', '8e44ad', '2c3e50', 'f39c12',
            'e67e22', 'e74c3c', 'ecf0f1', '95a5a6', 'dddddd', 'ffffff',
            'd35400', 'c0392b', 'bdc3c7', '7f8c8d', '999999', '000000',
        ];
        this.historyColors = signal([]);
        this.PLACEMENT_BOTTOM = NgxFloatUiPlacements.BOTTOM;
    }
    onEditorUpdate() {
        super.onEditorUpdate();
        this.updateCurrentColor();
    }
    onClick() {
        // Handling per FloatUI
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setHighlight();
    }
    updateCurrentColor() {
        this.currentColor.set(this.getCurrentColor()
            .substring(1)
            .toLowerCase());
    }
    getCurrentColor() {
        const editor = this.editor();
        // Determine if all the selected content shares the same set color.
        const allCurrentTextStyleAttrs = editor
            ? getAttributesForEachSelected(editor.state, BgColor.name)
            : [];
        const isTextStyleAppliedToEntireSelection = !!editor?.isActive(BgColor.name);
        const currentColors = allCurrentTextStyleAttrs.map(
        // Treat any null/missing color as the default color
        (attrs) => attrs.color || this.defaultBGColor);
        if (!isTextStyleAppliedToEntireSelection) {
            // If there is some selected content that does not have textStyle, we can
            // treat it the same as a selected textStyle mark with color set to the
            // default
            currentColors.push(this.defaultBGColor);
        }
        const numUniqueCurrentColors = new Set(currentColors).size;
        if (numUniqueCurrentColors === 1) {
            // There's exactly one color in the selected content, so show that
            return currentColors[0];
        }
        if (numUniqueCurrentColors > 1) {
            // There are multiple colors (either explicitly, or because some of the
            // selection has a color set and some does not and is using the default
            // color). Similar to other rich text editors like Google Docs, we'll treat
            // this as "unset" and not show a color indicator in the button or a
            // "current" color when interacting with the color picker.
            return '';
        }
        // Since no color was set anywhere in the selected content, we should show
        // the default color
        return this.defaultBGColor;
    }
    setColor(color) {
        const prefixedColor = (color.startsWith('#') ? color : `#${color}`).toLowerCase();
        this.editor()
            .chain()
            .focus()
            .setHighlight({ color: prefixedColor })
            .run() && this.closePopup();
        const colorNoHash = prefixedColor.substring(1);
        this.historyColors.update(colors => [colorNoHash, ...colors.filter(c => c !== color)]);
        this.currentColor.set(colorNoHash);
    }
    resetColor() {
        this.editor()
            .chain()
            .focus()
            .unsetHighlight()
            .run() && this.closePopup();
        this.currentColor.set('');
    }
    closePopup() {
        this.floatUiTrigger()
            ?.hide();
    }
    openMoreColorsDialog() {
        this.closePopup();
        this.moreColorsInput()
            ?.nativeElement
            .click();
    }
    onMoreColorsChange(e) {
        const color = e.target.value;
        this.setColor(color);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBGColorComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: MenuButtonBGColorComponent, isStandalone: true, selector: "bui-wysiwyg-bgcolor", viewQueries: [{ propertyName: "floatUiTrigger", first: true, predicate: NgxFloatUiDirective, descendants: true, isSignal: true }, { propertyName: "moreColorsInput", first: true, predicate: ["moreColorsInput"], descendants: true, isSignal: true }], usesInheritance: true, ngImport: i0, template: `
		<float-ui-content class="bui-wysiwyg__color-popup"
		                  #colorPopup>
			<button class="bui-wysiwyg__color-button bui-wysiwyg__color-button--auto"
			        type="button"
			        (click)="resetColor()">
				<span class="bui-wysiwyg__color"
				      [style.background-color]="'var(--color--layout--background)'"></span>
				<span class="bui-wysiwyg__color-auto-text">{{ 'bui.wysiwyg.Color.auto' | msgKey | async }}</span>
			</button>
			<div class="bui-wysiwyg__color-swatch">
				@for (color of swatchColors; track color) {
					<button class="bui-wysiwyg__color-button"
					        [class.bui-wysiwyg__color-button--active]="color === currentColor()"
					        title="{{ ('bui.wysiwyg.Color.color.' + color) | msgKey | async }}"
					        (click)="setColor(color)"
					        type="button">
						<span class="bui-wysiwyg__color"
						      [style.background-color]="'#' + color"></span>
					</button>
				}
			</div>
			<hr>
			@if (historyColors().length) {
				<div class="bui-wysiwyg__color-swatch bui-wysiwyg__color-swatch--history">
					@for (color of historyColors(); track color) {
						<button class="bui-wysiwyg__color-button"
						        [class.bui-wysiwyg__color-button--active]="color === currentColor()"
						        title="{{ swatchColors.includes(color) ? (('bui.wysiwyg.Color.color.' + color) | msgKey | async) : ('#' + color) }}"
						        (click)="setColor(color)"
						        type="button">
							<span class="bui-wysiwyg__color"
							      [style.background-color]="'#' + color"></span>
						</button>
					}
				</div>
			}
			<button class="bui-wysiwyg__color-button bui-wysiwyg__color-button--more"
			        type="button"
			        (click)="openMoreColorsDialog()">
				<span class="bui-wysiwyg__color-more-text">{{ 'bui.wysiwyg.Color.more' | msgKey | async }}</span>
			</button>
		</float-ui-content>
		<div class="bui-wysiwyg__toolbar-control bui-wysiwyg__toolbar-control--color"
		     [class.bui-wysiwyg__toolbar-control--active]="selected()">
			<button bui-button
			        [disabled]="disabled()"
			        [title]="(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()"
			        [floatUi]="colorPopup"
			        [placement]="PLACEMENT_BOTTOM"
			        [style]="colorStyle()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		</div>
		<input #moreColorsInput
		       (change)="onMoreColorsChange($event)"
		       class="bui-wysiwyg__color-more-input"
		       type="color">`, isInline: true, dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "ngmodule", type: NgxFloatUiModule }, { kind: "component", type: i5.NgxFloatUiContentComponent, selector: "float-ui-content", exportAs: ["ngxFloatUiContent"] }, { kind: "directive", type: i5.NgxFloatUiDirective, selector: "[floatUi]", inputs: ["applyClass", "arrowClass", "disabled", "floatUi", "hideOnClickOutside", "placement", "preventOverflow", "showOnStart", "appendTo", "ariaDescribe", "ariaRole", "boundariesElement", "disableAnimation", "disableStyle", "hideOnMouseLeave", "hideOnScroll", "hideTimeout", "positionFixed", "showDelay", "showTrigger", "styles", "targetElement", "timeoutAfterShow"], outputs: ["onHidden", "onShown", "onUpdate"], exportAs: ["floatUi"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBGColorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-wysiwyg-bgcolor',
                    imports: [
                        ...AbstractMenuButtonImports,
                        NgxFloatUiModule,
                    ],
                    template: `
		<float-ui-content class="bui-wysiwyg__color-popup"
		                  #colorPopup>
			<button class="bui-wysiwyg__color-button bui-wysiwyg__color-button--auto"
			        type="button"
			        (click)="resetColor()">
				<span class="bui-wysiwyg__color"
				      [style.background-color]="'var(--color--layout--background)'"></span>
				<span class="bui-wysiwyg__color-auto-text">{{ 'bui.wysiwyg.Color.auto' | msgKey | async }}</span>
			</button>
			<div class="bui-wysiwyg__color-swatch">
				@for (color of swatchColors; track color) {
					<button class="bui-wysiwyg__color-button"
					        [class.bui-wysiwyg__color-button--active]="color === currentColor()"
					        title="{{ ('bui.wysiwyg.Color.color.' + color) | msgKey | async }}"
					        (click)="setColor(color)"
					        type="button">
						<span class="bui-wysiwyg__color"
						      [style.background-color]="'#' + color"></span>
					</button>
				}
			</div>
			<hr>
			@if (historyColors().length) {
				<div class="bui-wysiwyg__color-swatch bui-wysiwyg__color-swatch--history">
					@for (color of historyColors(); track color) {
						<button class="bui-wysiwyg__color-button"
						        [class.bui-wysiwyg__color-button--active]="color === currentColor()"
						        title="{{ swatchColors.includes(color) ? (('bui.wysiwyg.Color.color.' + color) | msgKey | async) : ('#' + color) }}"
						        (click)="setColor(color)"
						        type="button">
							<span class="bui-wysiwyg__color"
							      [style.background-color]="'#' + color"></span>
						</button>
					}
				</div>
			}
			<button class="bui-wysiwyg__color-button bui-wysiwyg__color-button--more"
			        type="button"
			        (click)="openMoreColorsDialog()">
				<span class="bui-wysiwyg__color-more-text">{{ 'bui.wysiwyg.Color.more' | msgKey | async }}</span>
			</button>
		</float-ui-content>
		<div class="bui-wysiwyg__toolbar-control bui-wysiwyg__toolbar-control--color"
		     [class.bui-wysiwyg__toolbar-control--active]="selected()">
			<button bui-button
			        [disabled]="disabled()"
			        [title]="(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()"
			        [floatUi]="colorPopup"
			        [placement]="PLACEMENT_BOTTOM"
			        [style]="colorStyle()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		</div>
		<input #moreColorsInput
		       (change)="onMoreColorsChange($event)"
		       class="bui-wysiwyg__color-more-input"
		       type="color">`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });
const BGColorTool = {
    dependencies: [BgColor],
    control: MenuButtonBGColorComponent,
    config: {
        [BgColor.name]: ((config) => ({
            ...config,
            multicolor: true,
        })),
    },
    optionMap: {
        [BgColor.name]: Object.getOwnPropertyNames(BgColor.options),
    },
};

class MenuButtonBlockquoteComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Blockquote';
        this.tooltipShortcutKeys = ['mod', 'Shift', 'B'];
        this.icon = 'format_quote';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .toggleBlockquote()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('blockquote');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleBlockquote();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBlockquoteComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonBlockquoteComponent, isStandalone: true, selector: "bui-wysiwyg-blockquote", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBlockquoteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-blockquote', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const BlockquoteTool = {
    dependencies: [Blockquote],
    control: MenuButtonBlockquoteComponent,
    optionMap: {
        [Blockquote.name]: Object.getOwnPropertyNames(Blockquote.options),
    },
};

class MenuButtonBoldComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Bold';
        this.tooltipShortcutKeys = ['mod', 'B'];
        this.icon = 'format_bold';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .toggleBold()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('bold');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleBold();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBoldComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonBoldComponent, isStandalone: true, selector: "bui-wysiwyg-bold", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBoldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-bold', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const BoldTool = {
    dependencies: [Bold],
    control: MenuButtonBoldComponent,
    optionMap: {
        [Bold.name]: Object.getOwnPropertyNames(Bold.options),
    },
};

const Paragraph = Paragraph$1.extend({
    parseHTML() {
        return [
            { tag: 'p' },
            {
                tag: 'div:not([data-type]):not([data-oembed_provider])',
                priority: 1,
            },
        ];
    },
});

class MenuButtonBulletedListComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'BulletedList';
        this.tooltipShortcutKeys = ['mod', 'Shift', '8'];
        this.icon = 'format_list_bulleted';
    }
    onClick() {
        this.editor()
            ?.chain()
            .focus()
            .toggleBulletList()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('bulletList');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleBulletList();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBulletedListComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonBulletedListComponent, isStandalone: true, selector: "bui-wysiwyg-bulletedlist", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonBulletedListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-bulletedlist', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const BulletedListTool = {
    dependencies: [BulletList, ListItem, Paragraph],
    control: MenuButtonBulletedListComponent,
    optionMap: {
        [BulletList.name]: Object.fromEntries(Object.getOwnPropertyNames(BulletList.options)
            .map(option => [option, option === 'HTMLAttributes' ? 'bulletListHTMLAttributes' : option])),
        [ListItem.name]: Object.fromEntries(Object.getOwnPropertyNames(ListItem.options)
            .map(option => [option, option === 'HTMLAttributes' ? 'listItemHTMLAttributes' : option])),
    },
};

class MenuButtonHorizontalRuleComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'HorizontalRule';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'horizontal_rule';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .setHorizontalRule()
            .run();
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setHorizontalRule();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonHorizontalRuleComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonHorizontalRuleComponent, isStandalone: true, selector: "bui-wysiwyg-horizontalrule", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonHorizontalRuleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-horizontalrule', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const HorizontalRuleTool = {
    dependencies: [HorizontalRule],
    control: MenuButtonHorizontalRuleComponent,
    optionMap: {
        [HorizontalRule.name]: Object.getOwnPropertyNames(HorizontalRule.options),
    },
};

class DialogActionDirective extends MatDialogClose {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogActionDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.1.1", type: DialogActionDirective, isStandalone: true, selector: "button[bui-dialog-action]", inputs: { ariaLabel: "ariaLabel", type: "type", dialogResult: ["bui-dialog-action", "dialogResult"] }, host: { listeners: { "click": "_onButtonClick($event)" }, properties: { "class.bui-dialog-action": "true", "attr.aria-label": "ariaLabel || null", "attr.type": "type" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogActionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[bui-dialog-action]',
                    inputs: ['ariaLabel', 'type', 'dialogResult: bui-dialog-action'],
                    host: {
                        '[class.bui-dialog-action]': 'true',
                        '(click)': '_onButtonClick($event)',
                        '[attr.aria-label]': 'ariaLabel || null',
                        '[attr.type]': 'type',
                    },
                }]
        }] });

class DialogActionsComponent {
    constructor() {
        this.align = input('start');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogActionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: DialogActionsComponent, isStandalone: true, selector: "bui-dialog-actions", inputs: { align: { classPropertyName: "align", publicName: "align", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-dialog-actions": "true" } }, ngImport: i0, template: "<div mat-dialog-actions\r\n     [align]=\"align()\">\r\n\t<ng-content></ng-content>\r\n</div>", dependencies: [{ kind: "ngmodule", type: MatDialogModule }, { kind: "directive", type: i1$3.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogActionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-dialog-actions', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        MatDialogModule,
                    ], host: {
                        '[class.bui-dialog-actions]': 'true',
                    }, template: "<div mat-dialog-actions\r\n     [align]=\"align()\">\r\n\t<ng-content></ng-content>\r\n</div>" }]
        }] });

class DialogContentComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: DialogContentComponent, isStandalone: true, selector: "bui-dialog-content", host: { properties: { "class.bui-dialog-content": "true" } }, ngImport: i0, template: "<mat-dialog-content>\r\n\t<ng-content></ng-content>\r\n</mat-dialog-content>", dependencies: [{ kind: "ngmodule", type: MatDialogModule }, { kind: "directive", type: i1$3.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-dialog-content', changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        MatDialogModule,
                    ], host: {
                        '[class.bui-dialog-content]': 'true',
                    }, template: "<mat-dialog-content>\r\n\t<ng-content></ng-content>\r\n</mat-dialog-content>" }]
        }] });

class DialogTitleDirective extends MatDialogTitle {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogTitleDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.1.1", type: DialogTitleDirective, isStandalone: true, selector: "[bui-dialog-title]", host: { properties: { "class.bui-dialog-title": "true" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogTitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bui-dialog-title]',
                    host: {
                        '[class.bui-dialog-title]': 'true',
                    },
                }]
        }] });

class HintComponent {
    constructor() {
        this.hint = input.required();
        this.tiny = input(null, { transform: coerceBooleanProperty });
        this.newicon = input(null, { transform: coerceBooleanProperty });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: HintComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: HintComponent, isStandalone: true, selector: "bui-hint", inputs: { hint: { classPropertyName: "hint", publicName: "hint", isSignal: true, isRequired: true, transformFunction: null }, tiny: { classPropertyName: "tiny", publicName: "tiny", isSignal: true, isRequired: false, transformFunction: null }, newicon: { classPropertyName: "newicon", publicName: "newicon", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-hint": "true" } }, ngImport: i0, template: "<div [bui-tooltip]=\"hint()\"\r\n     [class.tiny]=\"tiny()\"\r\n     [class.newicon]=\"newicon()\">\r\n\t<!--bui-tooltip-content>\r\n\t\t<ng-content></ng-content>\r\n\t</bui-tooltip-content-->\r\n</div>", dependencies: [{ kind: "directive", type: TooltipDirective, selector: "[bui-tooltip]", inputs: ["bui-tooltip", "disableTabindex"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: HintComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-hint', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        TooltipDirective,
                    ], host: {
                        '[class.bui-hint]': 'true',
                    }, template: "<div [bui-tooltip]=\"hint()\"\r\n     [class.tiny]=\"tiny()\"\r\n     [class.newicon]=\"newicon()\">\r\n\t<!--bui-tooltip-content>\r\n\t\t<ng-content></ng-content>\r\n\t</bui-tooltip-content-->\r\n</div>" }]
        }] });

class LabelComponent {
    constructor() {
        this.required = input(false, { transform: coerceBooleanProperty });
        this.hint = input();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: LabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: LabelComponent, isStandalone: true, selector: "bui-label", inputs: { required: { classPropertyName: "required", publicName: "required", isSignal: true, isRequired: false, transformFunction: null }, hint: { classPropertyName: "hint", publicName: "hint", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-label": "true", "class.bui-label--required": "required()" } }, ngImport: i0, template: "<span class=\"bui-label__content\">\r\n\t<ng-content></ng-content>\r\n</span>\r\n@if (hint()) {\r\n\t<bui-hint class=\"bui-label__hint\"\r\n\t          [hint]=\"hint()!\"\r\n\t          [tiny]=\"true\"></bui-hint>\r\n}", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: HintComponent, selector: "bui-hint", inputs: ["hint", "tiny", "newicon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: LabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-label', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        HintComponent,
                    ], host: {
                        '[class.bui-label]': 'true',
                        '[class.bui-label--required]': 'required()',
                    }, template: "<span class=\"bui-label__content\">\r\n\t<ng-content></ng-content>\r\n</span>\r\n@if (hint()) {\r\n\t<bui-hint class=\"bui-label__hint\"\r\n\t          [hint]=\"hint()!\"\r\n\t          [tiny]=\"true\"></bui-hint>\r\n}" }]
        }] });

class FieldComponent {
    constructor() {
        this.labelPosition = input();
        this.labelPositionClass = computed(() => this.labelPosition() && `bui-row--label-position--${this.labelPosition()}`);
        this.label = contentChild(LabelComponent);
        this.hasLabel = computed(() => !!this.label());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: FieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: FieldComponent, isStandalone: true, selector: "bui-field", inputs: { labelPosition: { classPropertyName: "labelPosition", publicName: "labelPosition", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-field": "true", "class.bui-row": "true", "class": "labelPositionClass()" } }, queries: [{ propertyName: "label", first: true, predicate: LabelComponent, descendants: true, isSignal: true }], ngImport: i0, template: "<div *ngIf=\"hasLabel()\"\r\n\t class=\"bui-row__label\">\r\n\t<ng-content select=\"bui-label\"></ng-content>\r\n</div>\r\n<div *ngIf=\"hasLabel(); else noLabel\"\r\n\t class=\"bui-row__content\">\r\n\t<ng-container *ngTemplateOutlet=\"content\"></ng-container>\r\n</div>\r\n\r\n<ng-template #noLabel>\r\n\t<ng-container *ngTemplateOutlet=\"content\"></ng-container>\r\n</ng-template>\r\n\r\n<ng-template #content>\r\n\t<ng-content></ng-content>\r\n</ng-template>", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: FieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-field', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                    ], host: {
                        '[class.bui-field]': 'true',
                        '[class.bui-row]': 'true',
                        '[class]': 'labelPositionClass()',
                    }, template: "<div *ngIf=\"hasLabel()\"\r\n\t class=\"bui-row__label\">\r\n\t<ng-content select=\"bui-label\"></ng-content>\r\n</div>\r\n<div *ngIf=\"hasLabel(); else noLabel\"\r\n\t class=\"bui-row__content\">\r\n\t<ng-container *ngTemplateOutlet=\"content\"></ng-container>\r\n</div>\r\n\r\n<ng-template #noLabel>\r\n\t<ng-container *ngTemplateOutlet=\"content\"></ng-container>\r\n</ng-template>\r\n\r\n<ng-template #content>\r\n\t<ng-content></ng-content>\r\n</ng-template>" }]
        }] });

class GroupComponent {
    constructor() {
        this.name = input();
        this.hint = input();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: GroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: GroupComponent, isStandalone: true, selector: "bui-group", inputs: { name: { classPropertyName: "name", publicName: "name", isSignal: true, isRequired: false, transformFunction: null }, hint: { classPropertyName: "hint", publicName: "hint", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-group": "true" } }, ngImport: i0, template: "<header class=\"bui-group__header groupSeparator\"\r\n        *ngIf=\"name() || hint()\">\r\n\t<span *ngIf=\"name()\">{{ name() }}</span>\r\n\t<bui-hint class=\"bui-group__hint\"\r\n\t          *ngIf=\"hint()\"\r\n\t          [hint]=\"hint()!\"\r\n\t          [tiny]=\"true\"></bui-hint>\r\n</header>\r\n<ng-content></ng-content>", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: HintComponent, selector: "bui-hint", inputs: ["hint", "tiny", "newicon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: GroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-group', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        HintComponent,
                    ], host: {
                        '[class.bui-group]': 'true',
                    }, template: "<header class=\"bui-group__header groupSeparator\"\r\n        *ngIf=\"name() || hint()\">\r\n\t<span *ngIf=\"name()\">{{ name() }}</span>\r\n\t<bui-hint class=\"bui-group__hint\"\r\n\t          *ngIf=\"hint()\"\r\n\t          [hint]=\"hint()!\"\r\n\t          [tiny]=\"true\"></bui-hint>\r\n</header>\r\n<ng-content></ng-content>" }]
        }] });

// de: 54.123,51
const INPUT_DECIMAL_FORMAT_DE = {
    decimalSeparator: ',',
    thousandsSeparator: '.'
};
// en: 54,123.51
const INPUT_DECIMAL_FORMAT_EN = {
    decimalSeparator: '.',
    thousandsSeparator: ','
};

class InputDecimalFormatter {
    constructor(locale) {
        this.locale = locale;
        switch (locale?.toString()) {
            case 'de':
            case 'de_DE':
            case 'de-DE':
                this.inputDecimalFormat = INPUT_DECIMAL_FORMAT_DE;
                break;
            default:
                this.inputDecimalFormat = INPUT_DECIMAL_FORMAT_EN;
        }
    }
    format(value, minPrecisionDigits, maxPrecisionDigits) {
        return value.toLocaleString(this.locale, {
            minimumFractionDigits: minPrecisionDigits,
            maximumFractionDigits: maxPrecisionDigits,
        });
    }
    parse(value, maxPrecisionDigits) {
        value = value.replace(new RegExp(`[${this.inputDecimalFormat.thousandsSeparator}]`, 'g'), '');
        value = value.replace(new RegExp(`[${this.inputDecimalFormat.decimalSeparator}]`, 'g'), '.');
        const lastDecimalSeparator = value.lastIndexOf('.');
        const length = lastDecimalSeparator > -1 ? lastDecimalSeparator + 1 + maxPrecisionDigits : value.length;
        value = value.substring(0, length);
        return value.length > 0 ? Number(value) : NaN;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputDecimalFormatter, deps: [{ token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputDecimalFormatter, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputDecimalFormatter, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }] });

class InputDecimalComponent {
    constructor() {
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.name = input();
        this.precisionDigits = input(2);
        this.minPrecisionDigitsInput = input(undefined, { alias: 'minPrecisionDigits' });
        this.maxPrecisionDigitsInput = input(undefined, { alias: 'maxPrecisionDigits' });
        this.placeholder = input('');
        this.disabled = linkedSignal(() => this.disabledInput());
        this.minPrecisionDigits = computed(() => {
            const min = this.minPrecisionDigitsInput();
            const fallback = this.precisionDigits();
            return min ?? fallback;
        });
        this.maxPrecisionDigits = computed(() => {
            const max = this.maxPrecisionDigitsInput();
            const fallback = this.precisionDigits();
            return max ?? fallback;
        });
        this.valueString = signal(undefined);
        this.value = null;
        this.changedSinceLastWriteValue = false;
        this.formatter = inject(InputDecimalFormatter);
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    writeValue(obj) {
        this.value = obj;
        this.changedSinceLastWriteValue = false;
        if (obj !== null && obj !== undefined && !isNaN(obj)) {
            this.valueString.set(this.formatter.format(obj, this.minPrecisionDigits(), this.maxPrecisionDigits()));
        }
    }
    onBlur() {
        if (!this.changedSinceLastWriteValue && this.valueString() !== undefined) {
            this.updateValue(this.valueString());
        }
        else {
            this._onTouchedFn();
        }
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    updateValue(value) {
        this.value = value ? this.formatter.parse(value, this.maxPrecisionDigits()) : null;
        this.changedSinceLastWriteValue = true;
        this.valueString.set(value);
        this._onTouchedFn();
        this._onChangeFn(this.value);
    }
    validate(control) {
        if (this.valueString() && isNaN(this.formatter.parse(this.valueString(), this.maxPrecisionDigits()))) {
            return {
                format: {
                    actual: this.valueString(),
                },
            };
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputDecimalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: InputDecimalComponent, isStandalone: true, selector: "bui-input-decimal", inputs: { disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, name: { classPropertyName: "name", publicName: "name", isSignal: true, isRequired: false, transformFunction: null }, precisionDigits: { classPropertyName: "precisionDigits", publicName: "precisionDigits", isSignal: true, isRequired: false, transformFunction: null }, minPrecisionDigitsInput: { classPropertyName: "minPrecisionDigitsInput", publicName: "minPrecisionDigits", isSignal: true, isRequired: false, transformFunction: null }, maxPrecisionDigitsInput: { classPropertyName: "maxPrecisionDigitsInput", publicName: "maxPrecisionDigits", isSignal: true, isRequired: false, transformFunction: null }, placeholder: { classPropertyName: "placeholder", publicName: "placeholder", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-input-decimal": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: InputDecimalComponent,
                multi: true,
            }, {
                provide: NG_VALIDATORS,
                useExisting: InputDecimalComponent,
                multi: true,
            },
        ], ngImport: i0, template: "<input buiValidationControl\r\n       type=\"text\"\r\n       [attr.name]=\"name()\"\r\n       (ngModelChange)=\"updateValue($event)\"\r\n       [ngModel]=\"valueString()\"\r\n       (blur)=\"onBlur()\"\r\n       [placeholder]=\"placeholder()\"\r\n       [disabled]=\"disabled()\"/>\r\n", dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputDecimalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-input-decimal', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        FormsModule,
                        ValidationControlDirective,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: InputDecimalComponent,
                            multi: true,
                        }, {
                            provide: NG_VALIDATORS,
                            useExisting: InputDecimalComponent,
                            multi: true,
                        },
                    ], host: {
                        '[class.bui-input-decimal]': 'true',
                    }, template: "<input buiValidationControl\r\n       type=\"text\"\r\n       [attr.name]=\"name()\"\r\n       (ngModelChange)=\"updateValue($event)\"\r\n       [ngModel]=\"valueString()\"\r\n       (blur)=\"onBlur()\"\r\n       [placeholder]=\"placeholder()\"\r\n       [disabled]=\"disabled()\"/>\r\n" }]
        }], ctorParameters: () => [] });

class InputComponent {
    constructor() {
        this.placeholder = input('');
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.disabled = linkedSignal(() => this.disabledInput());
        this.value = signal(null);
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    writeValue(value) {
        this.value.set(value);
    }
    updateValue(value) {
        this.writeValue(value);
        this._onChangeFn(this.value());
        this._onTouchedFn();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: InputComponent, isStandalone: true, selector: "bui-input", inputs: { placeholder: { classPropertyName: "placeholder", publicName: "placeholder", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-input": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: InputComponent,
                multi: true,
            },
        ], ngImport: i0, template: "<input buiValidationControl\r\n       type=\"text\"\r\n       [disabled]=\"disabled()\"\r\n       [placeholder]=\"placeholder()\"\r\n       [ngModel]=\"value()\"\r\n       (ngModelChange)=\"updateValue($event)\"/>\r\n", dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-input', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        FormsModule,
                        ValidationControlDirective,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: InputComponent,
                            multi: true,
                        },
                    ], host: {
                        '[class.bui-input]': 'true',
                    }, template: "<input buiValidationControl\r\n       type=\"text\"\r\n       [disabled]=\"disabled()\"\r\n       [placeholder]=\"placeholder()\"\r\n       [ngModel]=\"value()\"\r\n       (ngModelChange)=\"updateValue($event)\"/>\r\n" }]
        }], ctorParameters: () => [] });

class Html5videoDialogComponent {
    constructor() {
        this.data = inject(MAT_DIALOG_DATA, { optional: true });
        this.form = new FormGroup({
            src: new FormControl(this.data?.src ?? '', Validators.required),
            height: new FormControl(this.data?.height ?? null, Validators.min(1)),
            width: new FormControl(this.data?.width ?? null, Validators.min(1)),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: Html5videoDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: Html5videoDialogComponent, isStandalone: true, selector: "ng-component", host: { properties: { "class.bui-wysiwyg__dialog": "true" } }, ngImport: i0, template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.Html5Video.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<bui-group>
				<form [formGroup]="form"
				      buiValidationContext="bui.wysiwyg.Html5Video.dialog">
					<bui-field>
						<bui-label required>{{ 'bui.wysiwyg.Html5Video.dialog.src.label' | msgKey | async }}</bui-label>
						<bui-input formControlName="src"></bui-input>
					</bui-field>
					<bui-field>
						<bui-label>{{ 'bui.wysiwyg.Html5Video.dialog.width.label' | msgKey | async }}</bui-label>
						<bui-input-decimal formControlName="width"
						                   [precisionDigits]="0"></bui-input-decimal>
					</bui-field>
					<bui-field>
						<bui-label>{{ 'bui.wysiwyg.Html5Video.dialog.height.label' | msgKey | async }}</bui-label>
						<bui-input-decimal formControlName="height"
						                   [precisionDigits]="0"></bui-input-decimal>
					</bui-field>
				</form>
			</bui-group>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="form.invalid"
			        [bui-dialog-action]="form.value">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`, isInline: true, dependencies: [{ kind: "component", type: DialogActionsComponent, selector: "bui-dialog-actions", inputs: ["align"] }, { kind: "directive", type: DialogActionDirective, selector: "button[bui-dialog-action]", inputs: ["ariaLabel", "type", "bui-dialog-action"] }, { kind: "directive", type: DialogTitleDirective, selector: "[bui-dialog-title]" }, { kind: "component", type: DialogContentComponent, selector: "bui-dialog-content" }, { kind: "component", type: GroupComponent, selector: "bui-group", inputs: ["name", "hint"] }, { kind: "component", type: FieldComponent, selector: "bui-field", inputs: ["labelPosition"] }, { kind: "component", type: LabelComponent, selector: "bui-label", inputs: ["required", "hint"] }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: AsyncPipe, name: "async" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: InputComponent, selector: "bui-input", inputs: ["placeholder", "disabled"] }, { kind: "component", type: InputDecimalComponent, selector: "bui-input-decimal", inputs: ["disabled", "name", "precisionDigits", "minPrecisionDigits", "maxPrecisionDigits", "placeholder"] }, { kind: "directive", type: ValidationContextDirective, selector: "[buiValidationContext]", inputs: ["buiValidationContext", "unassignableErrors"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: Html5videoDialogComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.Html5Video.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<bui-group>
				<form [formGroup]="form"
				      buiValidationContext="bui.wysiwyg.Html5Video.dialog">
					<bui-field>
						<bui-label required>{{ 'bui.wysiwyg.Html5Video.dialog.src.label' | msgKey | async }}</bui-label>
						<bui-input formControlName="src"></bui-input>
					</bui-field>
					<bui-field>
						<bui-label>{{ 'bui.wysiwyg.Html5Video.dialog.width.label' | msgKey | async }}</bui-label>
						<bui-input-decimal formControlName="width"
						                   [precisionDigits]="0"></bui-input-decimal>
					</bui-field>
					<bui-field>
						<bui-label>{{ 'bui.wysiwyg.Html5Video.dialog.height.label' | msgKey | async }}</bui-label>
						<bui-input-decimal formControlName="height"
						                   [precisionDigits]="0"></bui-input-decimal>
					</bui-field>
				</form>
			</bui-group>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="form.invalid"
			        [bui-dialog-action]="form.value">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`,
                    imports: [
                        DialogActionsComponent,
                        DialogActionDirective,
                        DialogTitleDirective,
                        DialogContentComponent,
                        GroupComponent,
                        FieldComponent,
                        LabelComponent,
                        ButtonComponent,
                        MsgKeyPipe,
                        AsyncPipe,
                        ReactiveFormsModule,
                        InputComponent,
                        InputDecimalComponent,
                        ValidationContextDirective,
                    ],
                    host: {
                        '[class.bui-wysiwyg__dialog]': 'true',
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });

const Html5VideoName = 'html5video';
function getAttrs(div, options) {
    const el = div.querySelector('video');
    const src = el.getAttribute('src')
        ?.slice(options.srcPrefix.length);
    return {
        src: src,
        height: el.getAttribute('height'),
        width: el.getAttribute('width'),
    };
}
const Html5Video = (injector) => Node.create({
    name: Html5VideoName,
    group: 'block',
    addOptions() {
        return {
            srcPrefix: '',
        };
    },
    addAttributes() {
        return {
            src: {
                default: null,
            },
            height: {
                default: null,
            },
            width: {
                default: null,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'div[data-type="html5video"]',
                getAttrs: div => getAttrs(div, this.options),
            }, {
                tag: 'div.ckeditor-html5-video',
                getAttrs: div => getAttrs(div, this.options),
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        const { style, ...videoAttrs } = HTMLAttributes;
        const styles = styleAttributeToObject(style);
        const { 'text-align': textAlign, ...videoStyles } = styles;
        videoAttrs['style'] = objectToStyleAttribute(videoStyles);
        return [
            'div',
            {
                'data-type': 'html5video',
                ...(textAlign ? { style: `text-align: ${textAlign}` } : {}),
            },
            [
                'video',
                { controls: 'true', ...videoAttrs, src: this.options.srcPrefix + HTMLAttributes['src'] },
            ],
        ];
    },
    addCommands() {
        return {
            setVideo: attrs => ({ commands }) => commands.insertContent({ type: 'html5video', attrs }),
        };
    },
    addNodeView() {
        return AngularNodeViewRenderer(VideoPreviewComponent, { injector });
    },
});
class VideoPreviewComponent extends AngularNodeViewComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: VideoPreviewComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: VideoPreviewComponent, isStandalone: true, selector: "ng-component", providers: [], usesInheritance: true, ngImport: i0, template: `
		<div data-type="html5video"
		     [style.text-align]="node()['attrs']['textAlign']">
			<video [src]="extension().options.srcPrefix + node()['attrs']['src']"
			       [attr.height]="node()['attrs']['height']"
			       [attr.width]="node()['attrs']['width']"
			       [class.selected]="selected()"></video>
		</div>
	`, isInline: true, styles: ["video.selected{outline:3px solid var(--color--highlight)}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: VideoPreviewComponent, decorators: [{
            type: Component,
            args: [{ template: `
		<div data-type="html5video"
		     [style.text-align]="node()['attrs']['textAlign']">
			<video [src]="extension().options.srcPrefix + node()['attrs']['src']"
			       [attr.height]="node()['attrs']['height']"
			       [attr.width]="node()['attrs']['width']"
			       [class.selected]="selected()"></video>
		</div>
	`, encapsulation: ViewEncapsulation.None, providers: [], imports: [], styles: ["video.selected{outline:3px solid var(--color--highlight)}\n"] }]
        }] });

class MenuButtonHtml5VideoComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'HTML5Video';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'video_library';
        this.dialogService = inject(MatDialog);
        this.injector = inject(Injector);
    }
    onClick() {
        const data = this.editor()
            .getAttributes('html5video');
        this.dialogService.open(Html5videoDialogComponent, {
            panelClass: 'bui-wysiwyg__dialog',
            data: {
                ...data,
                src: data['src'] && decodeURIComponent(data['src']),
            },
            injector: this.injector,
        })
            .afterClosed()
            .pipe(filter(Boolean))
            .subscribe((data) => {
            this.editor()
                ?.chain()
                .focus()
                .setVideo(data)
                .run();
        });
    }
    isSelected() {
        return this.editor()
            .isActive(Html5VideoName);
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setVideo({ src: 'http://example.com' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonHtml5VideoComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonHtml5VideoComponent, isStandalone: true, selector: "bui-wysiwyg-html5video", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonHtml5VideoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-html5video', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const Html5VideoTool = {
    dependencies: [Html5Video],
    control: MenuButtonHtml5VideoComponent,
    optionMap: {
        [Html5VideoName]: ['srcPrefix'], // Explizite Auflistung, da Html5Video einen Injector benötigt
    },
    config: {
        [TextAlign.name]: ((config) => ({
            ...config,
            types: [...(config.types ?? []), Html5VideoName],
        })),
    },
};

class MenuButtonImageUploadComponent extends AbstractMenuButtonComponent {
    constructor() {
        super();
        this.tooltipLabel = 'ImageUpload';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'image';
        this.fileInput = viewChild.required('fileInput');
        this.config = inject(BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE)
            .config().ImageUpload;
        this.accept = this.config.accept ?? 'image/*';
        if (!this.config) {
            throw new Error('ImageUpload requires BUI_WYSIWYG_STATIC_CONFIG.ImageUpload to be provided.');
        }
    }
    onClick() {
        this.fileInput()
            .nativeElement
            .click();
    }
    isSelected() {
        return this.editor()
            .isActive(ResizableImageName);
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setImage({ src: 'http://example.com' });
    }
    onFileChange(event) {
        const files = event.target?.files;
        if (!files || !files.length) {
            return;
        }
        const images = Array.from(files);
        const attrs = this.config.onUpload(images);
        const attrsObservable = Array.isArray(attrs) ? of(attrs) : attrs;
        attrsObservable.pipe(take(1), map(attrs => attrs.filter(imageAttrs => !!imageAttrs.src)
            .map(imageAttrs => ({
            type: Image$1.name,
            attrs: imageAttrs,
        }))), catchError(() => of([])))
            .subscribe(imageContent => {
            if (!imageContent.length) {
                return;
            }
            this.editor()
                ?.chain()
                .focus()
                .insertContent(imageContent)
                .run();
            this.fileInput().nativeElement.value = '';
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonImageUploadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: MenuButtonImageUploadComponent, isStandalone: true, selector: "bui-wysiwyg-imageupload", viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true, isSignal: true }], usesInheritance: true, ngImport: i0, template: `
		<div class="bui-wysiwyg__toolbar-control"
		     [class.bui-wysiwyg__toolbar-control--active]="selected()">
			<button bui-button
			        [disabled]="disabled()"
			        [title]="(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()"
			        (throttledClick)="onClick()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		</div>
		<input #fileInput
		       type="file"
		       [accept]="accept"
		       style="display: none"
		       (change)="onFileChange($event)">`, isInline: true, dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonImageUploadComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-wysiwyg-imageupload',
                    imports: AbstractMenuButtonImports,
                    template: `
		<div class="bui-wysiwyg__toolbar-control"
		     [class.bui-wysiwyg__toolbar-control--active]="selected()">
			<button bui-button
			        [disabled]="disabled()"
			        [title]="(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()"
			        (throttledClick)="onClick()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		</div>
		<input #fileInput
		       type="file"
		       [accept]="accept"
		       style="display: none"
		       (change)="onFileChange($event)">`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [] });
const ImageUploadTool = {
    dependencies: [ResizableImage],
    conflicts: ['Base64Image'],
    control: MenuButtonImageUploadComponent,
    optionMap: {
        [ResizableImageName]: Object.getOwnPropertyNames(Image$1.options),
    },
    config: {
        [TextAlign.name]: ((config) => ({
            ...config,
            types: [...(config.types ?? []), Image$1.name],
        })),
    },
};

class MenuButtonIndentComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Indent';
        this.tooltipShortcutKeys = ['Tab'];
        this.icon = 'format_indent_increase';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .sinkListItem('listItem')
            .run();
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .sinkListItem('listItem');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonIndentComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonIndentComponent, isStandalone: true, selector: "bui-wysiwyg-indent", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonIndentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-indent', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const IndentTool = {
    dependencies: [ListItem, Paragraph],
    control: MenuButtonIndentComponent,
};

class MenuButtonItalicComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Italic';
        this.tooltipShortcutKeys = ['mod', 'I'];
        this.icon = 'format_italic';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .toggleItalic()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('italic');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleItalic();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonItalicComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonItalicComponent, isStandalone: true, selector: "bui-wysiwyg-italic", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonItalicComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-italic', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const ItalicTool = {
    dependencies: [Italic],
    control: MenuButtonItalicComponent,
    optionMap: {
        [Italic.name]: Object.getOwnPropertyNames(Italic.options),
    },
};

class JumpAnchorDialogComponent {
    constructor() {
        this.data = inject(MAT_DIALOG_DATA);
        this.form = new FormGroup({
            id: new FormControl(this.data.id, Validators.required),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: JumpAnchorDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: JumpAnchorDialogComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.JumpAnchor.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<form [formGroup]="form"
			      buiValidationContext="bui.wysiwyg.JumpAnchor.dialog">
				<bui-group>
					<bui-field>
						<bui-label required>{{ 'bui.wysiwyg.JumpAnchor.dialog.id.label' | msgKey | async }}</bui-label>
						<bui-input formControlName="id"></bui-input>
					</bui-field>
				</bui-group>
			</form>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="form.invalid"
			        [bui-dialog-action]="form.value.id">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`, isInline: true, dependencies: [{ kind: "component", type: DialogActionsComponent, selector: "bui-dialog-actions", inputs: ["align"] }, { kind: "directive", type: DialogActionDirective, selector: "button[bui-dialog-action]", inputs: ["ariaLabel", "type", "bui-dialog-action"] }, { kind: "directive", type: DialogTitleDirective, selector: "[bui-dialog-title]" }, { kind: "component", type: DialogContentComponent, selector: "bui-dialog-content" }, { kind: "component", type: GroupComponent, selector: "bui-group", inputs: ["name", "hint"] }, { kind: "component", type: FieldComponent, selector: "bui-field", inputs: ["labelPosition"] }, { kind: "component", type: LabelComponent, selector: "bui-label", inputs: ["required", "hint"] }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: InputComponent, selector: "bui-input", inputs: ["placeholder", "disabled"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: ValidationContextDirective, selector: "[buiValidationContext]", inputs: ["buiValidationContext", "unassignableErrors"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: JumpAnchorDialogComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.JumpAnchor.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<form [formGroup]="form"
			      buiValidationContext="bui.wysiwyg.JumpAnchor.dialog">
				<bui-group>
					<bui-field>
						<bui-label required>{{ 'bui.wysiwyg.JumpAnchor.dialog.id.label' | msgKey | async }}</bui-label>
						<bui-input formControlName="id"></bui-input>
					</bui-field>
				</bui-group>
			</form>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="form.invalid"
			        [bui-dialog-action]="form.value.id">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`,
                    imports: [
                        DialogActionsComponent,
                        DialogActionDirective,
                        DialogTitleDirective,
                        DialogContentComponent,
                        GroupComponent,
                        FieldComponent,
                        LabelComponent,
                        ButtonComponent,
                        InputComponent,
                        ReactiveFormsModule,
                        ValidationContextDirective,
                        MsgKeyPipe,
                        AsyncPipe,
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });

const JumpAnchor = Node.create({
    name: 'jumpAnchor',
    group: 'inline',
    inline: true,
    atom: true,
    selectable: true,
    draggable: true,
    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('id'),
                renderHTML: attributes => {
                    if (!attributes['id']) {
                        return {};
                    }
                    return { 'id': attributes['id'] };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span[data-type="jumpAnchor"]',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(HTMLAttributes, { 'data-type': 'jumpAnchor' })];
    },
    addCommands() {
        return {
            setJumpAnchor: (attrs) => ({ editor, commands, state }) => {
                if (editor.isActive(this.name)) {
                    // If a jumpAnchor is already active/selected, update its attributes.
                    return commands.updateAttributes(this.name, attrs);
                }
                else {
                    // If not active, we are inserting a new jumpAnchor node.
                    // If there's a text selection, collapse it to its start point
                    // to prevent the jumpAnchor from replacing the selected text.
                    if (!state.selection.empty && !(state.selection instanceof NodeSelection)) {
                        commands.setTextSelection(state.selection.from);
                    }
                    return commands.insertContent({
                        type: this.name,
                        attrs,
                    });
                }
            },
        };
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('jumpAnchorDecorations'),
                props: {
                    decorations: ({ doc }) => {
                        const decorations = [];
                        doc.descendants((node, pos) => {
                            if (node.type.name !== this.name) {
                                return;
                            }
                            const nodeId = node.attrs['id'];
                            const toDOM = (view) => {
                                const widget = document.createElement('span');
                                widget.className = 'jump-anchor-widget proseMirror-widget';
                                widget.setAttribute('contenteditable', 'false');
                                widget.setAttribute('spellcheck', 'false');
                                const icon = document.createElement('span');
                                icon.className = 'material-icons mat-ligature-font';
                                icon.textContent = 'anchor';
                                widget.appendChild(icon);
                                const idTextSpan = document.createElement('span');
                                idTextSpan.textContent = `-ID: ${node.attrs['id']}`;
                                widget.appendChild(idTextSpan);
                                const createHandler = (preventDefault) => (event) => {
                                    if (preventDefault) {
                                        // Verhindert, dass der Cursor nach dem Klick hinter das Widget springt,
                                        // würde aber auch drag&drop verhindern
                                        event.preventDefault();
                                        event.stopPropagation();
                                    }
                                    const selection = NodeSelection.create(view.state.doc, pos);
                                    view.dispatch(view.state.tr.setSelection(selection));
                                    if (!view.hasFocus()) {
                                        view.focus();
                                    }
                                };
                                // Selektiert bei mousedown die echte Node für Drag&Drop
                                widget.addEventListener('mousedown', createHandler(false));
                                // Selektiert beim Klick die echte Node
                                widget.addEventListener('click', createHandler(true));
                                return widget;
                            };
                            decorations.push(Decoration.widget(pos + 1, toDOM, {
                                key: `jump-anchor-${nodeId || 'new'}-${pos}`,
                                side: -1,
                            }));
                        });
                        return DecorationSet.create(doc, decorations);
                    },
                },
            }),
        ];
    },
});

class MenuButtonJumpAnchorComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'JumpAnchor';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'anchor';
        this.dialogService = inject(MatDialog);
        this.injector = inject(Injector);
    }
    onClick() {
        const editor = this.editor();
        const oldId = editor.isActive('jumpAnchor')
            ? editor.getAttributes('jumpAnchor')['id']
            : null;
        this.dialogService.open(JumpAnchorDialogComponent, {
            data: { id: oldId },
            panelClass: 'bui-wysiwyg__dialog',
            injector: this.injector,
        })
            .afterClosed()
            .pipe(filter(Boolean))
            .subscribe((id) => {
            const currentEditorState = editor.state;
            const currentSelection = currentEditorState.selection;
            const chain = editor.chain()
                .setJumpAnchor({ id })
                .focus();
            if (oldId !== null) {
                const nodePos = currentSelection.from;
                const nodeSize = currentSelection.node.nodeSize;
                chain.setTextSelection(nodePos + nodeSize);
            }
            chain.run();
        });
    }
    isSelected() {
        return this.editor()
            .isActive(JumpAnchor.name);
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setJumpAnchor({ id: 'test' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJumpAnchorComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonJumpAnchorComponent, isStandalone: true, selector: "bui-wysiwyg-jumpanchor", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJumpAnchorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-jumpanchor', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const JumpAnchorTool = {
    dependencies: [JumpAnchor],
    control: MenuButtonJumpAnchorComponent,
};

class MenuButtonJustifyBlockComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'JustifyBlock';
        this.tooltipShortcutKeys = ['mod', 'Shift', 'J'];
        this.icon = 'format_align_justify';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .setTextAlign('justify')
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive({ textAlign: 'justify' });
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setTextAlign('justify');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJustifyBlockComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonJustifyBlockComponent, isStandalone: true, selector: "bui-wysiwyg-justifyblock", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJustifyBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-justifyblock', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const JustifyBlockTool = {
    dependencies: [TextAlign],
    control: MenuButtonJustifyBlockComponent,
    config: {
        [TextAlign.name]: ((config) => ({
            ...config,
            alignments: [...(config.alignments ?? []), 'justify'],
        })),
    },
};

class MenuButtonJustifyCenterComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'JustifyCenter';
        this.tooltipShortcutKeys = ['mod', 'Shift', 'E'];
        this.icon = 'format_align_center';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .setTextAlign('center')
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive({ textAlign: 'center' });
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setTextAlign('center');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJustifyCenterComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonJustifyCenterComponent, isStandalone: true, selector: "bui-wysiwyg-justifycenter", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJustifyCenterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-justifycenter', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const JustifyCenterTool = {
    dependencies: [TextAlign],
    control: MenuButtonJustifyCenterComponent,
    config: {
        [TextAlign.name]: ((config) => ({
            ...config,
            alignments: [...(config.alignments ?? []), 'center'],
        })),
    },
};

class MenuButtonJustifyLeftComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'JustifyLeft';
        this.tooltipShortcutKeys = ['mod', 'Shift', 'L'];
        this.icon = 'format_align_left';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .setTextAlign('left')
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive({ textAlign: 'left' });
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setTextAlign('left');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJustifyLeftComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonJustifyLeftComponent, isStandalone: true, selector: "bui-wysiwyg-justifyleft", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJustifyLeftComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-justifyleft', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const JustifyLeftTool = {
    dependencies: [TextAlign],
    control: MenuButtonJustifyLeftComponent,
    config: {
        [TextAlign.name]: ((config) => ({
            ...config,
            alignments: [...(config.alignments ?? []), 'left'],
        })),
    },
};

class MenuButtonJustifyRightComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'JustifyRight';
        this.tooltipShortcutKeys = ['mod', 'Shift', 'R'];
        this.icon = 'format_align_right';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .setTextAlign('right')
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive({ textAlign: 'right' });
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setTextAlign('right');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJustifyRightComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonJustifyRightComponent, isStandalone: true, selector: "bui-wysiwyg-justifyright", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonJustifyRightComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-justifyright', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const JustifyRightTool = {
    dependencies: [TextAlign],
    control: MenuButtonJustifyRightComponent,
    config: {
        [TextAlign.name]: ((config) => ({
            ...config,
            alignments: [...(config.alignments ?? []), 'right'],
        })),
    },
};

class LinkDialogComponent {
    constructor() {
        this.data = inject(MAT_DIALOG_DATA);
        this.form = new FormGroup({
            displayText: new FormControl(this.data.displayText),
            type: new FormControl(this.data.type ?? 'url'),
            url: new FormControl(this.data.url, Validators.required),
            target: new FormControl(this.data.target ?? ''),
        });
        const anchorList = document.querySelectorAll('.bui-wysiwyg span[data-type="jumpAnchor"]');
        const anchors = [];
        anchorList.forEach(anchor => {
            anchors.push({
                value: `#${anchor.id}`,
                label: anchor.id,
            });
        });
        this.anchors = anchors;
        this.form.get('type')
            ?.valueChanges
            .pipe(takeUntilDestroyed())
            .subscribe(() => {
            this.form.patchValue({
                url: '',
                target: '',
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: LinkDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: LinkDialogComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.Link.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<form [formGroup]="form"
			      buiValidationContext="bui.wysiwyg.Link.dialog">
				<bui-group>
					<bui-field labelPosition="top">
						<bui-label>{{ 'bui.wysiwyg.Link.dialog.displayText.label' | msgKey | async }}</bui-label>
						<bui-input formControlName="displayText"></bui-input>
					</bui-field>
					<bui-field labelPosition="top">
						<bui-label required>{{ 'bui.wysiwyg.Link.dialog.type.label' | msgKey | async }}</bui-label>
						<bui-select formControlName="type"
						            class="col-fill"
						            [searchable]="false"
						            [items]="[
							{ value: 'url', label: 'bui.wysiwyg.Link.dialog.type.url.label' | msgKey | async },
							{ value: 'anchor', label: 'bui.wysiwyg.Link.dialog.type.anchor.label' | msgKey | async },
						]"></bui-select>
					</bui-field>
					@switch (form.value.type) {
						@case ('anchor') {
							<bui-field labelPosition="top">
								<bui-label required>{{ 'bui.wysiwyg.Link.dialog.anchor.label' | msgKey | async }}</bui-label>
								<bui-select formControlName="url"
								            class="col-fill"
								            [items]="anchors"></bui-select>
							</bui-field>
						}
						@default {
							<bui-field labelPosition="top">
								<bui-label required>{{ 'bui.wysiwyg.Link.dialog.url.label' | msgKey | async }}</bui-label>
								<bui-input formControlName="url"></bui-input>
							</bui-field>
							<bui-field labelPosition="top">
								<bui-label>{{ 'bui.wysiwyg.Link.dialog.target.label' | msgKey | async }}</bui-label>
								<bui-select formControlName="target"
								            class="col-fill"
								            [searchable]="false"
								            [items]="[
									{ value: '', label: 'bui.wysiwyg.Link.dialog.target.default.label' | msgKey | async },
									{ value: '_self', label: 'bui.wysiwyg.Link.dialog.target.self.label' | msgKey | async },
									{ value: '_blank', label: 'bui.wysiwyg.Link.dialog.target.blank.label' | msgKey | async },
								]"></bui-select>
							</bui-field>
						}
					}
				</bui-group>
			</form>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="form.invalid"
			        [bui-dialog-action]="form.value">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`, isInline: true, dependencies: [{ kind: "component", type: DialogActionsComponent, selector: "bui-dialog-actions", inputs: ["align"] }, { kind: "directive", type: DialogActionDirective, selector: "button[bui-dialog-action]", inputs: ["ariaLabel", "type", "bui-dialog-action"] }, { kind: "directive", type: DialogTitleDirective, selector: "[bui-dialog-title]" }, { kind: "component", type: DialogContentComponent, selector: "bui-dialog-content" }, { kind: "component", type: GroupComponent, selector: "bui-group", inputs: ["name", "hint"] }, { kind: "component", type: FieldComponent, selector: "bui-field", inputs: ["labelPosition"] }, { kind: "component", type: LabelComponent, selector: "bui-label", inputs: ["required", "hint"] }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: InputComponent, selector: "bui-input", inputs: ["placeholder", "disabled"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: ValidationContextDirective, selector: "[buiValidationContext]", inputs: ["buiValidationContext", "unassignableErrors"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: AsyncPipe, name: "async" }, { kind: "component", type: SelectComponent, selector: "bui-select", inputs: ["items", "valueKey", "labelKey", "placeholder", "clearable", "searchable", "multiple", "disabled", "groupBy"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: LinkDialogComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.Link.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<form [formGroup]="form"
			      buiValidationContext="bui.wysiwyg.Link.dialog">
				<bui-group>
					<bui-field labelPosition="top">
						<bui-label>{{ 'bui.wysiwyg.Link.dialog.displayText.label' | msgKey | async }}</bui-label>
						<bui-input formControlName="displayText"></bui-input>
					</bui-field>
					<bui-field labelPosition="top">
						<bui-label required>{{ 'bui.wysiwyg.Link.dialog.type.label' | msgKey | async }}</bui-label>
						<bui-select formControlName="type"
						            class="col-fill"
						            [searchable]="false"
						            [items]="[
							{ value: 'url', label: 'bui.wysiwyg.Link.dialog.type.url.label' | msgKey | async },
							{ value: 'anchor', label: 'bui.wysiwyg.Link.dialog.type.anchor.label' | msgKey | async },
						]"></bui-select>
					</bui-field>
					@switch (form.value.type) {
						@case ('anchor') {
							<bui-field labelPosition="top">
								<bui-label required>{{ 'bui.wysiwyg.Link.dialog.anchor.label' | msgKey | async }}</bui-label>
								<bui-select formControlName="url"
								            class="col-fill"
								            [items]="anchors"></bui-select>
							</bui-field>
						}
						@default {
							<bui-field labelPosition="top">
								<bui-label required>{{ 'bui.wysiwyg.Link.dialog.url.label' | msgKey | async }}</bui-label>
								<bui-input formControlName="url"></bui-input>
							</bui-field>
							<bui-field labelPosition="top">
								<bui-label>{{ 'bui.wysiwyg.Link.dialog.target.label' | msgKey | async }}</bui-label>
								<bui-select formControlName="target"
								            class="col-fill"
								            [searchable]="false"
								            [items]="[
									{ value: '', label: 'bui.wysiwyg.Link.dialog.target.default.label' | msgKey | async },
									{ value: '_self', label: 'bui.wysiwyg.Link.dialog.target.self.label' | msgKey | async },
									{ value: '_blank', label: 'bui.wysiwyg.Link.dialog.target.blank.label' | msgKey | async },
								]"></bui-select>
							</bui-field>
						}
					}
				</bui-group>
			</form>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="form.invalid"
			        [bui-dialog-action]="form.value">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`,
                    imports: [
                        DialogActionsComponent,
                        DialogActionDirective,
                        DialogTitleDirective,
                        DialogContentComponent,
                        GroupComponent,
                        FieldComponent,
                        LabelComponent,
                        ButtonComponent,
                        InputComponent,
                        ReactiveFormsModule,
                        ValidationContextDirective,
                        MsgKeyPipe,
                        AsyncPipe,
                        SelectComponent,
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [] });

class MenuButtonLinkComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Link';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'link';
        this.dialogService = inject(MatDialog);
        this.injector = inject(Injector);
    }
    onClick() {
        const editor = this.editor();
        const isLink = editor.isActive('link');
        const url = isLink
            ? editor.getAttributes('link')['href']
            : '';
        const target = isLink
            ? editor.getAttributes('link')['target']
            : '';
        const type = url.startsWith('#') ? 'anchor' : 'url';
        const linkRange = getMarkRange(editor.state.selection.$from, getMarkType('link', editor.schema));
        const linkText = linkRange
            ? editor.state.doc.textBetween(linkRange.from, linkRange.to)
            : '';
        const getSelectedText = () => editor.state.doc.textBetween(editor.state.selection.$from.pos, editor.state.selection.$to.pos);
        const displayText = linkText || getSelectedText();
        this.dialogService.open(LinkDialogComponent, {
            data: {
                displayText,
                type,
                url,
                target,
            },
            panelClass: 'bui-wysiwyg__dialog',
            injector: this.injector,
        })
            .afterClosed()
            .pipe(filter(Boolean))
            .subscribe((linkData) => {
            const displayText = linkData.displayText || linkData.url;
            const isAnchor = linkData.type === 'anchor';
            let href = linkData.url;
            if (href &&
                !isAnchor &&
                !href.includes('://') &&
                !href.startsWith('mailto:') &&
                !href.startsWith('tel:')) {
                href = `http://${href}`;
            }
            const target = isAnchor ? '_self' : (linkData.target === '' ? undefined : linkData.target);
            const attrs = { href, target };
            editor
                .chain()
                // Make sure if we're updating a link, we update the link for the
                // full link "mark"
                .extendMarkRange('link')
                // Update the link href and its text content
                .insertContent({
                type: 'text',
                marks: [
                    {
                        type: 'link',
                        attrs,
                    },
                ],
                text: displayText,
            })
                // Note that as of "@tiptap/extension-link" 2.0.0-beta.37 when
                // `autolink` is on (which we want), adding the link mark directly
                // via `insertContent` above wasn't sufficient for the link mark to
                // be applied (though specifying it above is still necessary), so we
                // insert the content there and call `setLink` separately here.
                // Unclear why this separate command is necessary, but it does the
                // trick.
                .setLink(attrs)
                // Place the cursor at the end of the link (which requires "focus"
                // to take effect)
                .focus()
                .run();
        });
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setLink({ href: 'http://example.com' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonLinkComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonLinkComponent, isStandalone: true, selector: "bui-wysiwyg-link", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-link', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const LinkTool = {
    dependencies: [Link],
    control: MenuButtonLinkComponent,
    config: {
        [Link.name]: ((config) => ({
            ...config,
            openOnClick: false,
        })),
    },
    optionMap: {
        [Link.name]: Object.getOwnPropertyNames(Link.options),
    },
};

class MenuButtonNumberedListComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'NumberedList';
        this.tooltipShortcutKeys = ['mod', 'Shift', '7'];
        this.icon = 'format_list_numbered';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .toggleOrderedList()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('orderedList');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleOrderedList();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonNumberedListComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonNumberedListComponent, isStandalone: true, selector: "bui-wysiwyg-numberedlist", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonNumberedListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-numberedlist', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const NumberedListTool = {
    dependencies: [OrderedList, ListItem, Paragraph],
    control: MenuButtonNumberedListComponent,
    optionMap: {
        [OrderedList.name]: Object.fromEntries(Object.getOwnPropertyNames(OrderedList.options)
            .map(option => [option, option === 'HTMLAttributes' ? 'orderedListHTMLAttributes' : option])),
        [ListItem.name]: Object.fromEntries(Object.getOwnPropertyNames(ListItem.options)
            .map(option => [option, option === 'HTMLAttributes' ? 'listItemHTMLAttributes' : option])),
    },
};

class OembedDialogComponent {
    constructor() {
        this.data = inject(MAT_DIALOG_DATA, { optional: true });
        this.form = new FormGroup({
            src: new FormControl(this.data?.src ?? '', [Validators.required, youtubeValidator]),
            height: new FormControl(this.data?.height ?? null, Validators.min(1)),
            width: new FormControl(this.data?.width ?? null, Validators.min(1)),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: OembedDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: OembedDialogComponent, isStandalone: true, selector: "ng-component", host: { properties: { "class.bui-wysiwyg__dialog": "true" } }, ngImport: i0, template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.Oembed.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<bui-group>
				<form [formGroup]="form"
				      buiValidationContext="bui.wysiwyg.Oembed.dialog">
					<bui-field>
						<bui-label required>{{ 'bui.wysiwyg.Oembed.dialog.src.label' | msgKey | async }}</bui-label>
						<bui-input formControlName="src"></bui-input>
					</bui-field>
					<bui-field>
						<bui-label>{{ 'bui.wysiwyg.Oembed.dialog.width.label' | msgKey | async }}</bui-label>
						<bui-input-decimal formControlName="width"
						                   [precisionDigits]="0"></bui-input-decimal>
					</bui-field>
					<bui-field>
						<bui-label>{{ 'bui.wysiwyg.Oembed.dialog.height.label' | msgKey | async }}</bui-label>
						<bui-input-decimal formControlName="height"
						                   [precisionDigits]="0"></bui-input-decimal>
					</bui-field>
				</form>
			</bui-group>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="form.invalid"
			        [bui-dialog-action]="form.value">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`, isInline: true, dependencies: [{ kind: "component", type: DialogActionsComponent, selector: "bui-dialog-actions", inputs: ["align"] }, { kind: "directive", type: DialogActionDirective, selector: "button[bui-dialog-action]", inputs: ["ariaLabel", "type", "bui-dialog-action"] }, { kind: "directive", type: DialogTitleDirective, selector: "[bui-dialog-title]" }, { kind: "component", type: DialogContentComponent, selector: "bui-dialog-content" }, { kind: "component", type: GroupComponent, selector: "bui-group", inputs: ["name", "hint"] }, { kind: "component", type: FieldComponent, selector: "bui-field", inputs: ["labelPosition"] }, { kind: "component", type: LabelComponent, selector: "bui-label", inputs: ["required", "hint"] }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: AsyncPipe, name: "async" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: InputComponent, selector: "bui-input", inputs: ["placeholder", "disabled"] }, { kind: "component", type: InputDecimalComponent, selector: "bui-input-decimal", inputs: ["disabled", "name", "precisionDigits", "minPrecisionDigits", "maxPrecisionDigits", "placeholder"] }, { kind: "directive", type: ValidationContextDirective, selector: "[buiValidationContext]", inputs: ["buiValidationContext", "unassignableErrors"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: OembedDialogComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.Oembed.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<bui-group>
				<form [formGroup]="form"
				      buiValidationContext="bui.wysiwyg.Oembed.dialog">
					<bui-field>
						<bui-label required>{{ 'bui.wysiwyg.Oembed.dialog.src.label' | msgKey | async }}</bui-label>
						<bui-input formControlName="src"></bui-input>
					</bui-field>
					<bui-field>
						<bui-label>{{ 'bui.wysiwyg.Oembed.dialog.width.label' | msgKey | async }}</bui-label>
						<bui-input-decimal formControlName="width"
						                   [precisionDigits]="0"></bui-input-decimal>
					</bui-field>
					<bui-field>
						<bui-label>{{ 'bui.wysiwyg.Oembed.dialog.height.label' | msgKey | async }}</bui-label>
						<bui-input-decimal formControlName="height"
						                   [precisionDigits]="0"></bui-input-decimal>
					</bui-field>
				</form>
			</bui-group>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="form.invalid"
			        [bui-dialog-action]="form.value">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`,
                    imports: [
                        DialogActionsComponent,
                        DialogActionDirective,
                        DialogTitleDirective,
                        DialogContentComponent,
                        GroupComponent,
                        FieldComponent,
                        LabelComponent,
                        ButtonComponent,
                        MsgKeyPipe,
                        AsyncPipe,
                        ReactiveFormsModule,
                        InputComponent,
                        InputDecimalComponent,
                        ValidationContextDirective,
                    ],
                    host: {
                        '[class.bui-wysiwyg__dialog]': 'true',
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });
const youtubeValidator = (control) => {
    let src = control.value;
    if (!src?.length) {
        return null;
    }
    if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('//')) {
        src = src.slice(src.indexOf('//') + 2);
    }
    if (src.startsWith('www.')) {
        src = src.slice(4);
    }
    if (src.startsWith('youtube.com/watch?v=')) {
        return null;
    }
    if (src.startsWith('youtu.be/')) {
        return null;
    }
    if (src.startsWith('youtube-nocookie.com')) {
        return null;
    }
    return {
        youtube: true,
    };
};

const Oembed = Youtube.extend({
    name: 'oembed',
    parseHTML() {
        return [
            {
                tag: 'div[data-type="oembed"] iframe',
            }, {
                tag: 'div[data-oembed_provider="youtube"] iframe',
            },
        ];
    },
    renderHTML(props) {
        if (props.HTMLAttributes['width'] === null) {
            delete props.HTMLAttributes['width'];
        }
        if (props.HTMLAttributes['height'] === null) {
            delete props.HTMLAttributes['height'];
        }
        const style = props.HTMLAttributes['style'];
        const styles = styleAttributeToObject(style);
        // @ts-ignore
        const outputSpec = [...this.parent(props)];
        outputSpec[1] = { 'data-type': 'oembed' };
        if (styles['text-align']) {
            outputSpec[1].style = `text-align: ${styles['text-align']}`;
        }
        outputSpec[2][1] = Object.fromEntries(Object.entries(outputSpec[2][1])
            .filter(([key, value]) => IFRAME_ATTRIBUTES.includes(key)));
        return outputSpec;
    },
});
const IFRAME_ATTRIBUTES = ['width', 'height', 'allowfullscreen', 'src', 'style'];

class MenuButtonOembedComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Oembed';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'ondemand_video';
        this.dialogService = inject(MatDialog);
        this.injector = inject(Injector);
    }
    onClick() {
        this.dialogService.open(OembedDialogComponent, {
            panelClass: 'bui-wysiwyg__dialog',
            data: this.editor()
                .getAttributes('oembed'),
            injector: this.injector,
        })
            .afterClosed()
            .pipe(filter(Boolean))
            .subscribe((data) => {
            if (data.height && !data.width) {
                data.width = Math.round(16 / 9 * data.height);
            }
            if (data.width && !data.height) {
                data.height = Math.round(9 / 16 * data.width);
            }
            this.editor()
                .chain()
                .focus()
                .setYoutubeVideo(data)
                .run();
        });
    }
    isSelected() {
        return this.editor()
            .isActive(Oembed.name);
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setYoutubeVideo({ src: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonOembedComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonOembedComponent, isStandalone: true, selector: "bui-wysiwyg-oembed", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonOembedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-oembed', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
// Das OembedTool kann aktuell nur Youtube, aber heißt schon mal Oembed, damit wir an der einbindendedn Stelle nichts/weniger
// anpassen müssen, falls wir das Tool erweitern.
const OembedTool = {
    dependencies: [Oembed],
    control: MenuButtonOembedComponent,
    optionMap: {
        [Oembed.name]: Object.getOwnPropertyNames(Oembed.options),
    },
    config: {
        [TextAlign.name]: ((config) => ({
            ...config,
            types: [...(config.types ?? []), Oembed.name],
        })),
    },
};

class MenuButtonOutdentComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Outdent';
        this.tooltipShortcutKeys = ['Shift', 'Tab'];
        this.icon = 'format_indent_decrease';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .liftListItem('listItem')
            .run();
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .liftListItem('listItem');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonOutdentComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonOutdentComponent, isStandalone: true, selector: "bui-wysiwyg-outdent", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonOutdentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-outdent', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const OutdentTool = {
    dependencies: [ListItem, Paragraph],
    control: MenuButtonOutdentComponent,
};

class PlaceholderDialogComponent {
    constructor() {
        this.data = inject(MAT_DIALOG_DATA);
        this.config = inject(BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE)
            .config().Placeholder;
        this.placeholders = this.config?.placeholders ?? {};
        this.placeholderEntries = Object.entries(this.placeholders ?? {})
            .map(([key, value]) => ({ key, value }));
        this.selected = signal(new Set(this.data.ids ?? []));
        this.value = computed(() => ({
            ids: this.selected(),
        }));
        if (!this.config?.placeholders) {
            throw new Error('ImageUpload requires BUI_WYSIWYG_STATIC_CONFIG.ImageUpload to be provided.');
        }
    }
    toggle(id) {
        this.selected.update(value => {
            const newValue = new Set(value);
            if (newValue.has(id)) {
                newValue.delete(id);
            }
            else {
                newValue.add(id);
            }
            return newValue;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: PlaceholderDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: PlaceholderDialogComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.Placeholder.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<bui-group style="width: min-content;">
				<bui-field>
					<p class="col-fill">{{ 'bui.wysiwyg.Placeholder.dialog.description' | msgKey | async }}</p>
				</bui-field>
				<bui-field>
					<div class="bui-wysiwyg__placeholder-list">
						@for (placeholder of placeholderEntries; track placeholder.key) {
							<div class="bui-wysiwyg__placeholder-option"
							     [class.bui-wysiwyg__placeholder-option--selected]="selected().has(placeholder.key)"
							     (click)="toggle(placeholder.key)">
								<b>{{ placeholder.value.label }}</b><br>
								{{ placeholder.value.title }}
							</div>
						}
					</div>
				</bui-field>
				<bui-field labelPosition="top">
					<bui-label>{{ 'bui.wysiwyg.Placeholder.dialog.selected' | msgKey | async }}</bui-label>
					<div class="bui-row">
						@for (value of selected(); track value) {
							<span class="bui-wysiwyg__placeholder--selected">&lt;&lt;&nbsp;{{ placeholders[value]?.label }}&nbsp;&gt;&gt;</span>
						} @empty {
							<p>{{ 'bui.wysiwyg.Placeholder.dialog.selected.none' | msgKey | async }}</p>
						}
					</div>
				</bui-field>
			</bui-group>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="!selected().size"
			        [bui-dialog-action]="value()">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`, isInline: true, styles: [".bui-wysiwyg__placeholder-list{width:600px;display:grid;grid-template-columns:repeat(2,1fr);grid-auto-rows:auto;column-gap:10px;row-gap:5px;border:1px solid var(--color--highlight);padding:4px;max-height:400px;overflow-y:auto}.bui-wysiwyg__placeholder-option{border:1px solid var(--color--layout--tertiary);padding:4px;line-height:1.2;cursor:pointer}.bui-wysiwyg__placeholder-option--selected{border-color:var(--color--highlight);color:var(--color--highlight)}.bui-wysiwyg__placeholder--selected{background:var(--button--default--background-color);color:var(--button--default--font-color);padding:1px 2px;line-height:1.5;white-space:nowrap}\n"], dependencies: [{ kind: "component", type: DialogActionsComponent, selector: "bui-dialog-actions", inputs: ["align"] }, { kind: "directive", type: DialogActionDirective, selector: "button[bui-dialog-action]", inputs: ["ariaLabel", "type", "bui-dialog-action"] }, { kind: "directive", type: DialogTitleDirective, selector: "[bui-dialog-title]" }, { kind: "component", type: DialogContentComponent, selector: "bui-dialog-content" }, { kind: "component", type: GroupComponent, selector: "bui-group", inputs: ["name", "hint"] }, { kind: "component", type: FieldComponent, selector: "bui-field", inputs: ["labelPosition"] }, { kind: "component", type: LabelComponent, selector: "bui-label", inputs: ["required", "hint"] }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: PlaceholderDialogComponent, decorators: [{
            type: Component,
            args: [{ template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.Placeholder.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<bui-group style="width: min-content;">
				<bui-field>
					<p class="col-fill">{{ 'bui.wysiwyg.Placeholder.dialog.description' | msgKey | async }}</p>
				</bui-field>
				<bui-field>
					<div class="bui-wysiwyg__placeholder-list">
						@for (placeholder of placeholderEntries; track placeholder.key) {
							<div class="bui-wysiwyg__placeholder-option"
							     [class.bui-wysiwyg__placeholder-option--selected]="selected().has(placeholder.key)"
							     (click)="toggle(placeholder.key)">
								<b>{{ placeholder.value.label }}</b><br>
								{{ placeholder.value.title }}
							</div>
						}
					</div>
				</bui-field>
				<bui-field labelPosition="top">
					<bui-label>{{ 'bui.wysiwyg.Placeholder.dialog.selected' | msgKey | async }}</bui-label>
					<div class="bui-row">
						@for (value of selected(); track value) {
							<span class="bui-wysiwyg__placeholder--selected">&lt;&lt;&nbsp;{{ placeholders[value]?.label }}&nbsp;&gt;&gt;</span>
						} @empty {
							<p>{{ 'bui.wysiwyg.Placeholder.dialog.selected.none' | msgKey | async }}</p>
						}
					</div>
				</bui-field>
			</bui-group>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
			<button bui-button
			        color="primary"
			        [disabled]="!selected().size"
			        [bui-dialog-action]="value()">{{ 'bui.button.ok' | msgKey | async }}
			</button>
		</bui-dialog-actions>`, imports: [
                        DialogActionsComponent,
                        DialogActionDirective,
                        DialogTitleDirective,
                        DialogContentComponent,
                        GroupComponent,
                        FieldComponent,
                        LabelComponent,
                        ButtonComponent,
                        ReactiveFormsModule,
                        MsgKeyPipe,
                        AsyncPipe,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, styles: [".bui-wysiwyg__placeholder-list{width:600px;display:grid;grid-template-columns:repeat(2,1fr);grid-auto-rows:auto;column-gap:10px;row-gap:5px;border:1px solid var(--color--highlight);padding:4px;max-height:400px;overflow-y:auto}.bui-wysiwyg__placeholder-option{border:1px solid var(--color--layout--tertiary);padding:4px;line-height:1.2;cursor:pointer}.bui-wysiwyg__placeholder-option--selected{border-color:var(--color--highlight);color:var(--color--highlight)}.bui-wysiwyg__placeholder--selected{background:var(--button--default--background-color);color:var(--button--default--font-color);padding:1px 2px;line-height:1.5;white-space:nowrap}\n"] }]
        }], ctorParameters: () => [] });

const PlaceholderName = 'placeholder';
function startsWithPunctation(str) {
    return '.,;!?"\''.split('')
        .some(char => str.startsWith(char));
}
const Placeholder = (injector) => Node.create({
    name: PlaceholderName,
    draggable: true,
    group: 'inline',
    inline: true,
    selectable: true,
    atom: true,
    addOptions() {
        return {
            placeholders: {},
            delimiter: '$',
        };
    },
    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('data-id'),
                renderHTML: attributes => attributes['id'] ? { 'data-id': attributes['id'] } : {},
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: `span[data-type="${this.name}"]`,
            },
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        const attributes = mergeAttributes({ 'data-type': this.name }, HTMLAttributes);
        return [
            'span',
            attributes,
            `${this.options.delimiter}${node.attrs['id']}${this.options.delimiter}`,
        ];
    },
    addNodeView() {
        return AngularNodeViewRenderer(PlaceholderComponent, { injector });
    },
    addCommands() {
        return {
            setPlaceholders: (options) => ({ commands, state }) => {
                let { from, to } = state.selection;
                const prevNode = state.selection.$from.nodeBefore;
                const nextNode = state.selection.$to.nodeAfter;
                const addSpaceBefore = prevNode?.text && !prevNode.text.endsWith(' ');
                const replaceSpaceAfter = nextNode?.text?.startsWith(' ');
                const addSpaceAfter = replaceSpaceAfter || !nextNode?.text || !startsWithPunctation(nextNode.text);
                const contents = [];
                let isFirst = true;
                if (addSpaceBefore) {
                    contents.push({
                        type: 'text',
                        text: ' ',
                    });
                }
                options.ids.forEach(id => {
                    if (!isFirst) {
                        contents.push({
                            type: 'text',
                            text: ' ',
                        });
                    }
                    contents.push({
                        type: this.name,
                        attrs: { id },
                    });
                    isFirst = false;
                });
                if (addSpaceAfter) {
                    contents.push({
                        type: 'text',
                        text: ' ',
                    });
                }
                if (replaceSpaceAfter) {
                    // Cursor hinter das folgende Leerzeichen platzieren
                    to++;
                }
                return commands.insertContentAt({ from, to }, contents);
            },
        };
    },
});
class PlaceholderComponent extends AngularNodeViewComponent {
    constructor() {
        super(...arguments);
        this.dialogService = inject(MatDialog);
    }
    onDblclick() {
        this.dialogService.open(PlaceholderDialogComponent, {
            data: {
                ids: new Set([this.node().attrs['id']]),
                editor: this.editor(),
            },
        })
            .afterClosed()
            .pipe(filter(Boolean))
            .subscribe(({ ids }) => {
            if (!ids?.size) {
                return;
            }
            this.editor()
                .chain()
                .focus()
                .setPlaceholders({ ids })
                .run();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: PlaceholderComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: PlaceholderComponent, isStandalone: true, selector: "bui-wysiwyg-template-placeholder", host: { listeners: { "dblclick": "onDblclick()" }, properties: { "class.selected": "selected()", "title": "extension()[\"options\"][\"placeholders\"][node()[\"attrs\"][\"id\"]][\"title\"]" } }, usesInheritance: true, ngImport: i0, template: `<span tiptapDraggable>&lt;&lt; {{ extension()['options']['placeholders'][node()['attrs']['id']]['label'] }} &gt;&gt;</span>`, isInline: true, styles: [":host{background:var(--button--default--background-color);color:var(--button--default--font-color);padding:1px 2px;line-height:1.5}:host span{white-space:nowrap}:host.selected{background:var(--button--primary--background-color);color:var(--button--primary--font-color)}\n"], dependencies: [{ kind: "directive", type: TiptapDraggableDirective, selector: "[tiptapDraggable]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: PlaceholderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-template-placeholder', template: `<span tiptapDraggable>&lt;&lt; {{ extension()['options']['placeholders'][node()['attrs']['id']]['label'] }} &gt;&gt;</span>`, imports: [
                        TiptapDraggableDirective,
                    ], host: {
                        '[class.selected]': 'selected()',
                        '[title]': 'extension()["options"]["placeholders"][node()["attrs"]["id"]]["title"]',
                        '(dblclick)': 'onDblclick()',
                    }, styles: [":host{background:var(--button--default--background-color);color:var(--button--default--font-color);padding:1px 2px;line-height:1.5}:host span{white-space:nowrap}:host.selected{background:var(--button--primary--background-color);color:var(--button--primary--font-color)}\n"] }]
        }] });

class MenuButtonPlaceholderComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Placeholder';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'abc';
        this.canOptions = { ids: new Set() };
        this.dialogService = inject(MatDialog);
        this.injector = inject(Injector);
    }
    onClick() {
        const editor = this.editor();
        const isPlaceholder = editor.isActive(PlaceholderName);
        const ids = isPlaceholder
            ? new Set([editor.getAttributes(PlaceholderName)['id']])
            : new Set();
        this.dialogService.open(PlaceholderDialogComponent, {
            data: {
                ids,
                editor,
            },
            panelClass: 'bui-wysiwyg__dialog',
            injector: this.injector,
        })
            .afterClosed()
            .pipe(filter(Boolean))
            .subscribe(({ ids }) => {
            if (!ids?.size) {
                return;
            }
            editor.chain()
                .focus()
                .setPlaceholders({ ids })
                .run();
        });
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setPlaceholders(this.canOptions);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonPlaceholderComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonPlaceholderComponent, isStandalone: true, selector: "bui-wysiwyg-placeholder", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonPlaceholderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-placeholder', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const PlaceholderTool = {
    dependencies: [Placeholder],
    control: MenuButtonPlaceholderComponent,
    config: {
        [PlaceholderName]: ((config) => ({
            ...config,
            openOnClick: false,
        })),
    },
    optionMap: {
        [PlaceholderName]: ['placeholders', 'delimiter'], // Explizite Auflistung, da Html5Video einen Injector benötigt
    },
};

class MenuButtonRedoComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Redo';
        this.tooltipShortcutKeys = ['mod', 'Shift', 'Z'];
        this.icon = 'redo';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .redo()
            .run();
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .redo();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonRedoComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonRedoComponent, isStandalone: true, selector: "bui-wysiwyg-redo", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonRedoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-redo', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const RedoTool = {
    dependencies: [History],
    control: MenuButtonRedoComponent,
    optionMap: {
        [History.name]: Object.getOwnPropertyNames(History.options),
    },
};

class MenuButtonRemoveFormatComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'RemoveFormat';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'format_clear';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .unsetAllMarks()
            .run();
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .unsetAllMarks();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonRemoveFormatComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonRemoveFormatComponent, isStandalone: true, selector: "bui-wysiwyg-removeformat", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonRemoveFormatComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-removeformat', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const RemoveFormatTool = {
    dependencies: [],
    control: MenuButtonRemoveFormatComponent,
};

class SpecialCharDialogComponent {
    constructor() {
        this.locale = inject(LOCALE_ID)
            ?.toString()
            .substring(0, 2) ?? 'en';
        this.config = inject(BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE)
            .config().SpecialChar;
        this.chars = this.config?.specialChars ?? [];
        this.charEntries = this.chars.map(char => ({ value: char, label: labels[this.locale]?.[char] ?? char }));
        this.preview = signal({ value: '', label: '' });
        if (!this.config?.specialChars) {
            throw new Error('SpecialChar requires BUI_WYSIWYG_STATIC_CONFIG.SpecialChar to be provided.');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SpecialCharDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: SpecialCharDialogComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.SpecialChar.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<bui-group>
				<bui-field class="bui-wysiwyg__special-char-field">
					<div class="bui-wysiwyg__special-char-list">
						@for (entry of charEntries; track entry.value) {
							<button class="bui-wysiwyg__special-char-option"
							        [title]="entry.label"
							        [bui-dialog-action]="entry.value"
							        (mouseenter)="preview.set(entry)">
								{{ entry.value }}
							</button>
						}
					</div>
					<div class="bui-wysiwyg__special-char-preview">
						{{ preview().value }}
					</div>
				</bui-field>
			</bui-group>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
		</bui-dialog-actions>`, isInline: true, styles: [".bui-wysiwyg__special-char-field ::ng-deep .bui-row__content{flex-wrap:nowrap}.bui-wysiwyg__special-char-list{display:grid;grid-template-columns:repeat(17,1fr);grid-auto-rows:auto;gap:2px;border:1px solid var(--color--highlight);padding:4px}.bui-wysiwyg__special-char-option{border:1px solid var(--color--layout--tertiary);padding:3px;line-height:1;cursor:pointer}.bui-wysiwyg__special-char-option:hover{border-color:var(--color--layout--secondary);background:var(--color--base--white)}.bui-wysiwyg__special-char-preview{width:70px;height:50px;background:var(--color--layout--tertiary);text-align:center;line-height:50px;font-size:30px}\n"], dependencies: [{ kind: "component", type: DialogActionsComponent, selector: "bui-dialog-actions", inputs: ["align"] }, { kind: "directive", type: DialogActionDirective, selector: "button[bui-dialog-action]", inputs: ["ariaLabel", "type", "bui-dialog-action"] }, { kind: "directive", type: DialogTitleDirective, selector: "[bui-dialog-title]" }, { kind: "component", type: DialogContentComponent, selector: "bui-dialog-content" }, { kind: "component", type: GroupComponent, selector: "bui-group", inputs: ["name", "hint"] }, { kind: "component", type: FieldComponent, selector: "bui-field", inputs: ["labelPosition"] }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SpecialCharDialogComponent, decorators: [{
            type: Component,
            args: [{ template: `
		<h2 bui-dialog-title>{{ 'bui.wysiwyg.SpecialChar.dialog.title' | msgKey | async }}</h2>
		<bui-dialog-content>
			<bui-group>
				<bui-field class="bui-wysiwyg__special-char-field">
					<div class="bui-wysiwyg__special-char-list">
						@for (entry of charEntries; track entry.value) {
							<button class="bui-wysiwyg__special-char-option"
							        [title]="entry.label"
							        [bui-dialog-action]="entry.value"
							        (mouseenter)="preview.set(entry)">
								{{ entry.value }}
							</button>
						}
					</div>
					<div class="bui-wysiwyg__special-char-preview">
						{{ preview().value }}
					</div>
				</bui-field>
			</bui-group>
		</bui-dialog-content>
		<bui-dialog-actions>
			<button bui-button
			        [bui-dialog-action]="false">{{ 'bui.button.cancel' | msgKey | async }}
			</button>
		</bui-dialog-actions>`, imports: [
                        DialogActionsComponent,
                        DialogActionDirective,
                        DialogTitleDirective,
                        DialogContentComponent,
                        GroupComponent,
                        FieldComponent,
                        ButtonComponent,
                        ReactiveFormsModule,
                        MsgKeyPipe,
                        AsyncPipe,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, styles: [".bui-wysiwyg__special-char-field ::ng-deep .bui-row__content{flex-wrap:nowrap}.bui-wysiwyg__special-char-list{display:grid;grid-template-columns:repeat(17,1fr);grid-auto-rows:auto;gap:2px;border:1px solid var(--color--highlight);padding:4px}.bui-wysiwyg__special-char-option{border:1px solid var(--color--layout--tertiary);padding:3px;line-height:1;cursor:pointer}.bui-wysiwyg__special-char-option:hover{border-color:var(--color--layout--secondary);background:var(--color--base--white)}.bui-wysiwyg__special-char-preview{width:70px;height:50px;background:var(--color--layout--tertiary);text-align:center;line-height:50px;font-size:30px}\n"] }]
        }], ctorParameters: () => [] });
const labels = {
    de: {
        '€': 'Euro-Symbol',
        '‘': 'Hochkomma links',
        '’': 'Hochkomma rechts',
        '“': 'Anführungszeichen links',
        '”': 'Anführungszeichen rechts',
        '–': 'Halbgeviertstrich',
        '—': 'Geviertstrich',
        '¡': 'Umgekehrtes Ausrufezeichen',
        '¢': 'Cent-Symbol',
        '£': 'Pfund-Symbol',
        '¤': 'Allgemeines Währungssymbol',
        '¥': 'Yen-Symbol',
        '¦': 'Unterbrochener Strich',
        '§': 'Paragrafenzeichen',
        '¨': 'Trema',
        '©': 'Copyright-Zeichen',
        'ª': 'Weibliches Ordnialzeichen',
        '«': 'Nach links zeigendes Spitzzeichen',
        '¬': 'Negationszeichen',
        '®': 'Registriert-Zeichen',
        '¯': 'Makron',
        '°': 'Grad',
        '²': 'Hoch 2',
        '³': 'Hoch 3',
        '₂': 'Tiefgestellte 2',
        '´': 'Akutakzent',
        'µ': 'Mikro-Zeichen',
        '¶': 'Absatzmarke',
        '·': 'Mittelpunkt',
        '¸': 'Cedilla',
        '¹': 'Hoch 1',
        'º': 'Männliche Ordnialzeichen',
        '»': 'Nach rechts zeigendes Spitzzeichen',
        '¼': 'ein Viertel',
        '½': 'Hälfte',
        '¾': 'Dreiviertel',
        '¿': 'Umgekehrtes Fragezeichen',
        'À': 'Lateinischer Buchstabe A mit Gravis',
        'Á': 'Lateinischer Buchstabe A mit Akutakzent',
        'Â': 'Lateinischer Buchstabe A mit Zirkumflex',
        'Ã': 'Lateinischer Buchstabe A mit Tilde',
        'Ä': 'Lateinischer Buchstabe A mit Trema',
        'Å': 'Lateinischer Buchstabe A mit Ring oben',
        'Æ': 'Lateinischer Buchstabe Ligatur AE',
        'Ç': 'Lateinischer Buchstabe C mit Cedille',
        'È': 'Lateinischer Buchstabe E mit Gravis',
        'É': 'Lateinischer Buchstabe E mit Akutakzent',
        'Ê': 'Lateinischer Buchstabe E mit Zirkumflex',
        'Ë': 'Lateinischer Buchstabe E Trema',
        'Ì': 'Lateinischer Buchstabe I mit Gravis',
        'Í': 'Lateinischer Buchstabe I mit Akutakzent',
        'Î': 'Lateinischer Buchstabe I mit Zirkumflex',
        'Ï': 'Lateinischer Buchstabe I mit Trema',
        'Ð': 'Lateinischer Buchstabe Eth',
        'Ñ': 'Lateinischer Buchstabe N mit Tilde',
        'Ò': 'Lateinischer Buchstabe O mit Gravis',
        'Ó': 'Lateinischer Buchstabe O mit Akutakzent',
        'Ô': 'Lateinischer Buchstabe O mit Zirkumflex',
        'Õ': 'Lateinischer Buchstabe O mit Tilde',
        'Ö': 'Lateinischer Buchstabe O mit Trema',
        '×': 'Multiplikationszeichen',
        'Ø': 'Lateinischer Buchstabe O durchgestrichen',
        'Ù': 'Lateinischer Buchstabe U mit Akzentgrave',
        'Ú': 'Lateinischer Buchstabe U mit Akutakzent',
        'Û': 'Lateinischer Buchstabe U mit Zirkumflex',
        'Ü': 'Lateinischer Buchstabe U mit Trema',
        'Ý': 'Lateinischer Buchstabe Y mit Akzent',
        'Þ': 'Lateinischer Buchstabe Thorn',
        'ß': 'Kleiner lateinischer Buchstabe scharfes s',
        'à': 'Kleiner lateinischer Buchstabe a mit Gravis',
        'á': 'Kleiner lateinischer Buchstabe a mit Akut',
        'â': 'Kleiner lateinischer Buchstabe a mit Zirkumflex',
        'ã': 'Kleiner lateinischer Buchstabe a mit Tilde',
        'ä': 'Kleiner lateinischer Buchstabe a mit Trema',
        'å': 'Kleiner lateinischer Buchstabe a mit Ring oben',
        'æ': 'Kleiner lateinischer Buchstabe Ligatur ae',
        'ç': 'Kleiner lateinischer Buchstabe c mit Cedille',
        'è': 'Kleiner lateinischer Buchstabe e mit Gravis',
        'é': 'Kleiner lateinischer Buchstabe e mit Akut',
        'ê': 'Kleiner lateinischer Buchstabe e mit Zirkumflex',
        'ë': 'Kleiner lateinischer Buchstabe e mit Trema',
        'ì': 'Kleiner lateinischer Buchstabe i mit Gravis',
        'í': 'Kleiner lateinischer Buchstabe i mit Akzent',
        'î': 'Kleiner lateinischer Buchstabe i mit Zirkumflex',
        'ï': 'Kleiner lateinischer Buchstabe i mit Trema',
        'ð': 'Kleiner lateinischer Buchstabe eth',
        'ñ': 'Kleiner lateinischer Buchstabe n mit Tilde',
        'ò': 'Kleiner lateinischer Buchstabe o mit Gravis',
        'ó': 'Kleiner lateinischer Buchstabe o mit Akzent',
        'ô': 'Kleiner lateinischer Buchstabe o mit Zirkumflex',
        'õ': 'Kleiner lateinischer Buchstabe o mit Tilde',
        'ö': 'Kleiner lateinischer Buchstabe o mit Trema',
        '÷': 'Divisionszeichen',
        'ø': 'Kleiner lateinischer Buchstabe o durchgestrichen',
        'ù': 'Kleiner lateinischer Buchstabe u mit Gravis',
        'ú': 'Kleiner lateinischer Buchstabe u mit Akut',
        'û': 'Kleiner lateinischer Buchstabe u mit Zirkumflex',
        'ü': 'Kleiner lateinischer Buchstabe u mit Trema',
        'ý': 'Kleiner lateinischer Buchstabe y mit Akut',
        'þ': 'Kleiner lateinischer Buchstabe Thorn',
        'ÿ': 'Kleiner lateinischer Buchstabe y mit Trema',
        'Œ': 'Lateinischer Buchstabe Ligatur OE',
        'œ': 'Kleiner lateinischer Buchstabe Ligatur oe',
        'Ŵ': 'Lateinischer Buchstabe W mit Zirkumflex',
        'Ŷ': 'Lateinischer Buchstabe Y mit Zirkumflex',
        'ŵ': 'Kleiner lateinischer Buchstabe w mit Zirkumflex',
        'ŷ': 'Kleiner lateinischer Buchstabe y mit Zirkumflex',
        '‚': 'Einfaches Anführungszeichen unten',
        '‛': 'Einfaches Anführungszeichen oben',
        '„': 'Doppeltes Anführungszeichen unten',
        '…': 'horizontale Auslassungspunkte',
        '™': 'Trademark-Zeichen',
        '►': 'Dreieckspfeil rechts',
        '•': 'Aufzählungszeichen',
        '→': 'Pfeil rechts',
        '⇒': 'Doppelpfeil rechts',
        '⇔': 'Doppelpfeil links und rechts',
        '♦': 'Karo',
        '≈': 'Ungefähr',
    },
    en: {
        '€': 'Euro sign',
        '‘': 'Left single quotation mark',
        '’': 'Right single quotation mark',
        '“': 'Left double quotation mark',
        '”': 'Right double quotation mark',
        '–': 'En dash',
        '—': 'Em dash',
        '¡': 'Inverted exclamation mark',
        '¢': 'Cent sign',
        '£': 'Pound sign',
        '¤': 'Currency sign',
        '¥': 'Yen sign',
        '¦': 'Broken bar',
        '§': 'Section sign',
        '¨': 'Diaeresis',
        '©': 'Copyright sign',
        'ª': 'Feminine ordinal indicator',
        '«': 'Left-pointing double angle quotation mark',
        '¬': 'Not sign',
        '®': 'Registered sign',
        '¯': 'Macron',
        '°': 'Degree sign',
        '²': 'Superscript two',
        '³': 'Superscript three',
        '´': 'Acute accent',
        'µ': 'Micro sign',
        '¶': 'Pilcrow sign',
        '·': 'Middle dot',
        '¸': 'Cedilla',
        '¹': 'Superscript one',
        'º': 'Masculine ordinal indicator',
        '»': 'Right-pointing double angle quotation mark',
        '¼': 'Vulgar fraction one quarter',
        '½': 'Vulgar fraction one half',
        '¾': 'Vulgar fraction three quarters',
        '¿': 'Inverted question mark',
        'À': 'Latin capital letter A with grave accent',
        'Á': 'Latin capital letter A with acute accent',
        'Â': 'Latin capital letter A with circumflex',
        'Ã': 'Latin capital letter A with tilde',
        'Ä': 'Latin capital letter A with diaeresis',
        'Å': 'Latin capital letter A with ring above',
        'Æ': 'Latin capital ligature AE',
        'Ç': 'Latin capital letter C with cedilla',
        'È': 'Latin capital letter E with grave accent',
        'É': 'Latin capital letter E with acute accent',
        'Ê': 'Latin capital letter E with circumflex',
        'Ë': 'Latin capital letter E with diaeresis',
        'Ì': 'Latin capital letter I with grave accent',
        'Í': 'Latin capital letter I with acute accent',
        'Î': 'Latin capital letter I with circumflex',
        'Ï': 'Latin capital letter I with diaeresis',
        'Ð': 'Latin capital letter Eth',
        'Ñ': 'Latin capital letter N with tilde',
        'Ò': 'Latin capital letter O with grave accent',
        'Ó': 'Latin capital letter O with acute accent',
        'Ô': 'Latin capital letter O with circumflex',
        'Õ': 'Latin capital letter O with tilde',
        'Ö': 'Latin capital letter O with diaeresis',
        '×': 'Multiplication sign',
        'Ø': 'Latin capital letter O with stroke',
        'Ù': 'Latin capital letter U with grave accent',
        'Ú': 'Latin capital letter U with acute accent',
        'Û': 'Latin capital letter U with circumflex',
        'Ü': 'Latin capital letter U with diaeresis',
        'Ý': 'Latin capital letter Y with acute accent',
        'Þ': 'Latin capital letter Thorn',
        'ß': 'Latin small letter sharp s',
        'à': 'Latin small letter a with grave accent',
        'á': 'Latin small letter a with acute accent',
        'â': 'Latin small letter a with circumflex',
        'ã': 'Latin small letter a with tilde',
        'ä': 'Latin small letter a with diaeresis',
        'å': 'Latin small letter a with ring above',
        'æ': 'Latin small ligature ae',
        'ç': 'Latin small letter c with cedilla',
        'è': 'Latin small letter e with grave accent',
        'é': 'Latin small letter e with acute accent',
        'ê': 'Latin small letter e with circumflex',
        'ë': 'Latin small letter e with diaeresis',
        'ì': 'Latin small letter i with grave accent',
        'í': 'Latin small letter i with acute accent',
        'î': 'Latin small letter i with circumflex',
        'ï': 'Latin small letter i with diaeresis',
        'ð': 'Latin small letter eth',
        'ñ': 'Latin small letter n with tilde',
        'ò': 'Latin small letter o with grave accent',
        'ó': 'Latin small letter o with acute accent',
        'ô': 'Latin small letter o with circumflex',
        'õ': 'Latin small letter o with tilde',
        'ö': 'Latin small letter o with diaeresis',
        '÷': 'Division sign',
        'ø': 'Latin small letter o with stroke',
        'ù': 'Latin small letter u with grave accent',
        'ú': 'Latin small letter u with acute accent',
        'û': 'Latin small letter u with circumflex',
        'ü': 'Latin small letter u with diaeresis',
        'ý': 'Latin small letter y with acute accent',
        'þ': 'Latin small letter thorn',
        'ÿ': 'Latin small letter y with diaeresis',
        'Œ': 'Latin capital ligature OE',
        'œ': 'Latin small ligature oe',
        'Ŵ': 'Latin capital letter W with circumflex',
        'Ŷ': 'Latin capital letter Y with circumflex',
        'ŵ': 'Latin small letter w with circumflex',
        'ŷ': 'Latin small letter y with circumflex',
        '‚': 'Single low-9 quotation mark',
        '‛': 'Single high-reversed-9 quotation mark',
        '„': 'Double low-9 quotation mark',
        '…': 'Horizontal ellipsis',
        '™': 'Trade mark sign',
        '►': 'Black right-pointing pointer',
        '•': 'Bullet',
        '→': 'Rightwards arrow',
        '⇒': 'Rightwards double arrow',
        '⇔': 'Left right double arrow',
        '♦': 'Black diamond suit',
        '≈': 'Almost equal to',
    },
};

class MenuButtonSpecialCharComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'SpecialChar';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'emoji_symbols';
        this.dialogService = inject(MatDialog);
        this.injector = inject(Injector);
    }
    onClick() {
        this.dialogService.open(SpecialCharDialogComponent, {
            panelClass: 'bui-wysiwyg__dialog',
            injector: this.injector,
        })
            .afterClosed()
            .pipe(filter(Boolean))
            .subscribe((char) => {
            this.editor()
                .chain()
                .focus()
                .insertContent(char)
                .run();
        });
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .insertContent('!');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonSpecialCharComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonSpecialCharComponent, isStandalone: true, selector: "bui-wysiwyg-special-char", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonSpecialCharComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-special-char', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const SpecialCharTool = {
    dependencies: [],
    control: MenuButtonSpecialCharComponent,
};

class MenuButtonStrikeComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Strike';
        this.tooltipShortcutKeys = ['mod', 'Shift', 'X'];
        this.icon = 'format_strikethrough';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .toggleStrike()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('strike');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleStrike();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonStrikeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonStrikeComponent, isStandalone: true, selector: "bui-wysiwyg-strike", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonStrikeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-strike', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const StrikeTool = {
    dependencies: [Strike],
    control: MenuButtonStrikeComponent,
    optionMap: {
        [Strike.name]: Object.getOwnPropertyNames(Strike.options),
    },
};

class MenuButtonSubscriptComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Subscript';
        this.tooltipShortcutKeys = ['mod', ','];
        this.icon = 'subscript';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .toggleSubscript()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('subscript');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleSubscript();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonSubscriptComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonSubscriptComponent, isStandalone: true, selector: "bui-wysiwyg-subscript", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonSubscriptComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-subscript', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const SubscriptTool = {
    dependencies: [Subscript],
    control: MenuButtonSubscriptComponent,
    replace: {
        [Superscript.name]: (extendedConfig = {}) => ({
            ...extendedConfig,
            excludes: Subscript.name,
        }),
    },
    optionMap: {
        [Subscript.name]: Object.getOwnPropertyNames(Subscript.options),
    },
};

class MenuButtonSuperscriptComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Superscript';
        this.tooltipShortcutKeys = ['mod', '.'];
        this.icon = 'superscript';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .toggleSuperscript()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('superscript');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleSuperscript();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonSuperscriptComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonSuperscriptComponent, isStandalone: true, selector: "bui-wysiwyg-superscript", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonSuperscriptComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-superscript', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const SuperscriptTool = {
    dependencies: [Superscript],
    control: MenuButtonSuperscriptComponent,
    replace: {
        [Subscript.name]: (extendedConfig = {}) => ({
            ...extendedConfig,
            excludes: Superscript.name,
        }),
    },
    optionMap: {
        [Superscript.name]: Object.getOwnPropertyNames(Superscript.options),
    },
};

const Color = Color$1.extend({
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    color: {
                        default: null,
                        parseHTML: element => element.getAttribute('style')
                            ?.match(/(^|;\s*)color:\s*([^;]+)/)?.[2],
                        renderHTML: attributes => {
                            if (!attributes['color']) {
                                return {};
                            }
                            return {
                                style: `color: ${attributes['color']}`,
                            };
                        },
                    },
                },
            },
        ];
    },
});

class MenuButtonTextColorComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'TextColor';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'format_color_text';
        this.floatUiTrigger = viewChild(NgxFloatUiDirective);
        this.moreColorsInput = viewChild('moreColorsInput');
        this.defaultTextColor = '';
        this.currentColor = signal('');
        this.colorStyle = computed(() => {
            if (!this.currentColor().length) {
                return {};
            }
            return {
                '--bui-wysiwyg--current-color': `#${this.currentColor()}`,
            };
        });
        this.swatchColors = [
            '1abc9c', '2ecc71', '3498db', '9b59b6', '4e5f70', 'f1c40f',
            '16a085', '27ae60', '2980b9', '8e44ad', '2c3e50', 'f39c12',
            'e67e22', 'e74c3c', 'ecf0f1', '95a5a6', 'dddddd', 'ffffff',
            'd35400', 'c0392b', 'bdc3c7', '7f8c8d', '999999', '000000',
        ];
        this.historyColors = signal([]);
        this.PLACEMENT_BOTTOM = NgxFloatUiPlacements.BOTTOM;
    }
    onEditorUpdate() {
        super.onEditorUpdate();
        this.updateCurrentColor();
    }
    onClick() {
        // Handling per FloatUI
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setColor('red');
    }
    updateCurrentColor() {
        this.currentColor.set(this.getCurrentColor()
            .substring(1)
            .toLowerCase());
    }
    getCurrentColor() {
        const editor = this.editor();
        // Determine if all the selected content shares the same set color.
        const allCurrentTextStyleAttrs = editor
            ? getAttributesForEachSelected(editor.state, 'textStyle')
            : [];
        const isTextStyleAppliedToEntireSelection = !!editor?.isActive('textStyle');
        const currentColors = allCurrentTextStyleAttrs.map(
        // Treat any null/missing color as the default color
        (attrs) => attrs.color || this.defaultTextColor);
        if (!isTextStyleAppliedToEntireSelection) {
            // If there is some selected content that does not have textStyle, we can
            // treat it the same as a selected textStyle mark with color set to the
            // default
            currentColors.push(this.defaultTextColor);
        }
        const numUniqueCurrentColors = new Set(currentColors).size;
        if (numUniqueCurrentColors === 1) {
            // There's exactly one color in the selected content, so show that
            return currentColors[0];
        }
        if (numUniqueCurrentColors > 1) {
            // There are multiple colors (either explicitly, or because some of the
            // selection has a color set and some does not and is using the default
            // color). Similar to other rich text editors like Google Docs, we'll treat
            // this as "unset" and not show a color indicator in the button or a
            // "current" color when interacting with the color picker.
            return '';
        }
        // Since no color was set anywhere in the selected content, we should show
        // the default color
        return this.defaultTextColor;
    }
    setColor(color) {
        const prefixedColor = (color.startsWith('#') ? color : `#${color}`).toLowerCase();
        this.editor()
            .chain()
            .focus()
            .setColor(prefixedColor)
            .run() && this.closePopup();
        const colorNoHash = prefixedColor.substring(1);
        this.historyColors.update(colors => [colorNoHash, ...colors.filter(c => c !== color)]);
        this.currentColor.set(colorNoHash);
    }
    resetColor() {
        this.editor()
            .chain()
            .focus()
            .unsetColor()
            .run() && this.closePopup();
        this.currentColor.set('');
    }
    closePopup() {
        this.floatUiTrigger()
            ?.hide();
    }
    openMoreColorsDialog() {
        this.closePopup();
        this.moreColorsInput()
            ?.nativeElement
            .click();
    }
    onMoreColorsChange(e) {
        const color = e.target.value;
        this.setColor(color);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonTextColorComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: MenuButtonTextColorComponent, isStandalone: true, selector: "bui-wysiwyg-textcolor", viewQueries: [{ propertyName: "floatUiTrigger", first: true, predicate: NgxFloatUiDirective, descendants: true, isSignal: true }, { propertyName: "moreColorsInput", first: true, predicate: ["moreColorsInput"], descendants: true, isSignal: true }], usesInheritance: true, ngImport: i0, template: `
		<float-ui-content class="bui-wysiwyg__color-popup"
		                  #colorPopup>
			<button class="bui-wysiwyg__color-button bui-wysiwyg__color-button--auto"
			        type="button"
			        (click)="resetColor()">
				<span class="bui-wysiwyg__color"
				      [style.background-color]="'var(--color--font--primary)'"></span>
				<span class="bui-wysiwyg__color-auto-text">{{ 'bui.wysiwyg.Color.auto' | msgKey | async }}</span>
			</button>
			<div class="bui-wysiwyg__color-swatch">
				@for (color of swatchColors; track color) {
					<button class="bui-wysiwyg__color-button"
					        [class.bui-wysiwyg__color-button--active]="color === currentColor()"
					        title="{{ ('bui.wysiwyg.Color.color.' + color) | msgKey | async }}"
					        (click)="setColor(color)"
					        type="button">
						<span class="bui-wysiwyg__color"
						      [style.background-color]="'#' + color"></span>
					</button>
				}
			</div>
			<hr>
			@if (historyColors().length) {
				<div class="bui-wysiwyg__color-swatch bui-wysiwyg__color-swatch--history">
					@for (color of historyColors(); track color) {
						<button class="bui-wysiwyg__color-button"
						        [class.bui-wysiwyg__color-button--active]="color === currentColor()"
						        title="{{ swatchColors.includes(color) ? (('bui.wysiwyg.Color.color.' + color) | msgKey | async) : ('#' + color) }}"
						        (click)="setColor(color)"
						        type="button">
							<span class="bui-wysiwyg__color"
							      [style.background-color]="'#' + color"></span>
						</button>
					}
				</div>
			}
			<button class="bui-wysiwyg__color-button bui-wysiwyg__color-button--more"
			        type="button"
			        (click)="openMoreColorsDialog()">
				<span class="bui-wysiwyg__color-more-text">{{ 'bui.wysiwyg.Color.more' | msgKey | async }}</span>
			</button>
		</float-ui-content>
		<div class="bui-wysiwyg__toolbar-control bui-wysiwyg__toolbar-control--color"
		     [class.bui-wysiwyg__toolbar-control--active]="selected()">
			<button bui-button
			        [disabled]="disabled()"
			        [title]="(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()"
			        [floatUi]="colorPopup"
			        [placement]="PLACEMENT_BOTTOM"
			        [style]="colorStyle()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		</div>
		<input #moreColorsInput
		       (change)="onMoreColorsChange($event)"
		       class="bui-wysiwyg__color-more-input"
		       type="color">`, isInline: true, dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "ngmodule", type: NgxFloatUiModule }, { kind: "component", type: i5.NgxFloatUiContentComponent, selector: "float-ui-content", exportAs: ["ngxFloatUiContent"] }, { kind: "directive", type: i5.NgxFloatUiDirective, selector: "[floatUi]", inputs: ["applyClass", "arrowClass", "disabled", "floatUi", "hideOnClickOutside", "placement", "preventOverflow", "showOnStart", "appendTo", "ariaDescribe", "ariaRole", "boundariesElement", "disableAnimation", "disableStyle", "hideOnMouseLeave", "hideOnScroll", "hideTimeout", "positionFixed", "showDelay", "showTrigger", "styles", "targetElement", "timeoutAfterShow"], outputs: ["onHidden", "onShown", "onUpdate"], exportAs: ["floatUi"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonTextColorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-wysiwyg-textcolor',
                    imports: [
                        ...AbstractMenuButtonImports,
                        NgxFloatUiModule,
                    ],
                    template: `
		<float-ui-content class="bui-wysiwyg__color-popup"
		                  #colorPopup>
			<button class="bui-wysiwyg__color-button bui-wysiwyg__color-button--auto"
			        type="button"
			        (click)="resetColor()">
				<span class="bui-wysiwyg__color"
				      [style.background-color]="'var(--color--font--primary)'"></span>
				<span class="bui-wysiwyg__color-auto-text">{{ 'bui.wysiwyg.Color.auto' | msgKey | async }}</span>
			</button>
			<div class="bui-wysiwyg__color-swatch">
				@for (color of swatchColors; track color) {
					<button class="bui-wysiwyg__color-button"
					        [class.bui-wysiwyg__color-button--active]="color === currentColor()"
					        title="{{ ('bui.wysiwyg.Color.color.' + color) | msgKey | async }}"
					        (click)="setColor(color)"
					        type="button">
						<span class="bui-wysiwyg__color"
						      [style.background-color]="'#' + color"></span>
					</button>
				}
			</div>
			<hr>
			@if (historyColors().length) {
				<div class="bui-wysiwyg__color-swatch bui-wysiwyg__color-swatch--history">
					@for (color of historyColors(); track color) {
						<button class="bui-wysiwyg__color-button"
						        [class.bui-wysiwyg__color-button--active]="color === currentColor()"
						        title="{{ swatchColors.includes(color) ? (('bui.wysiwyg.Color.color.' + color) | msgKey | async) : ('#' + color) }}"
						        (click)="setColor(color)"
						        type="button">
							<span class="bui-wysiwyg__color"
							      [style.background-color]="'#' + color"></span>
						</button>
					}
				</div>
			}
			<button class="bui-wysiwyg__color-button bui-wysiwyg__color-button--more"
			        type="button"
			        (click)="openMoreColorsDialog()">
				<span class="bui-wysiwyg__color-more-text">{{ 'bui.wysiwyg.Color.more' | msgKey | async }}</span>
			</button>
		</float-ui-content>
		<div class="bui-wysiwyg__toolbar-control bui-wysiwyg__toolbar-control--color"
		     [class.bui-wysiwyg__toolbar-control--active]="selected()">
			<button bui-button
			        [disabled]="disabled()"
			        [title]="(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()"
			        [floatUi]="colorPopup"
			        [placement]="PLACEMENT_BOTTOM"
			        [style]="colorStyle()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		</div>
		<input #moreColorsInput
		       (change)="onMoreColorsChange($event)"
		       class="bui-wysiwyg__color-more-input"
		       type="color">`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });
const TextColorTool = {
    dependencies: [Color, TextStyle],
    control: MenuButtonTextColorComponent,
    optionMap: {
        [TextStyle.name]: Object.getOwnPropertyNames(TextStyle.options),
    },
};

class MenuButtonUnderlineComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Underline';
        this.tooltipShortcutKeys = ['mod', 'U'];
        this.icon = 'format_underline';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .toggleUnderline()
            .run();
    }
    isSelected() {
        return this.editor()
            .isActive('underline');
    }
    canRunCommand() {
        return this.editor()
            .can()
            .toggleUnderline();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonUnderlineComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonUnderlineComponent, isStandalone: true, selector: "bui-wysiwyg-underline", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonUnderlineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-underline', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const UnderlineTool = {
    dependencies: [Underline],
    control: MenuButtonUnderlineComponent,
    optionMap: {
        [Underline.name]: Object.getOwnPropertyNames(Underline.options),
    },
};

class MenuButtonUndoComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Undo';
        this.tooltipShortcutKeys = ['mod', 'Z'];
        this.icon = 'undo';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .undo()
            .run();
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .undo();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonUndoComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonUndoComponent, isStandalone: true, selector: "bui-wysiwyg-undo", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonUndoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-undo', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const UndoTool = {
    dependencies: [History],
    control: MenuButtonUndoComponent,
};

class MenuButtonUnlinkComponent extends AbstractMenuButtonComponent {
    constructor() {
        super(...arguments);
        this.tooltipLabel = 'Unlink';
        this.tooltipShortcutKeys = undefined;
        this.icon = 'link_off';
    }
    onClick() {
        this.editor()
            .chain()
            .focus()
            .unsetLink()
            .run();
    }
    isSelected() {
        return false;
    }
    canRunCommand() {
        return this.editor()
            .can()
            .unsetLink();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonUnlinkComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuButtonUnlinkComponent, isStandalone: true, selector: "bui-wysiwyg-unlink", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuButtonUnlinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-unlink', imports: AbstractMenuButtonImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\"\r\n     [class.bui-wysiwyg__toolbar-control--active]=\"selected()\">\r\n\t<button bui-button\r\n\t        [disabled]=\"disabled()\"\r\n\t        [title]=\"(tooltipLabelKey() | msgKey | async) + tooltipShortcutHint()\"\r\n\t        (throttledClick)=\"onClick()\">\r\n\t\t<mat-icon>{{ icon }}</mat-icon>\r\n\t</button>\r\n</div>" }]
        }] });
const UnlinkTool = {
    dependencies: [Link],
    control: MenuButtonUnlinkComponent,
};

const FontSize = Extension.create({
    name: 'fontSize',
    addOptions() {
        return {
            types: ['textStyle'],
            fontSizes: [],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (element) => element.style.fontSize.replace(/['"]+/g, ''),
                        renderHTML: (attributes) => {
                            if (!attributes.fontSize) {
                                return {};
                            }
                            return {
                                style: `font-size: ${attributes.fontSize}`,
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setFontSize: (fontSize) => ({ chain }) => {
                if (!this.options.fontSizes.includes(fontSize)) {
                    return false;
                }
                return chain()
                    .setMark('textStyle', { fontSize })
                    .run();
            },
            unsetFontSize: () => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { fontSize: null })
                    .removeEmptyTextStyle()
                    .run();
            },
        };
    },
});

class AbstractMenuSelectComponent {
    constructor() {
        this.msgKeyService = inject(MessageService);
        this.default = toSignal(this.msgKeyService.resolve('bui.wysiwyg.common.default')
            .pipe(take(1), map(msg => `(${msg})`)), {
            initialValue: 'Default',
        });
        this.selectOptions = computed(() => [
            { value: null, label: this.default() },
            ...this.options,
        ]);
        this.value = signal(undefined);
        this.disabled = signal(false);
        this.editor = input.required();
        this.tooltipLabelKey = computed(() => `bui.wysiwyg.${this.tooltipLabel}.label`);
        this.tooltipPlaceholderKey = computed(() => `bui.wysiwyg.${this.tooltipLabel}.placeholder`);
        explicitEffect([this.editor], ([editor]) => {
            this.onEditorUpdate();
            editor.on('update', () => this.onEditorUpdate());
            editor.on('selectionUpdate', () => this.onEditorUpdate());
        });
    }
    onEditorUpdate() {
        this.value.set(this.getValue());
        this.disabled.set(!this.editor().isEditable || !this.canRunCommand());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: AbstractMenuSelectComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "19.1.1", type: AbstractMenuSelectComponent, isStandalone: true, inputs: { editor: { classPropertyName: "editor", publicName: "editor", isSignal: true, isRequired: true, transformFunction: null } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: AbstractMenuSelectComponent, decorators: [{
            type: Directive
        }], ctorParameters: () => [] });
const AbstractMenuSelectImports = [
    SelectComponent,
    FormsModule,
    MsgKeyPipe,
    AsyncPipe,
];

class MenuSelectFontSizeComponent extends AbstractMenuSelectComponent {
    constructor() {
        super(...arguments);
        this.fontSizes = inject(BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE)
            .config().FontSize.fontSizes;
        this.firstFontSize = this.fontSizes[0];
        this.tooltipLabel = 'FontSize';
        this.options = this.fontSizes.map(fontSize => ({ value: fontSize, label: fontSize }));
    }
    onSelect(value) {
        const chain = this.editor()
            .chain()
            .focus();
        if (value) {
            chain
                .setFontSize(value)
                .run();
        }
        else {
            chain
                .unsetFontSize()
                .run();
        }
    }
    getValue() {
        const allCurrentTextStyleAttrs = this.editor()
            ? getAttributesForEachSelected(this.editor().state, 'textStyle')
            : [];
        const isTextStyleAppliedToEntireSelection = !!this.editor()
            ?.isActive('textStyle');
        const currentFontSizes = allCurrentTextStyleAttrs.map((attrs) => attrs.fontSize ?? '');
        if (!isTextStyleAppliedToEntireSelection) {
            currentFontSizes.push('');
        }
        const numUniqueCurrentFontSizes = new Set(currentFontSizes).size;
        if (numUniqueCurrentFontSizes === 1 && currentFontSizes[0] !== '') {
            return currentFontSizes[0];
        }
        else {
            return null;
        }
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setFontSize(this.firstFontSize);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuSelectFontSizeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuSelectFontSizeComponent, isStandalone: true, selector: "bui-wysiwyg-fontsize", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\">\r\n\t<bui-select [items]=\"selectOptions()\"\r\n\t            [disabled]=\"disabled()\"\r\n\t            [ngModel]=\"value()\"\r\n\t            (ngModelChange)=\"onSelect($event)\"\r\n\t            [ngModelOptions]=\"{standalone: true}\"\r\n\t            [title]=\"tooltipLabelKey() | msgKey | async\"\r\n\t            [placeholder]=\"tooltipPlaceholderKey() | msgKey | async\"\r\n\t            [searchable]=\"false\"></bui-select>\r\n</div>", dependencies: [{ kind: "component", type: SelectComponent, selector: "bui-select", inputs: ["items", "valueKey", "labelKey", "placeholder", "clearable", "searchable", "multiple", "disabled", "groupBy"] }, { kind: "ngmodule", type: i1$2.FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuSelectFontSizeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-fontsize', imports: AbstractMenuSelectImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\">\r\n\t<bui-select [items]=\"selectOptions()\"\r\n\t            [disabled]=\"disabled()\"\r\n\t            [ngModel]=\"value()\"\r\n\t            (ngModelChange)=\"onSelect($event)\"\r\n\t            [ngModelOptions]=\"{standalone: true}\"\r\n\t            [title]=\"tooltipLabelKey() | msgKey | async\"\r\n\t            [placeholder]=\"tooltipPlaceholderKey() | msgKey | async\"\r\n\t            [searchable]=\"false\"></bui-select>\r\n</div>" }]
        }] });
const FontSizeTool = {
    dependencies: [FontSize, TextStyle],
    control: MenuSelectFontSizeComponent,
    optionMap: {
        [FontSize.name]: Object.getOwnPropertyNames(FontSize.options),
    },
};

function getClasses(element) {
    return element.className?.split(' ') ?? [];
}
const Styles = Mark.create({
    name: 'styles',
    addOptions() {
        return {
            element: 'font',
            stylesets: {},
            HTMLAttributes: {},
        };
    },
    addAttributes() {
        return {
            styleset: {
                default: null,
                renderHTML: ({ styleset }) => styleset ? { class: this.options.stylesets[styleset] } : {},
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.element,
                getAttrs: (element) => {
                    const classes = getClasses(element);
                    const styleset = Object.entries(this.options.stylesets)
                        .find(([_, className]) => classes.includes(className))?.[0];
                    return styleset ? { styleset } : false;
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.element, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setStyle: (styleset) => ({ chain }) => {
                if (!this.options.stylesets[styleset]) {
                    return false;
                }
                return chain()
                    .setMark(this.name, { styleset })
                    .run();
            },
            unsetStyle: () => ({ chain }) => {
                return chain()
                    .unsetMark(this.name)
                    .run();
            },
        };
    },
});

class MenuSelectStylesComponent extends AbstractMenuSelectComponent {
    constructor() {
        super(...arguments);
        this.styles = inject(BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE)
            .config().Styles.stylesets;
        this.firstStyle = Object.keys(this.styles)[0];
        this.tooltipLabel = 'Styles';
        this.options = Object.keys(this.styles)
            .map(fontSize => ({ value: fontSize, label: fontSize }));
    }
    onSelect(value) {
        const chain = this.editor()
            .chain()
            .focus();
        if (value) {
            chain
                .setStyle(value)
                .run();
        }
        else {
            chain
                .unsetStyle()
                .run();
        }
    }
    getValue() {
        const allCurrentTextStyleAttrs = this.editor()
            ? getAttributesForEachSelected(this.editor().state, 'styles')
            : [];
        const isTextStyleAppliedToEntireSelection = !!this.editor()
            ?.isActive('styles');
        const currentStyles = allCurrentTextStyleAttrs.map((attrs) => attrs.styleset ?? '');
        if (!isTextStyleAppliedToEntireSelection) {
            currentStyles.push('');
        }
        const numUniqueCurrentStyles = new Set(currentStyles).size;
        if (numUniqueCurrentStyles === 1 && currentStyles[0] !== '') {
            return currentStyles[0];
        }
        else {
            return null;
        }
    }
    canRunCommand() {
        return this.editor()
            .can()
            .setStyle(this.firstStyle);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuSelectStylesComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: MenuSelectStylesComponent, isStandalone: true, selector: "bui-wysiwyg-styles", usesInheritance: true, ngImport: i0, template: "<div class=\"bui-wysiwyg__toolbar-control\">\r\n\t<bui-select [items]=\"selectOptions()\"\r\n\t            [disabled]=\"disabled()\"\r\n\t            [ngModel]=\"value()\"\r\n\t            (ngModelChange)=\"onSelect($event)\"\r\n\t            [ngModelOptions]=\"{standalone: true}\"\r\n\t            [title]=\"tooltipLabelKey() | msgKey | async\"\r\n\t            [placeholder]=\"tooltipPlaceholderKey() | msgKey | async\"\r\n\t            [searchable]=\"false\"></bui-select>\r\n</div>", dependencies: [{ kind: "component", type: SelectComponent, selector: "bui-select", inputs: ["items", "valueKey", "labelKey", "placeholder", "clearable", "searchable", "multiple", "disabled", "groupBy"] }, { kind: "ngmodule", type: i1$2.FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MenuSelectStylesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg-styles', imports: AbstractMenuSelectImports, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bui-wysiwyg__toolbar-control\">\r\n\t<bui-select [items]=\"selectOptions()\"\r\n\t            [disabled]=\"disabled()\"\r\n\t            [ngModel]=\"value()\"\r\n\t            (ngModelChange)=\"onSelect($event)\"\r\n\t            [ngModelOptions]=\"{standalone: true}\"\r\n\t            [title]=\"tooltipLabelKey() | msgKey | async\"\r\n\t            [placeholder]=\"tooltipPlaceholderKey() | msgKey | async\"\r\n\t            [searchable]=\"false\"></bui-select>\r\n</div>" }]
        }] });
const StylesTool = {
    dependencies: [Styles],
    control: MenuSelectStylesComponent,
    optionMap: {
        [Styles.name]: Object.getOwnPropertyNames(Styles.options),
    },
};

const TOOL_MAP = {
    Bold: BoldTool,
    Italic: ItalicTool,
    Underline: UnderlineTool,
    Strike: StrikeTool,
    Subscript: SubscriptTool,
    Superscript: SuperscriptTool,
    Link: LinkTool,
    Unlink: UnlinkTool,
    Anchor: JumpAnchorTool,
    NumberedList: NumberedListTool,
    BulletedList: BulletedListTool,
    Outdent: OutdentTool,
    Indent: IndentTool,
    JustifyLeft: JustifyLeftTool,
    JustifyCenter: JustifyCenterTool,
    JustifyRight: JustifyRightTool,
    JustifyBlock: JustifyBlockTool,
    FontSize: FontSizeTool,
    TextColor: TextColorTool,
    BGColor: BGColorTool,
    Blockquote: BlockquoteTool,
    HorizontalRule: HorizontalRuleTool,
    RemoveFormat: RemoveFormatTool,
    Undo: UndoTool,
    Redo: RedoTool,
    ImageUpload: ImageUploadTool,
    Base64Image: Base64ImageTool,
    Html5Video: Html5VideoTool,
    Oembed: OembedTool,
    Styles: StylesTool,
    Placeholder: PlaceholderTool,
    SpecialChar: SpecialCharTool,
};

const WYSIWYG_DEFAULT_CONFIG = {
    config: {
        Link: ((config) => ({
            // autolink is generally useful for changing text into links if they
            // appear to be URLs (like someone types in literally "example.com"),
            // though it comes with the caveat that if you then *remove* the link
            // from the text, and then add a space or newline directly after the
            // text, autolink will turn the text back into a link again. Not ideal,
            // but probably still overall worth having autolink enabled, and that's
            // how a lot of other tools behave as well.
            autolink: config?.autolink ?? true,
            linkOnPaste: config?.linkOnPaste ?? true,
            openOnClick: config?.openOnClick ?? false,
            ...config,
        })),
        Oembed: ((config) => ({
            width: config?.width ?? 622,
            height: config?.height ?? 350,
            ...config,
        })),
        FontSize: ((config) => ({
            fontSizes: config?.fontSizes ?? ['8px', '10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px'],
        })),
        SpecialChar: ((config) => ({
            specialChars: config?.specialChars ?? [
                '!', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', '-', '.', '/', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                ':', ';', '<', '=', '>', '?', '@', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
                'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '[', ']', '^', '_', '`', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l',
                'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '{', '|', '}', '~', '€', '‘', '’', '“', '”', '–', '—',
                '¡', '¢', '£', '¤', '¥', '¦', '§', '¨', '©', 'ª', '«', '¬', '®', '¯', '°', '²', '³', '₂', '´', 'µ', '¶', '·', '¸', '¹', 'º',
                '»', '¼', '½', '¾', '¿', 'À', 'Á', 'Â', 'Ã', 'Ä', 'Å', 'Æ', 'Ç', 'È', 'É', 'Ê', 'Ë', 'Ì', 'Í', 'Î', 'Ï', 'Ð', 'Ñ', 'Ò', 'Ó',
                'Ô', 'Õ', 'Ö', '×', 'Ø', 'Ù', 'Ú', 'Û', 'Ü', 'Ý', 'Þ', 'ß', 'à', 'á', 'â', 'ã', 'ä', 'å', 'æ', 'ç', 'è', 'é', 'ê', 'ë', 'ì',
                'í', 'î', 'ï', 'ð', 'ñ', 'ò', 'ó', 'ô', 'õ', 'ö', '÷', 'ø', 'ù', 'ú', 'û', 'ü', 'ý', 'þ', 'ÿ', 'Œ', 'œ', 'Ŵ', 'Ŷ', 'ŵ', 'ŷ',
                '‚', '‛', '„', '…', '™', '►', '•', '→', '⇒', '⇔', '♦', '≈',
            ],
        })),
        // Es muss direkt die TextAlign-Extension konfiguriert werden, statt ein Tool,
        // da TextAlign nicht über ein einzelnes Tool gesteuert wird, sondern 4 Tools
        [TextAlign.name]: ((config) => {
            const types = new Set(config.types ?? []);
            types.add('paragraph');
            return { types: [...types] };
        }),
    },
    replace: {
        [Link.name]: {
            inclusive: false,
        },
    },
};
const WYSIWYG_DEFAULT_EXTENSIONS = [
    Document,
    Text,
    Dropcursor,
    Gapcursor,
    HardBreak,
    Paragraph,
];
const WYSIWYG_DEFAULT_EXTENSIONS_SINGLELINE = [
    Document.extend({
        content: 'inline*',
    }),
    Text,
    Dropcursor,
    Gapcursor,
];

const BUI_WYSIWYG_STATIC_CONFIG = new InjectionToken('BuiWysiwygStaticConfig');
const BUI_WYSIWYG_DYNAMIC_CONFIG = new InjectionToken('BuiWysiwygDynamicConfig');
const BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE = new InjectionToken('BuiWysiwygTiptapConfigService');
class WysiwygTiptapConfigService {
    constructor() {
        this._config = signal(null);
        this.config = computed(() => this._config()?.config);
        this.extensions = computed(() => this._config()?.extensions);
        this.transforms = computed(() => this._config()?.transforms);
    }
    configure(toolbar, customConfig, injector) {
        const tools = toolbar.flat()
            .filter(toolName => toolName !== '-')
            .flatMap(toolName => ({ tool: TOOL_MAP[toolName], name: toolName }));
        for (const { tool, name } of tools) {
            if (tool.conflicts?.length) {
                for (const conflict of tool.conflicts) {
                    if (tools.some(({ name }) => name === conflict)) {
                        throw new Error(`WYSIWYG-Tools "${name}" und "${conflict}" sind inkompatibel.`);
                    }
                }
            }
        }
        const singleLine = typeof customConfig.schema === 'function' ? customConfig.schema({}) : customConfig.schema?.singleLine ?? false;
        const defaultExtensions = singleLine ? WYSIWYG_DEFAULT_EXTENSIONS_SINGLELINE : WYSIWYG_DEFAULT_EXTENSIONS;
        const extensions = new Set(defaultExtensions);
        const replace = {};
        const config = injector.get(BUI_WYSIWYG_STATIC_CONFIG, () => ({}))();
        const dynamicConfig = injector.get(BUI_WYSIWYG_DYNAMIC_CONFIG, {});
        const transforms = {
            input: [],
            output: [],
        };
        for (const tool in WYSIWYG_DEFAULT_CONFIG.config) {
            config[tool] = WYSIWYG_DEFAULT_CONFIG.config[tool](config[tool] ?? {});
        }
        for (const name in dynamicConfig) {
            const configFn = dynamicConfig[name];
            config[name] = configFn(config[name] ?? {});
        }
        for (const name in customConfig) {
            config[name] = typeof customConfig[name] === 'function' ? customConfig[name](config[name] ?? {}) : customConfig[name];
        }
        for (const { tool, name } of tools) {
            for (const dependency of tool.dependencies) {
                extensions.add(dependency);
            }
            if (tool.config) {
                for (const [extensionName, configFn] of Object.entries(tool.config)) {
                    config[extensionName] = configFn(config[extensionName] ?? WYSIWYG_DEFAULT_CONFIG.config[extensionName] ?? {});
                }
            }
            if (tool.replace) {
                for (const [extensionName, replaceFn] of Object.entries(tool.replace)) {
                    replace[extensionName] = replaceFn(replace[extensionName] ?? WYSIWYG_DEFAULT_CONFIG.replace[extensionName] ?? {});
                }
            }
            if (tool.optionMap) {
                for (const [extensionName, optionMap] of Object.entries(tool.optionMap)) {
                    const map = Array.isArray(optionMap) ? Object.fromEntries(optionMap.map(key => [key, key])) : optionMap;
                    const options = Object.fromEntries(Object.entries(map)
                        .map(([configName, optionName]) => {
                        return [optionName, config[name]?.[configName]];
                    })
                        .filter(([_, value]) => value !== undefined));
                    if (Object.keys(options).length) {
                        config[extensionName] = {
                            ...options,
                            ...config[extensionName],
                        };
                    }
                }
            }
            const toolTransforms = config[name]?.transforms;
            if (toolTransforms?.input) {
                transforms.input.push(toolTransforms.input);
            }
            if (toolTransforms?.output) {
                transforms.output.push(toolTransforms.output);
            }
        }
        const configuredExtensions = [...extensions]
            .map(dependency => dependency instanceof Function ? dependency(injector) : dependency)
            .map(extension => replace[extension.name] ? extension.extend(replace[extension.name]) : extension)
            .map(extension => {
            if (!config[extension.name]) {
                return extension;
            }
            return extension.configure(config[extension.name]);
        });
        this._config.set({ extensions: configuredExtensions, config, transforms });
    }
}

const BUI_WYSIWYG_TOOLBAR_RESOLVER = new InjectionToken('BuiWysiwygToolbarResolver');

const VOID_ELEMENTS = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
class WysiwygComponent {
    constructor(createEffects) {
        this.toolbar = input(undefined);
        this.toolbarName = input(undefined);
        this.customConfig = input({});
        this.bgcolor = input();
        this.textcolor = input();
        this.placeholder = input();
        this.rows = input(undefined, { transform: coerceNumberProperty });
        this.resolvedToolbar = computed(() => {
            const toolbar = this.toolbar();
            const toolbarName = this.toolbarName();
            return this.resolveToolbar(toolbar, toolbarName);
        });
        this.tipTapToolbar = computed(() => typeof this.resolvedToolbar() === 'string' ? undefined : this.resolvedToolbar());
        this.toolbarError = computed(() => typeof this.resolvedToolbar() === 'string' ? this.resolvedToolbar() : undefined);
        this.value = signal(undefined);
        this.transformedValue = computed(() => this.transformOutput(this.value()));
        this.xhtmlifiedValue = computed(() => this.transformedValue()
            ?.replace(RegExp(`<(${VOID_ELEMENTS.join('|')})\\b([^>]*)>`, 'g'), (_match, tag, attrs) => `<${tag}${attrs}${attrs.endsWith('/') ? '' : '/'}>`));
        this.disabled = signal(false);
        this.editor = signal(undefined);
        /**
         * @Deprecated nur für die webcomponent gedacht
         * */
        this.name = input('');
        this.configService = inject(BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE, {
            self: true,
        });
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
        this.htmlTransforms = {
            input: [],
            output: [],
        };
        this.elRef = inject(ElementRef);
        this.toolbarResolver = inject(BUI_WYSIWYG_TOOLBAR_RESOLVER, { optional: true });
        this.injector = inject(Injector);
        this.TOOL_MAP = TOOL_MAP;
        if (createEffects ?? true) {
            this.createEffects();
        }
    }
    createEffects(isWebComponent = false) {
        explicitEffect([this.tipTapToolbar, this.customConfig], ([toolbar, customConfigInput]) => {
            this.editor()
                ?.destroy();
            if (!toolbar) {
                return;
            }
            const configure = () => {
                const customConfig = this.configureDefaultTextAlignment(customConfigInput);
                this.configService.configure(toolbar, customConfig, this.injector);
            };
            if (isWebComponent) {
                configure();
            }
            else {
                // Mit rAF auf DOM warten, sonst wurde text-align ggf noch nicht richtig vererbt
                requestAnimationFrame(() => {
                    configure();
                });
            }
        });
        explicitEffect([
            this.configService.config, this.configService.extensions, this.configService.transforms, this.placeholder,
        ], ([config, extensions, transforms, placeholder]) => {
            if (!(config && extensions && transforms)) {
                return;
            }
            if (placeholder) {
                extensions = [
                    ...extensions,
                    Placeholder$1.configure({
                        placeholder,
                    }),
                ];
            }
            this.htmlTransforms = transforms;
            this.value.set(this.transformInput(this.value()));
            this.editor.set(new Editor({
                extensions,
                onCreate: ({ editor }) => this.onEditorCreate(editor),
            }));
        });
    }
    onEditorCreate(editor) {
        // noop; nur für Webcomponent
    }
    onModelChange(val) {
        this.value.set(val);
        this._onChangeFn(this.transformedValue());
    }
    writeValue(obj) {
        this.value.set(this.transformInput(obj));
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    ngOnDestroy() {
        this.editor()
            ?.destroy();
    }
    stripTrailingP(val) {
        return val.endsWith('<p></p>') ? val.slice(0, -7) : val;
    }
    transformInput(html) {
        return html && this.htmlTransforms.input.reduce((value, input) => input(value), html);
    }
    transformOutput(html) {
        return html && this.stripTrailingP(this.htmlTransforms.output.reduce((value, output) => output(value), html));
    }
    resolveToolbar(customToolbar, toolbarName) {
        const resolvedToolbar = (() => {
            if (customToolbar && toolbarName === 'custom') {
                return customToolbar;
            }
            if (!toolbarName) {
                return 'Es wurde kein Toolbar-Name übergeben. Um eine custom Toolbar zu verwenden, muss der Toolbar-Name "custom" verwendet werden.';
            }
            if (!this.toolbarResolver) {
                return 'Um benannte Toolbars für <bui-wysiwyg> zu nutzen muss ein BUI_WYSIWYG_TOOLBAR_RESOLVER provided werden.';
            }
            const ckeToolbar = this.toolbarResolver.resolve(toolbarName);
            if (!ckeToolbar) {
                return `Unbekannte Toolbar "${toolbarName}"`;
            }
            return ckeToolbar;
        })();
        if (typeof resolvedToolbar === 'string') {
            return resolvedToolbar;
        }
        return resolvedToolbar?.map(toolbarSection => toolbarSection.filter(tool => tool === '-' || TOOL_MAP[tool] || console.warn(`Unbekanntes WYSIWYG Tool ${tool}`)))
            .filter(toolbarSection => toolbarSection.length);
    }
    configureDefaultTextAlignment(customConfigInput) {
        const customConfig = { ...customConfigInput };
        const defaultAlignment = window.getComputedStyle(this.elRef.nativeElement).textAlign ?? 'left';
        const textAlignName = TextAlign.name;
        if (!customConfig[textAlignName]) {
            customConfig[textAlignName] = ((textAlignOptions) => ({
                ...textAlignOptions,
                defaultAlignment,
            }));
        }
        else if (typeof customConfig[textAlignName] === 'function') {
            const existingFn = customConfig[textAlignName];
            customConfig[textAlignName] = ((textAlignOptions) => existingFn({
                ...textAlignOptions,
                defaultAlignment,
            }));
        }
        else if (!('defaultAlignment' in customConfig[textAlignName])) {
            customConfig[textAlignName].defaultAlignment = defaultAlignment;
        }
        return customConfig;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: WysiwygComponent, deps: [{ token: 'DAS_TOKEN_EXISTIERT_NICHT_ABER_DER_COMPILER_GEHT_NICHT_OHNE_INJECT', optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: WysiwygComponent, isStandalone: true, selector: "bui-wysiwyg", inputs: { toolbar: { classPropertyName: "toolbar", publicName: "toolbar", isSignal: true, isRequired: false, transformFunction: null }, toolbarName: { classPropertyName: "toolbarName", publicName: "toolbarName", isSignal: true, isRequired: false, transformFunction: null }, customConfig: { classPropertyName: "customConfig", publicName: "customConfig", isSignal: true, isRequired: false, transformFunction: null }, bgcolor: { classPropertyName: "bgcolor", publicName: "bgcolor", isSignal: true, isRequired: false, transformFunction: null }, textcolor: { classPropertyName: "textcolor", publicName: "textcolor", isSignal: true, isRequired: false, transformFunction: null }, placeholder: { classPropertyName: "placeholder", publicName: "placeholder", isSignal: true, isRequired: false, transformFunction: null }, rows: { classPropertyName: "rows", publicName: "rows", isSignal: true, isRequired: false, transformFunction: null }, name: { classPropertyName: "name", publicName: "name", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-wysiwyg": "true", "class.bui-wysiwyg--singleline": "configService.config()?.schema?.singleLine", "style.--bui-wysiwyg--rows": "rows()" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => WysiwygComponent),
                multi: true,
            }, {
                provide: BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE,
                useClass: WysiwygTiptapConfigService,
            },
        ], ngImport: i0, template: "@if (editor()) {\r\n\t@if (!disabled()) {\r\n\t\t<div class=\"bui-wysiwyg__toolbar\">\r\n\t\t\t@for (toolbarSection of tipTapToolbar(); track $index) {\r\n\t\t\t\t<bui-button-group class=\"bui-wysiwyg__toolbar-section\">\r\n\t\t\t\t\t@for (tool of toolbarSection; track $index) {\r\n\t\t\t\t\t\t@if (tool === '-') {\r\n\t\t\t\t\t\t\t<div class=\"bui-wysiwyg__toolbar-divider\"></div>\r\n\t\t\t\t\t\t} @else {\r\n\t\t\t\t\t\t\t<ng-container *ngComponentOutlet=\"TOOL_MAP[tool].control; inputs: { editor: editor() }\"></ng-container>\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t</bui-button-group>\r\n\t\t\t}\r\n\t\t</div>\r\n\t}\r\n\t<tiptap-editor class=\"bui-wysiwyg__editor\"\r\n\t               buiValidationControl\r\n\t               [editor]=\"editor()!\"\r\n\t               [ngModel]=\"value()\"\r\n\t               (ngModelChange)=\"onModelChange($event)\"\r\n\t               [disabled]=\"disabled()\"\r\n\t               [class.bui-wysiwyg__editor--disabled]=\"disabled()\"\r\n\t               [style.color]=\"textcolor()\"\r\n\t               [style.background-color]=\"bgcolor()\"></tiptap-editor>    <!-- wird nur in webcomponent ausgelesen -->\r\n\t<div class=\"bui-wysiwyg__content\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n\t<input type=\"hidden\"\r\n\t       [disabled]=\"disabled()\"\r\n\t       [attr.name]=\"name()\"\r\n\t       [value]=\"xhtmlifiedValue()\"/>\r\n}\r\n@if (toolbarError()) {\r\n\t<div class=\"bui-wysiwyg__toolbar-error\">\r\n\t\t<p>Beim Initialisieren der Toolbar ist ein Fehler aufgetreten:</p>\r\n\t\t<p>{{ toolbarError() }}</p>\r\n\t</div>\r\n}", dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: TiptapEditorDirective, selector: "tiptap[editor], [tiptap][editor], tiptap-editor[editor], [tiptapEditor][editor]", inputs: ["editor", "outputFormat"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }, { kind: "directive", type: NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"], exportAs: ["ngComponentOutlet"] }, { kind: "component", type: ButtonGroupComponent, selector: "bui-button-group", inputs: ["disabled"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: WysiwygComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-wysiwyg', encapsulation: ViewEncapsulation.None, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => WysiwygComponent),
                            multi: true,
                        }, {
                            provide: BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE,
                            useClass: WysiwygTiptapConfigService,
                        },
                    ], imports: [
                        FormsModule,
                        TiptapEditorDirective,
                        ReactiveFormsModule,
                        ValidationControlDirective,
                        NgComponentOutlet,
                        ButtonGroupComponent,
                    ], host: {
                        '[class.bui-wysiwyg]': 'true',
                        '[class.bui-wysiwyg--singleline]': 'configService.config()?.schema?.singleLine',
                        '[style.--bui-wysiwyg--rows]': 'rows()',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, template: "@if (editor()) {\r\n\t@if (!disabled()) {\r\n\t\t<div class=\"bui-wysiwyg__toolbar\">\r\n\t\t\t@for (toolbarSection of tipTapToolbar(); track $index) {\r\n\t\t\t\t<bui-button-group class=\"bui-wysiwyg__toolbar-section\">\r\n\t\t\t\t\t@for (tool of toolbarSection; track $index) {\r\n\t\t\t\t\t\t@if (tool === '-') {\r\n\t\t\t\t\t\t\t<div class=\"bui-wysiwyg__toolbar-divider\"></div>\r\n\t\t\t\t\t\t} @else {\r\n\t\t\t\t\t\t\t<ng-container *ngComponentOutlet=\"TOOL_MAP[tool].control; inputs: { editor: editor() }\"></ng-container>\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t</bui-button-group>\r\n\t\t\t}\r\n\t\t</div>\r\n\t}\r\n\t<tiptap-editor class=\"bui-wysiwyg__editor\"\r\n\t               buiValidationControl\r\n\t               [editor]=\"editor()!\"\r\n\t               [ngModel]=\"value()\"\r\n\t               (ngModelChange)=\"onModelChange($event)\"\r\n\t               [disabled]=\"disabled()\"\r\n\t               [class.bui-wysiwyg__editor--disabled]=\"disabled()\"\r\n\t               [style.color]=\"textcolor()\"\r\n\t               [style.background-color]=\"bgcolor()\"></tiptap-editor>    <!-- wird nur in webcomponent ausgelesen -->\r\n\t<div class=\"bui-wysiwyg__content\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n\t<input type=\"hidden\"\r\n\t       [disabled]=\"disabled()\"\r\n\t       [attr.name]=\"name()\"\r\n\t       [value]=\"xhtmlifiedValue()\"/>\r\n}\r\n@if (toolbarError()) {\r\n\t<div class=\"bui-wysiwyg__toolbar-error\">\r\n\t\t<p>Beim Initialisieren der Toolbar ist ein Fehler aufgetreten:</p>\r\n\t\t<p>{{ toolbarError() }}</p>\r\n\t</div>\r\n}" }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['DAS_TOKEN_EXISTIERT_NICHT_ABER_DER_COMPILER_GEHT_NICHT_OHNE_INJECT']
                }, {
                    type: Optional
                }] }] });

class WysiwygWebcomponent extends WysiwygComponent {
    constructor() {
        super(false);
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        // @ts-ignore
        this.toolbar = input(undefined);
        this.customToolbarConfig = input(undefined, {
            alias: 'custom-toolbar-config',
            transform: (value) => JSON.parse(`[${value.replace(/'/g, '"')}]`)
                .map((toolbarSection) => toolbarSection.map(tool => TOOL_MAP_LOWERCASE[tool.toLowerCase()])),
        });
        this.placeholders = input(false, {
            transform: (value) => coerceBooleanProperty(value),
        });
        this.elementRef = inject((ElementRef));
        this.resolvedToolbar = computed(() => {
            const toolbar = this.toolbar();
            const customToolbarConfig = this.customToolbarConfig();
            const placeholders = this.placeholders();
            const resolvedToolbar = this.resolveToolbar(customToolbarConfig, toolbar);
            if (placeholders && Array.isArray(resolvedToolbar)) {
                resolvedToolbar.push(['Placeholder']);
            }
            return resolvedToolbar;
        });
        this.tipTapToolbar = computed(() => typeof this.resolvedToolbar() === 'string'
            ? undefined
            : this.resolvedToolbar());
        this.toolbarError = computed(() => typeof this.resolvedToolbar() === 'string' ? this.resolvedToolbar() : undefined);
        this.customToolbarFontSize = input(undefined, {
            alias: 'custom-config-font-size',
            transform: (value) => value.split(';'),
        });
        this.singleline = input(false, { transform: coerceBooleanProperty });
        // @ts-expect-error - customConfig wird in der Webcomponent nicht per Input gesetzt
        this.customConfig = computed(() => {
            const config = {};
            const customToolbarFontSize = this.customToolbarFontSize();
            if (customToolbarFontSize) {
                config.FontSize = (fontSizeConfig) => ({
                    ...(fontSizeConfig || {}),
                    fontSizes: customToolbarFontSize,
                });
            }
            const singleline = this.singleline();
            if (singleline) {
                config.schema = {
                    singleLine: true,
                };
            }
            return config;
        });
        this.valueInput = input(undefined, { alias: 'value' });
        this.valueChange = output();
        this.createEffects(true);
        explicitEffect([this.valueInput], ([valueInput]) => {
            this.writeValue(valueInput);
        });
        explicitEffect([this.disabledInput], ([disabled]) => {
            this.setDisabledState(disabled);
        });
        explicitEffect([this.value], ([value]) => {
            this.valueChange.emit(value);
        });
    }
    /**
     * Nach Initialisierung des Editors den von außen gesetzten Wert einmal durch TipTap jagen,
     * um den Form Value mit dem TipTap Schema zu synchronisieren
     */
    onEditorCreate(editor) {
        this.value.set(editor.getHTML());
    }
    ngAfterViewInit() {
        if (this.valueInput()) {
            return;
        }
        this.writeValue(this.elementRef.nativeElement.querySelector('.bui-wysiwyg__content')?.innerHTML);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: WysiwygWebcomponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: WysiwygWebcomponent, isStandalone: true, selector: "ng-component", inputs: { disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, toolbar: { classPropertyName: "toolbar", publicName: "toolbar", isSignal: true, isRequired: false, transformFunction: null }, customToolbarConfig: { classPropertyName: "customToolbarConfig", publicName: "custom-toolbar-config", isSignal: true, isRequired: false, transformFunction: null }, placeholders: { classPropertyName: "placeholders", publicName: "placeholders", isSignal: true, isRequired: false, transformFunction: null }, customToolbarFontSize: { classPropertyName: "customToolbarFontSize", publicName: "custom-config-font-size", isSignal: true, isRequired: false, transformFunction: null }, singleline: { classPropertyName: "singleline", publicName: "singleline", isSignal: true, isRequired: false, transformFunction: null }, valueInput: { classPropertyName: "valueInput", publicName: "value", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { valueChange: "valueChange" }, providers: [
            {
                provide: BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE,
                useClass: WysiwygTiptapConfigService,
            },
        ], usesInheritance: true, ngImport: i0, template: "@if (editor()) {\r\n\t@if (!disabled()) {\r\n\t\t<div class=\"bui-wysiwyg__toolbar\">\r\n\t\t\t@for (toolbarSection of tipTapToolbar(); track $index) {\r\n\t\t\t\t<bui-button-group class=\"bui-wysiwyg__toolbar-section\">\r\n\t\t\t\t\t@for (tool of toolbarSection; track $index) {\r\n\t\t\t\t\t\t@if (tool === '-') {\r\n\t\t\t\t\t\t\t<div class=\"bui-wysiwyg__toolbar-divider\"></div>\r\n\t\t\t\t\t\t} @else {\r\n\t\t\t\t\t\t\t<ng-container *ngComponentOutlet=\"TOOL_MAP[tool].control; inputs: { editor: editor() }\"></ng-container>\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t</bui-button-group>\r\n\t\t\t}\r\n\t\t</div>\r\n\t}\r\n\t<tiptap-editor class=\"bui-wysiwyg__editor\"\r\n\t               buiValidationControl\r\n\t               [editor]=\"editor()!\"\r\n\t               [ngModel]=\"value()\"\r\n\t               (ngModelChange)=\"onModelChange($event)\"\r\n\t               [disabled]=\"disabled()\"\r\n\t               [class.bui-wysiwyg__editor--disabled]=\"disabled()\"\r\n\t               [style.color]=\"textcolor()\"\r\n\t               [style.background-color]=\"bgcolor()\"></tiptap-editor>    <!-- wird nur in webcomponent ausgelesen -->\r\n\t<div class=\"bui-wysiwyg__content\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n\t<input type=\"hidden\"\r\n\t       [disabled]=\"disabled()\"\r\n\t       [attr.name]=\"name()\"\r\n\t       [value]=\"xhtmlifiedValue()\"/>\r\n}\r\n@if (toolbarError()) {\r\n\t<div class=\"bui-wysiwyg__toolbar-error\">\r\n\t\t<p>Beim Initialisieren der Toolbar ist ein Fehler aufgetreten:</p>\r\n\t\t<p>{{ toolbarError() }}</p>\r\n\t</div>\r\n}", dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: TiptapEditorDirective, selector: "tiptap[editor], [tiptap][editor], tiptap-editor[editor], [tiptapEditor][editor]", inputs: ["editor", "outputFormat"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"], exportAs: ["ngComponentOutlet"] }, { kind: "component", type: ButtonGroupComponent, selector: "bui-button-group", inputs: ["disabled"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: WysiwygWebcomponent, decorators: [{
            type: Component,
            args: [{ encapsulation: ViewEncapsulation.None, imports: [
                        FormsModule,
                        TiptapEditorDirective,
                        ReactiveFormsModule,
                        NgComponentOutlet,
                        ButtonGroupComponent,
                    ], providers: [
                        {
                            provide: BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE,
                            useClass: WysiwygTiptapConfigService,
                        },
                    ], template: "@if (editor()) {\r\n\t@if (!disabled()) {\r\n\t\t<div class=\"bui-wysiwyg__toolbar\">\r\n\t\t\t@for (toolbarSection of tipTapToolbar(); track $index) {\r\n\t\t\t\t<bui-button-group class=\"bui-wysiwyg__toolbar-section\">\r\n\t\t\t\t\t@for (tool of toolbarSection; track $index) {\r\n\t\t\t\t\t\t@if (tool === '-') {\r\n\t\t\t\t\t\t\t<div class=\"bui-wysiwyg__toolbar-divider\"></div>\r\n\t\t\t\t\t\t} @else {\r\n\t\t\t\t\t\t\t<ng-container *ngComponentOutlet=\"TOOL_MAP[tool].control; inputs: { editor: editor() }\"></ng-container>\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t</bui-button-group>\r\n\t\t\t}\r\n\t\t</div>\r\n\t}\r\n\t<tiptap-editor class=\"bui-wysiwyg__editor\"\r\n\t               buiValidationControl\r\n\t               [editor]=\"editor()!\"\r\n\t               [ngModel]=\"value()\"\r\n\t               (ngModelChange)=\"onModelChange($event)\"\r\n\t               [disabled]=\"disabled()\"\r\n\t               [class.bui-wysiwyg__editor--disabled]=\"disabled()\"\r\n\t               [style.color]=\"textcolor()\"\r\n\t               [style.background-color]=\"bgcolor()\"></tiptap-editor>    <!-- wird nur in webcomponent ausgelesen -->\r\n\t<div class=\"bui-wysiwyg__content\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n\t<input type=\"hidden\"\r\n\t       [disabled]=\"disabled()\"\r\n\t       [attr.name]=\"name()\"\r\n\t       [value]=\"xhtmlifiedValue()\"/>\r\n}\r\n@if (toolbarError()) {\r\n\t<div class=\"bui-wysiwyg__toolbar-error\">\r\n\t\t<p>Beim Initialisieren der Toolbar ist ein Fehler aufgetreten:</p>\r\n\t\t<p>{{ toolbarError() }}</p>\r\n\t</div>\r\n}" }]
        }], ctorParameters: () => [] });
const TOOL_MAP_LOWERCASE = Object.fromEntries(Object.keys(TOOL_MAP)
    .map(tool => [tool.toLowerCase(), tool]));

const webcomponents = {
    'bwc-date-picker': DatePickerWebcomponent,
    'bwc-select': SelectWebcomponent,
    'bwc-wysiwyg': WysiwygWebcomponent,
};
function createCustomElements(injector) {
    Object.entries(webcomponents)
        .forEach(([tag, component]) => {
        // convert to a custom element
        const customElement = createCustomElement(component, { injector });
        // register the custom element
        customElements.define(tag, customElement);
    });
}

class ButtonLineComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonLineComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: ButtonLineComponent, isStandalone: true, selector: "bui-button-line", host: { properties: { "class.bui-button-line": "true" } }, ngImport: i0, template: `
		<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonLineComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-button-line',
                    template: `
		<ng-content></ng-content>`,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        '[class.bui-button-line]': 'true',
                    },
                }]
        }] });

class InputOption {
    constructor() {
        this.value = input();
        this.selectedInput = input(false, { alias: 'selected', transform: coerceBooleanProperty });
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.selected = linkedSignal(() => this.selectedInput());
        this.disabledWithGroup = computed(() => this.group?.disabled() || this.disabledInput());
        this.disabled = linkedSignal(() => this.disabledWithGroup());
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
    }
    ngOnDestroy() {
        if (this.group && this.selected()) {
            this.selected.set(false);
            this.group._syncOptionState(this);
        }
    }
    writeValue(value) {
        this.selected.set(value);
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    _onChange() {
        const newValue = (this.group?.multiple() ?? true) ? !this.selected() : true;
        if (newValue !== this.selected()) {
            this.selected.set(newValue);
            this._onChangeFn(newValue);
            this.group?._syncOptionState(this);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputOption, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "19.1.1", type: InputOption, isStandalone: true, inputs: { value: { classPropertyName: "value", publicName: "value", isSignal: true, isRequired: false, transformFunction: null }, selectedInput: { classPropertyName: "selectedInput", publicName: "selected", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputOption, decorators: [{
            type: Directive
        }], ctorParameters: () => [] });

class InputOptionGroup {
    constructor() {
        this.multiple = input(false, { transform: coerceBooleanProperty });
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.disabled = linkedSignal(() => this.disabledInput());
        this.value = new Set();
        this.valueOptionMap = computed(() => Object.fromEntries(this.optionComponents()
            .map(option => [option.value(), option])));
        this.injector = inject(Injector);
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
    }
    ngAfterContentChecked() {
        runInInjectionContext(this.injector, () => {
            explicitEffect([this.optionComponents], () => this._syncOptions());
        });
    }
    writeValue(value) {
        this.value = new Set(value !== null && value !== undefined && !Array.isArray(value) ? [value] : (value ?? []));
        this._syncOptions();
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    _syncOptions() {
        this.optionComponents()
            .forEach(option => {
            option.writeValue(this.value.has(option.value()));
        });
    }
    _syncOptionState(option) {
        const selected = option.selected();
        if (this.multiple()) {
            if (selected) {
                this.value.add(option.value());
            }
            else {
                this.value.delete(option.value());
            }
        }
        else {
            this.value.forEach(value => value !== option.value() && this.valueOptionMap()[value].writeValue(false));
            if (selected) {
                this.value = new Set([option.value()]);
            }
            else {
                this.value = new Set();
            }
        }
        this._onChangeFn(this.multiple() ? Array.from(this.value) : Array.from(this.value)[0]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputOptionGroup, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "19.1.1", type: InputOptionGroup, isStandalone: true, inputs: { multiple: { classPropertyName: "multiple", publicName: "multiple", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: InputOptionGroup, decorators: [{
            type: Directive
        }], ctorParameters: () => [] });

const BUI_BUTTON_TOGGLE = new InjectionToken('BuiButtonToggleComponent');
class ButtonToggleComponent extends InputOptionGroup {
    constructor() {
        super(...arguments);
        this.optionComponents = contentChildren(forwardRef(() => ButtonToggleOptionComponent));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonToggleComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: ButtonToggleComponent, isStandalone: true, selector: "bui-button-toggle", host: { properties: { "class.bui-button-toggle": "true", "class.disabled": "disabled()", "attr.buiValidationControl": "true" } }, providers: [
            { provide: BUI_BUTTON_TOGGLE, useExisting: ButtonToggleComponent },
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: ButtonToggleComponent,
                multi: true,
            },
        ], queries: [{ propertyName: "optionComponents", predicate: i0.forwardRef(() => ButtonToggleOptionComponent), isSignal: true }], usesInheritance: true, hostDirectives: [{ directive: ValidationControlDirective }], ngImport: i0, template: `
		<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonToggleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-button-toggle',
                    template: `
		<ng-content></ng-content>`,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        { provide: BUI_BUTTON_TOGGLE, useExisting: ButtonToggleComponent },
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: ButtonToggleComponent,
                            multi: true,
                        },
                    ],
                    hostDirectives: [
                        ValidationControlDirective,
                    ],
                    host: {
                        '[class.bui-button-toggle]': 'true',
                        '[class.disabled]': 'disabled()',
                        '[attr.buiValidationControl]': 'true',
                    },
                }]
        }] });

class ButtonToggleOptionComponent extends InputOption {
    constructor() {
        super(...arguments);
        this.tabindex = input(null);
        this.buttonComponent = viewChild.required('buttonComponent');
        this.group = inject(BUI_BUTTON_TOGGLE, { optional: true });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonToggleOptionComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: ButtonToggleOptionComponent, isStandalone: true, selector: "bui-button-toggle-option", inputs: { tabindex: { classPropertyName: "tabindex", publicName: "tabindex", isSignal: true, isRequired: false, transformFunction: null } }, host: { listeners: { "focus": "buttonComponent().nativeElement.focus()" }, properties: { "class.bui-button-toggle-option": "true" } }, viewQueries: [{ propertyName: "buttonComponent", first: true, predicate: ["buttonComponent"], descendants: true, isSignal: true }], usesInheritance: true, ngImport: i0, template: "<button type=\"button\"\r\n        bui-button\r\n        #buttonComponent\r\n        [tabindex]=\"tabindex()\"\r\n        [disabled]=\"disabled()\"\r\n        [color]=\"selected() ? 'primary' : 'default'\"\r\n        (click)=\"_onChange()\">\r\n\t<ng-content></ng-content>\r\n</button>", dependencies: [{ kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ButtonToggleOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-button-toggle-option', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        ButtonComponent,
                    ], host: {
                        '[class.bui-button-toggle-option]': 'true',
                        '(focus)': 'buttonComponent().nativeElement.focus()',
                    }, template: "<button type=\"button\"\r\n        bui-button\r\n        #buttonComponent\r\n        [tabindex]=\"tabindex()\"\r\n        [disabled]=\"disabled()\"\r\n        [color]=\"selected() ? 'primary' : 'default'\"\r\n        (click)=\"_onChange()\">\r\n\t<ng-content></ng-content>\r\n</button>" }]
        }] });

class CardComponent {
    constructor() {
        this.elRef = inject(ElementRef);
    }
    ngOnInit() {
        const parent = this.elRef.nativeElement.parentElement;
        const classes = parent.classList;
        if (classes.contains('bui-row')) {
            classes.add('bui-row--has-cards');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: CardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: CardComponent, isStandalone: true, selector: "bui-card", host: { properties: { "class.bui-card": "true" } }, ngImport: i0, template: "<div class=\"bui-card__wrapper\">\r\n\t<div class=\"bui-card__content\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n</div>\r\n", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-card', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.bui-card]': 'true',
                    }, template: "<div class=\"bui-card__wrapper\">\r\n\t<div class=\"bui-card__content\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [] });

class CheckboxComponent extends InputOption {
    constructor() {
        super(...arguments);
        this.checkboxRef = viewChild.required('checkboxRef');
        this.nativeElement = computed(() => this.checkboxRef().nativeElement);
        this.group = inject(BUI_CHECKBOX_GROUP, { optional: true });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: CheckboxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: CheckboxComponent, isStandalone: true, selector: "bui-checkbox", host: { properties: { "class.bui-checkbox": "true", "attr.buiValidationControl": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: CheckboxComponent,
                multi: true,
            },
        ], viewQueries: [{ propertyName: "checkboxRef", first: true, predicate: ["checkboxRef"], descendants: true, isSignal: true }], usesInheritance: true, hostDirectives: [{ directive: ValidationControlDirective }], ngImport: i0, template: "<label [class.disabled]=\"disabled()\">\r\n\t<input type=\"checkbox\"\r\n\t       #checkboxRef\r\n\t       [ngModel]=\"selected()\"\r\n\t       (ngModelChange)=\"_onChange()\"\r\n\t       [class.disabled]=\"disabled()\"\r\n\t       [disabled]=\"disabled()\">\r\n\t<span class=\"bui-checkbox__label\"><ng-content></ng-content></span>\r\n</label>", dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-checkbox', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        FormsModule,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: CheckboxComponent,
                            multi: true,
                        },
                    ], hostDirectives: [ValidationControlDirective], host: {
                        '[class.bui-checkbox]': 'true',
                        '[attr.buiValidationControl]': 'true',
                    }, template: "<label [class.disabled]=\"disabled()\">\r\n\t<input type=\"checkbox\"\r\n\t       #checkboxRef\r\n\t       [ngModel]=\"selected()\"\r\n\t       (ngModelChange)=\"_onChange()\"\r\n\t       [class.disabled]=\"disabled()\"\r\n\t       [disabled]=\"disabled()\">\r\n\t<span class=\"bui-checkbox__label\"><ng-content></ng-content></span>\r\n</label>" }]
        }] });

const BUI_CHECKBOX_GROUP = new InjectionToken('BuiCheckboxGroupComponent');
class CheckboxGroupComponent extends InputOptionGroup {
    constructor() {
        super(...arguments);
        // Checkbox-Gruppen machen nur mit Mehrfachauswahl Sinn → multiple ignorieren (immer true)
        this.multiple = input(true, { transform: (value) => true });
        this.optionComponents = contentChildren(forwardRef(() => CheckboxComponent));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: CheckboxGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: CheckboxGroupComponent, isStandalone: true, selector: "bui-checkbox-group", inputs: { multiple: { classPropertyName: "multiple", publicName: "multiple", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-checkbox-group": "true", "class.disabled": "disabled()", "attr.buiValidationControl": "true" } }, providers: [
            { provide: BUI_CHECKBOX_GROUP, useExisting: CheckboxGroupComponent },
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: CheckboxGroupComponent,
                multi: true,
            },
        ], queries: [{ propertyName: "optionComponents", predicate: i0.forwardRef(() => CheckboxComponent), isSignal: true }], usesInheritance: true, hostDirectives: [{ directive: ValidationControlDirective }], ngImport: i0, template: `
		<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: CheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-checkbox-group',
                    template: `
		<ng-content></ng-content>`,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        { provide: BUI_CHECKBOX_GROUP, useExisting: CheckboxGroupComponent },
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: CheckboxGroupComponent,
                            multi: true,
                        },
                    ],
                    hostDirectives: [
                        ValidationControlDirective,
                    ],
                    host: {
                        '[class.bui-checkbox-group]': 'true',
                        '[class.disabled]': 'disabled()',
                        '[attr.buiValidationControl]': 'true',
                    },
                }]
        }] });

class ColorPickerComponent {
    constructor() {
        this.value = model('');
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.disabled = linkedSignal(() => this.disabledInput());
        this.colorInputElement = viewChild.required('colorInput');
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
    }
    onClick() {
        if (!this.disabled()) {
            this.colorInputElement()
                .nativeElement
                .click();
        }
    }
    onInput(event) {
        this.value.set(event.target.value);
        this._onChangeFn(this.value());
        this._onTouchedFn();
    }
    writeValue(obj) {
        this.value.set(obj);
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ColorPickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: ColorPickerComponent, isStandalone: true, selector: "bui-color-picker", inputs: { value: { classPropertyName: "value", publicName: "value", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { value: "valueChange" }, host: { properties: { "class.bui-color-picker": "true", "class.disabled": "disabled()" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: ColorPickerComponent,
                multi: true,
            },
        ], viewQueries: [{ propertyName: "colorInputElement", first: true, predicate: ["colorInput"], descendants: true, isSignal: true }], ngImport: i0, template: "<div #selectedColor\r\n     (click)=\"onClick()\"\r\n     class=\"selectedColor\"\r\n     [style.background-color]=\"value()\"></div>\r\n<div class=\"color-picker-icon\">\r\n\t<mat-icon (click)=\"onClick()\"\r\n\t          class=\"material-symbols-outlined\">colorized\r\n\t</mat-icon>\r\n\t<input #colorInput\r\n\t       (input)=\"onInput($event)\"\r\n\t       class=\"colorInput\"\r\n\t       type=\"color\"\r\n\t       [value]=\"value()\">\r\n</div>\r\n", dependencies: [{ kind: "ngmodule", type: MatIconModule }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: ColorPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-color-picker', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        MatIconModule,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: ColorPickerComponent,
                            multi: true,
                        },
                    ], host: {
                        '[class.bui-color-picker]': 'true',
                        '[class.disabled]': 'disabled()',
                    }, template: "<div #selectedColor\r\n     (click)=\"onClick()\"\r\n     class=\"selectedColor\"\r\n     [style.background-color]=\"value()\"></div>\r\n<div class=\"color-picker-icon\">\r\n\t<mat-icon (click)=\"onClick()\"\r\n\t          class=\"material-symbols-outlined\">colorized\r\n\t</mat-icon>\r\n\t<input #colorInput\r\n\t       (input)=\"onInput($event)\"\r\n\t       class=\"colorInput\"\r\n\t       type=\"color\"\r\n\t       [value]=\"value()\">\r\n</div>\r\n" }]
        }], ctorParameters: () => [] });

class DataTableComponent {
    constructor() {
        this._componentClass = true;
        this._cols = {};
        this._originalItems = [];
        this._sortedItems = [];
        this._currentItems = [];
        this._sortDir = 'asc';
        this._disablePagination = false;
        this._itemsPerPage = 5;
        this._sortable = false;
        this.loading = false;
        this.templates = {};
        this._page = 1;
        this._pageCount = 1;
        this._pages = [1];
        this.msgService = inject(MessageService);
    }
    set cols(cols) {
        cols = cols ?? [];
        this._cols = Object.fromEntries(cols.map(col => [
            col.key,
            {
                ...col,
                title: col.title ?? col.key,
                width: typeof col.width === 'number' ? `${col.width}px` : col.width,
            },
        ]));
        this._sortable = cols.some(col => col.sortable);
    }
    get cols() {
        return Object.values(this._cols);
    }
    set items(items) {
        this._originalItems = items;
        this.refreshPages();
        this.sortItems();
        this.refreshItems();
    }
    get items() {
        return this._currentItems;
    }
    set sortKey(sortKey) {
        this._sortKey = sortKey;
    }
    set sortDir(sortDir) {
        this._sortDir = sortDir;
    }
    set disablePagination(disablePagination) {
        this._disablePagination = coerceBooleanProperty(disablePagination);
        this.refreshItems();
        this.refreshPages();
    }
    set itemsPerPage(itemsPerPage) {
        const firstItemOnPage = Math.max((this._page - 1) * this._itemsPerPage + 1, 1);
        this._itemsPerPage = itemsPerPage;
        this.refreshPages();
        this.page = Math.ceil(firstItemOnPage / itemsPerPage);
    }
    get itemsPerPage() {
        return this._itemsPerPage;
    }
    set page(page) {
        this._page = Math.min(Math.max(page, 1), this._pageCount);
        this.refreshItems();
    }
    get page() {
        return this._page;
    }
    ngOnInit() {
        if (this.itemsPerPageOptions) {
            return;
        }
        this.msgService.resolve('bui.data-table.itemsPerPage.all')
            .pipe(take(1))
            .subscribe(msg => this.itemsPerPageOptions = this.itemsPerPageOptions ?? [
            { value: 5, label: '5' },
            { value: 10, label: '10' },
            { value: 20, label: '20' },
            { value: 35, label: '35' },
            { value: 50, label: '50' },
            { value: 100, label: '100' },
            { value: -1, label: msg },
        ]);
    }
    refreshPages() {
        const items = this._originalItems ?? [];
        this._pageCount = Math.max(1, Math.ceil(items.length / this.itemsPerPage));
        this._pages = Array.from({ length: this._pageCount }, (_, i) => i + 1);
    }
    sortItems() {
        const key = this._sortKey;
        if (key === undefined || !this._originalItems) {
            this._sortedItems = this._originalItems ?? [];
            return;
        }
        const colDef = this._cols[key];
        const comparator = colDef.comparator;
        if (comparator) {
            const sorted = this._originalItems;
            sorted.sort(comparator);
            this._sortedItems = sorted;
            return;
        }
        const parser = colDef.parser;
        if (parser) {
            this._originalItems.forEach(item => {
                item.parsedSortValue = item.parsedSortValue ?? parser(item);
            });
        }
        else {
            this._originalItems.forEach(item => {
                item.parsedSortValue = item[colDef.key];
            });
        }
        const sortDirMultiplier = this._sortDir === 'asc' ? 1 : -1;
        const sorted = this._originalItems;
        sorted.sort((a, b) => {
            const aValue = a.parsedSortValue;
            const bValue = b.parsedSortValue;
            if (aValue === bValue) {
                return 0;
            }
            return (aValue > bValue ? 1 : -1) * sortDirMultiplier;
        });
        this._sortedItems = sorted;
    }
    refreshItems() {
        if (this._disablePagination || this._itemsPerPage === -1) {
            this._currentItems = this._sortedItems;
            return;
        }
        const start = (this._page - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        this._currentItems = this._sortedItems.slice(start, end);
    }
    prev() {
        this.page = this._page - 1;
    }
    next() {
        this.page = this._page + 1;
    }
    sortBy(key) {
        if (!this._cols[key].sortable) {
            return;
        }
        if (!this._sortKey || this._sortKey !== key) {
            this._sortKey = key;
            this._sortDir = 'asc';
        }
        else {
            this._sortDir = this._sortDir === 'asc' ? 'desc' : 'asc';
        }
        this.sortItems();
        this.refreshItems();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DataTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: DataTableComponent, isStandalone: true, selector: "bui-data-table", inputs: { cols: "cols", items: "items", sortKey: "sortKey", sortDir: "sortDir", disablePagination: "disablePagination", itemsPerPage: "itemsPerPage", itemsPerPageOptions: "itemsPerPageOptions", loading: "loading", templates: "templates" }, host: { properties: { "class.bui-data-table": "this._componentClass" } }, queries: [{ propertyName: "_footerTemplate", first: true, predicate: ["footer"], descendants: true }], ngImport: i0, template: "<table class=\"bui-data-table__table\">\r\n\t<thead>\r\n\t\t<tr class=\"bui-data-table__header-row\">\r\n\t\t\t<th *ngFor=\"let col of cols\"\r\n\t\t\t    class=\"bui-data-table__header-cell\"\r\n\t\t\t    [class]=\"col.align ? 'bui-data-table__header-cell--align-' + col.align : ''\"\r\n\t\t\t    [class.bui-data-table__header-cell--shrink]=\"col.shrink\"\r\n\t\t\t    [style.width]=\"col.width\">\r\n\t\t\t\t<ng-container *ngIf=\"!col.sortable; else sortLink\">\r\n\t\t\t\t\t{{ col.title }}\r\n\t\t\t\t</ng-container>\r\n\t\t\t\t<ng-template #sortLink>\r\n\t\t\t\t\t<a class=\"bui-data-table__sort-link\"\r\n\t\t\t\t\t   (click)=\"sortBy(col.key)\">\r\n\t\t\t\t\t<span class=\"bui-data-table__sort-icon\"\r\n\t\t\t\t\t      [class.bui-data-table__sort-icon--asc]=\"_sortKey === col.key && _sortDir === 'asc'\"\r\n\t\t\t\t\t      [class.bui-data-table__sort-icon--desc]=\"_sortKey === col.key && _sortDir === 'desc'\"></span>\r\n\t\t\t\t\t\t{{ col.title }} </a>\r\n\t\t\t\t</ng-template>\r\n\t\t\t</th>\r\n\t\t</tr>\r\n\t\t<tr *ngIf=\"!_originalItems || loading\">\r\n\t\t\t<th class=\"bui-data-table__loader\"\r\n\t\t\t    [attr.colspan]=\"cols.length\">\r\n\t\t\t\t<div class=\"bui-data-table__loader-background\"></div>\r\n\t\t\t\t<div class=\"bui-data-table__loader-indeterminate\">\r\n\t\t\t\t\t<div class=\"bui-data-table__loader-indeterminate--long\"></div>\r\n\t\t\t\t\t<div class=\"bui-data-table__loader-indeterminate--short\"></div>\r\n\t\t\t\t</div>\r\n\t\t\t</th>\r\n\t\t</tr>\r\n\t</thead>\r\n\t<tbody>\r\n\t\t<tr *ngIf=\"_originalItems && _originalItems.length === 0\">\r\n\t\t\t<td class=\"bui-data-table__cell bui-data-table__cell--no-data\"\r\n\t\t\t    [attr.colspan]=\"cols.length\">\r\n\t\t\t\t<span>{{ 'bui.data-table.noData' | msgKey | async }}</span>\r\n\t\t\t</td>\r\n\t\t</tr>\r\n\t\t<tr *ngFor=\"let item of _currentItems\"\r\n\t\t    class=\"bui-data-table__row\">\r\n\t\t\t<td *ngFor=\"let col of cols\"\r\n\t\t\t    class=\"bui-data-table__cell\"\r\n\t\t\t    [class.bui-data-table__cell--shrink]=\"col.shrink\"\r\n\t\t\t    [style.text-align]=\"col.align ?? 'start'\">\r\n\t\t\t\t<ng-container *ngIf=\"templates[col.key]; else defaultColTemplate\">\r\n\t\t\t\t\t<ng-container [ngTemplateOutlet]=\"templates[col.key]\"\r\n\t\t\t\t\t              [ngTemplateOutletContext]=\"{ $implicit: item }\"></ng-container>\r\n\t\t\t\t</ng-container>\r\n\t\t\t\t<ng-template #defaultColTemplate>\r\n\t\t\t\t\t{{ item[col.key] }}\r\n\t\t\t\t</ng-template>\r\n\t\t\t</td>\r\n\t\t</tr>\r\n\t</tbody>\r\n</table>\r\n<div *ngIf=\"_footerTemplate\"\r\n     class=\"bui-data-table__footer\">\r\n\t<ng-container [ngTemplateOutlet]=\"_footerTemplate\"></ng-container>\r\n</div>\r\n<div *ngIf=\"!_disablePagination\"\r\n     class=\"bui-data-table__footer bui-data-table__footer--pagination-wrapper\">\r\n\t<div class=\"bui-data-table__pagination\">\r\n\t\t<ng-container *ngIf=\"_pageCount > 1\">\r\n\t\t\t<a class=\"bui-data-table__prev-page\"\r\n\t\t\t   [attr.disabled]=\"_page === 1 ? '' : null\"\r\n\t\t\t   (click)=\"prev()\">\r\n\t\t\t\t<mat-icon>chevron_left</mat-icon>\r\n\t\t\t</a>\r\n\t\t\t<ol class=\"bui-data-table__pages\">\r\n\t\t\t\t<li *ngFor=\"let i of _pages\"\r\n\t\t\t\t    class=\"bui-data-table__page\"\r\n\t\t\t\t    [class.bui-data-table__page--current]=\"i === _page\">\r\n\t\t\t\t\t<ng-container *ngIf=\"i === _page; else pageLink\">\r\n\t\t\t\t\t\t<span>{{ i }}</span>\r\n\t\t\t\t\t</ng-container>\r\n\t\t\t\t\t<ng-template #pageLink>\r\n\t\t\t\t\t\t<a (click)=\"page = i\">{{ i }}</a>\r\n\t\t\t\t\t</ng-template>\r\n\t\t\t\t</li>\r\n\t\t\t</ol>\r\n\t\t\t<a class=\"bui-data-table__next-page\"\r\n\t\t\t   [attr.disabled]=\"_page === _pageCount ? '' : null\"\r\n\t\t\t   (click)=\"next()\">\r\n\t\t\t\t<mat-icon>chevron_right</mat-icon>\r\n\t\t\t</a>\r\n\t\t</ng-container>\r\n\t</div>\r\n\t<div class=\"bui-data-table__items-per-page-wrapper\"\r\n\t     *ngIf=\"itemsPerPageOptions\">\r\n\t\t<span>{{ 'bui.data-table.itemsPerPage' | msgKey | async }}</span>\r\n\t\t<bui-select [items]=\"itemsPerPageOptions\"\r\n\t\t            [(ngModel)]=\"itemsPerPage\"\r\n\t\t            [searchable]=\"false\"\r\n\t\t            [clearable]=\"false\"></bui-select>\r\n\t</div>\r\n</div>", styles: [""], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SelectComponent, selector: "bui-select", inputs: ["items", "valueKey", "labelKey", "placeholder", "clearable", "searchable", "multiple", "disabled", "groupBy"] }, { kind: "ngmodule", type: MatIconModule }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-data-table', encapsulation: ViewEncapsulation.None, imports: [
                        CommonModule,
                        FormsModule,
                        SelectComponent,
                        MatIconModule,
                        MsgKeyPipe,
                    ], template: "<table class=\"bui-data-table__table\">\r\n\t<thead>\r\n\t\t<tr class=\"bui-data-table__header-row\">\r\n\t\t\t<th *ngFor=\"let col of cols\"\r\n\t\t\t    class=\"bui-data-table__header-cell\"\r\n\t\t\t    [class]=\"col.align ? 'bui-data-table__header-cell--align-' + col.align : ''\"\r\n\t\t\t    [class.bui-data-table__header-cell--shrink]=\"col.shrink\"\r\n\t\t\t    [style.width]=\"col.width\">\r\n\t\t\t\t<ng-container *ngIf=\"!col.sortable; else sortLink\">\r\n\t\t\t\t\t{{ col.title }}\r\n\t\t\t\t</ng-container>\r\n\t\t\t\t<ng-template #sortLink>\r\n\t\t\t\t\t<a class=\"bui-data-table__sort-link\"\r\n\t\t\t\t\t   (click)=\"sortBy(col.key)\">\r\n\t\t\t\t\t<span class=\"bui-data-table__sort-icon\"\r\n\t\t\t\t\t      [class.bui-data-table__sort-icon--asc]=\"_sortKey === col.key && _sortDir === 'asc'\"\r\n\t\t\t\t\t      [class.bui-data-table__sort-icon--desc]=\"_sortKey === col.key && _sortDir === 'desc'\"></span>\r\n\t\t\t\t\t\t{{ col.title }} </a>\r\n\t\t\t\t</ng-template>\r\n\t\t\t</th>\r\n\t\t</tr>\r\n\t\t<tr *ngIf=\"!_originalItems || loading\">\r\n\t\t\t<th class=\"bui-data-table__loader\"\r\n\t\t\t    [attr.colspan]=\"cols.length\">\r\n\t\t\t\t<div class=\"bui-data-table__loader-background\"></div>\r\n\t\t\t\t<div class=\"bui-data-table__loader-indeterminate\">\r\n\t\t\t\t\t<div class=\"bui-data-table__loader-indeterminate--long\"></div>\r\n\t\t\t\t\t<div class=\"bui-data-table__loader-indeterminate--short\"></div>\r\n\t\t\t\t</div>\r\n\t\t\t</th>\r\n\t\t</tr>\r\n\t</thead>\r\n\t<tbody>\r\n\t\t<tr *ngIf=\"_originalItems && _originalItems.length === 0\">\r\n\t\t\t<td class=\"bui-data-table__cell bui-data-table__cell--no-data\"\r\n\t\t\t    [attr.colspan]=\"cols.length\">\r\n\t\t\t\t<span>{{ 'bui.data-table.noData' | msgKey | async }}</span>\r\n\t\t\t</td>\r\n\t\t</tr>\r\n\t\t<tr *ngFor=\"let item of _currentItems\"\r\n\t\t    class=\"bui-data-table__row\">\r\n\t\t\t<td *ngFor=\"let col of cols\"\r\n\t\t\t    class=\"bui-data-table__cell\"\r\n\t\t\t    [class.bui-data-table__cell--shrink]=\"col.shrink\"\r\n\t\t\t    [style.text-align]=\"col.align ?? 'start'\">\r\n\t\t\t\t<ng-container *ngIf=\"templates[col.key]; else defaultColTemplate\">\r\n\t\t\t\t\t<ng-container [ngTemplateOutlet]=\"templates[col.key]\"\r\n\t\t\t\t\t              [ngTemplateOutletContext]=\"{ $implicit: item }\"></ng-container>\r\n\t\t\t\t</ng-container>\r\n\t\t\t\t<ng-template #defaultColTemplate>\r\n\t\t\t\t\t{{ item[col.key] }}\r\n\t\t\t\t</ng-template>\r\n\t\t\t</td>\r\n\t\t</tr>\r\n\t</tbody>\r\n</table>\r\n<div *ngIf=\"_footerTemplate\"\r\n     class=\"bui-data-table__footer\">\r\n\t<ng-container [ngTemplateOutlet]=\"_footerTemplate\"></ng-container>\r\n</div>\r\n<div *ngIf=\"!_disablePagination\"\r\n     class=\"bui-data-table__footer bui-data-table__footer--pagination-wrapper\">\r\n\t<div class=\"bui-data-table__pagination\">\r\n\t\t<ng-container *ngIf=\"_pageCount > 1\">\r\n\t\t\t<a class=\"bui-data-table__prev-page\"\r\n\t\t\t   [attr.disabled]=\"_page === 1 ? '' : null\"\r\n\t\t\t   (click)=\"prev()\">\r\n\t\t\t\t<mat-icon>chevron_left</mat-icon>\r\n\t\t\t</a>\r\n\t\t\t<ol class=\"bui-data-table__pages\">\r\n\t\t\t\t<li *ngFor=\"let i of _pages\"\r\n\t\t\t\t    class=\"bui-data-table__page\"\r\n\t\t\t\t    [class.bui-data-table__page--current]=\"i === _page\">\r\n\t\t\t\t\t<ng-container *ngIf=\"i === _page; else pageLink\">\r\n\t\t\t\t\t\t<span>{{ i }}</span>\r\n\t\t\t\t\t</ng-container>\r\n\t\t\t\t\t<ng-template #pageLink>\r\n\t\t\t\t\t\t<a (click)=\"page = i\">{{ i }}</a>\r\n\t\t\t\t\t</ng-template>\r\n\t\t\t\t</li>\r\n\t\t\t</ol>\r\n\t\t\t<a class=\"bui-data-table__next-page\"\r\n\t\t\t   [attr.disabled]=\"_page === _pageCount ? '' : null\"\r\n\t\t\t   (click)=\"next()\">\r\n\t\t\t\t<mat-icon>chevron_right</mat-icon>\r\n\t\t\t</a>\r\n\t\t</ng-container>\r\n\t</div>\r\n\t<div class=\"bui-data-table__items-per-page-wrapper\"\r\n\t     *ngIf=\"itemsPerPageOptions\">\r\n\t\t<span>{{ 'bui.data-table.itemsPerPage' | msgKey | async }}</span>\r\n\t\t<bui-select [items]=\"itemsPerPageOptions\"\r\n\t\t            [(ngModel)]=\"itemsPerPage\"\r\n\t\t            [searchable]=\"false\"\r\n\t\t            [clearable]=\"false\"></bui-select>\r\n\t</div>\r\n</div>" }]
        }], propDecorators: { _componentClass: [{
                type: HostBinding,
                args: ['class.bui-data-table']
            }], cols: [{
                type: Input
            }], items: [{
                type: Input
            }], sortKey: [{
                type: Input
            }], sortDir: [{
                type: Input
            }], disablePagination: [{
                type: Input
            }], itemsPerPage: [{
                type: Input
            }], itemsPerPageOptions: [{
                type: Input
            }], loading: [{
                type: Input
            }], templates: [{
                type: Input
            }], _footerTemplate: [{
                type: ContentChild,
                args: ['footer']
            }] } });

class DialogComponent {
    constructor() {
        this.options = inject(MAT_DIALOG_DATA);
        this.messageService = inject(MessageService);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: DialogComponent, isStandalone: true, selector: "ng-component", host: { properties: { "class.bui-dialog": "true" } }, ngImport: i0, template: "<h2\r\n\t\tbui-dialog-title\r\n\t\t*ngIf=\"options.title\"\r\n>{{ options.title }}</h2>\r\n<bui-dialog-content>\r\n\t<div *ngIf=\"options.htmlMessage; else messageTemplate\" [innerHTML]=\"options.htmlMessage\"></div>\r\n\t<ng-template #messageTemplate>\r\n\t\t{{ options.message }}\r\n\t</ng-template>\r\n</bui-dialog-content>\r\n<bui-dialog-actions>\r\n\t<button\r\n\t\t\t*ngIf=\"options.cancel\"\r\n\t\t\tbui-button\r\n\t\t\t[bui-dialog-action]=\"false\"\r\n\t>\r\n\t\t{{ options.cancel }}\r\n\t</button>\r\n\t<button\r\n\t\t\tbui-button\r\n\t\t\t[bui-dialog-action]=\"true\"\r\n\t\t\tcolor=\"primary\"\r\n\t>\r\n\t\t{{ options.ok }}\r\n\t</button>\r\n</bui-dialog-actions>", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: DialogActionDirective, selector: "button[bui-dialog-action]", inputs: ["ariaLabel", "type", "bui-dialog-action"] }, { kind: "component", type: DialogActionsComponent, selector: "bui-dialog-actions", inputs: ["align"] }, { kind: "component", type: DialogContentComponent, selector: "bui-dialog-content" }, { kind: "directive", type: DialogTitleDirective, selector: "[bui-dialog-title]" }, { kind: "component", type: ButtonComponent, selector: "button[bui-button]", inputs: ["type", "disabled", "tabindex", "variant", "color", "loading"], outputs: ["throttledClick"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        DialogActionDirective,
                        DialogActionsComponent,
                        DialogContentComponent,
                        DialogTitleDirective,
                        ButtonComponent,
                    ], host: {
                        '[class.bui-dialog]': 'true',
                    }, template: "<h2\r\n\t\tbui-dialog-title\r\n\t\t*ngIf=\"options.title\"\r\n>{{ options.title }}</h2>\r\n<bui-dialog-content>\r\n\t<div *ngIf=\"options.htmlMessage; else messageTemplate\" [innerHTML]=\"options.htmlMessage\"></div>\r\n\t<ng-template #messageTemplate>\r\n\t\t{{ options.message }}\r\n\t</ng-template>\r\n</bui-dialog-content>\r\n<bui-dialog-actions>\r\n\t<button\r\n\t\t\t*ngIf=\"options.cancel\"\r\n\t\t\tbui-button\r\n\t\t\t[bui-dialog-action]=\"false\"\r\n\t>\r\n\t\t{{ options.cancel }}\r\n\t</button>\r\n\t<button\r\n\t\t\tbui-button\r\n\t\t\t[bui-dialog-action]=\"true\"\r\n\t\t\tcolor=\"primary\"\r\n\t>\r\n\t\t{{ options.ok }}\r\n\t</button>\r\n</bui-dialog-actions>" }]
        }], ctorParameters: () => [] });

const DialogComponents = [
    DialogComponent,
    DialogTitleDirective,
    DialogContentComponent,
    DialogActionsComponent,
    DialogActionDirective,
];
class DialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.1.1", ngImport: i0, type: DialogModule, imports: [DialogComponent,
            DialogTitleDirective,
            DialogContentComponent,
            DialogActionsComponent,
            DialogActionDirective], exports: [DialogComponent,
            DialogTitleDirective,
            DialogContentComponent,
            DialogActionsComponent,
            DialogActionDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogModule, imports: [DialogComponent,
            DialogContentComponent,
            DialogActionsComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: DialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        ...DialogComponents,
                    ],
                    exports: [
                        ...DialogComponents,
                    ],
                }]
        }] });

const assetPath = '';
const SvgIcons = [
    {
        name: 'baseline-open_in_new',
        path: 'default/img/icon/baseline-open_in_new.svg'
    },
    {
        name: 'settings',
        path: 'customer/base/default/img/icon/settings.svg'
    },
    {
        name: 'shopping_cart',
        path: 'customer/base/default/img/icon/shopping_cart.svg'
    },
    {
        name: 'phone',
        path: 'customer/base/default/img/icon/phone.svg'
    },
    {
        name: 'inprogress',
        path: 'default/img/icon/progress.svg'
    },
    {
        name: 'logout',
        path: 'default/img/icon/logout.svg'
    },
    {
        name: 'back',
        path: 'default/img/icon/back.svg'
    },
    {
        name: 'star',
        path: 'default/img/icon/star.svg'
    },
    {
        name: 'star_border',
        path: 'default/img/icon/star_border.svg'
    },
    {
        name: 'screen-rotation',
        path: 'default/img/icon/screen-rotation.svg'
    },
    {
        name: 'kpi_feedback',
        path: 'default/img/icon/feedback_kpi.svg'
    },
    {
        name: 'feedback',
        path: 'default/img/icon/feedback.svg'
    },
    {
        name: 'expand_less',
        path: 'default/img/icon/expand_less.svg'
    },
    {
        name: 'expand_more',
        path: 'default/img/icon/expand_more.svg'
    },
    {
        name: 'pageview',
        path: 'default/img/icon/pageview.svg'
    },
    {
        name: 'edit',
        path: 'default/img/icon/edit.svg'
    },
    {
        name: 'kpi_link1',
        path: 'default/img/icon/backlog.svg'
    },
    {
        name: 'kpi_link2',
        path: 'default/img/icon/pick_one.svg'
    },
    {
        name: 'umfrage',
        path: 'default/img/icon/umfrage.svg'
    },
    {
        name: 'dots',
        path: 'customer/base/default/img/icon/dots.svg'
    },
    {
        name: 'error',
        path: 'default/img/icon/error.svg'
    },
    {
        name: 'warning',
        path: 'default/img/icon/warning.svg'
    },
    {
        name: 'warning-triangle',
        path: 'default/img/icon/warning-triangular.svg'
    },
    {
        name: 'success',
        path: 'default/img/icon/success.svg'
    },
    {
        name: 'rotate_crop',
        path: 'default/img/icon/rotate-crop.svg'
    },
    {
        name: 'lock',
        path: 'default/img/icon/lock.svg',
    },
    {
        name: 'neue_adressen',
        path: 'default/img/icon/neue_adressen.svg',
    },
    {
        name: 'warten_auf_adressen',
        path: 'default/img/icon/warten_auf_adressen.svg',
    },
    {
        name: 'storno',
        path: 'default/img/icon/icon_storno.svg',
    },
    {
        name: 'download',
        path: 'default/img/icon/download.svg',
    },
    {
        name: 'allianz_logout',
        path: 'customer/allianz/img/icon/logout-icon-neu.svg',
    },
    {
        name: 'allianz_logout_hover',
        path: 'customer/allianz/img/icon/logout-icon-hover-neu.svg',
    },
    {
        name: 'allianz_helpicon',
        path: 'customer/allianz/img/icon/hilfe-icon.svg',
    },
    {
        name: 'allianz_helpicon_hover',
        path: 'customer/allianz/img/icon/hilfe-icon-hover.svg',
    },
    {
        name: 'allianz_archiveicon',
        path: 'customer/allianz/img/icon/documents-icon.svg',
    },
    {
        name: 'allianz_archiveicon_hover',
        path: 'customer/allianz/img/icon/documents-icon-hover.svg',
    },
    {
        name: 'allianz_preferencesicon',
        path: 'customer/allianz/img/icon/profil-icon.svg',
    },
    {
        name: 'allianz_preferencesicon_hover',
        path: 'customer/allianz/img/icon/profil-icon-hover.svg',
    },
    {
        name: 'allianz_shoppingcart',
        path: 'customer/allianz/img/icon/warenkorb-icon.svg',
    },
    {
        name: 'allianz_shoppingcart_hover',
        path: 'customer/allianz/img/icon/warenkorb-icon-hover.svg',
    },
    {
        name: 'allianz_suche',
        path: 'customer/allianz/img/icon/search-icon.svg',
    },
    {
        name: 'allianz_suche_hover',
        path: 'customer/allianz/img/icon/search-icon-hover.svg',
    },
    {
        name: 'allianz_favoriten',
        path: 'customer/allianz/img/icon/favoriten-icon.svg',
    },
    {
        name: 'allianz_favoriten_hover',
        path: 'customer/allianz/img/icon/favoriten-icon-hover.svg',
    }
].map(icon => ({ ...icon, path: assetPath + icon.path }));

function addIconsToRegistry(matIconRegistry, sanitizer) {
    for (let i = 0; i < SvgIcons.length; ++i) {
        const icon = SvgIcons[i];
        matIconRegistry.addSvgIcon(icon.name, sanitizer.bypassSecurityTrustResourceUrl(icon.path));
    }
}

class MaterialModule {
    constructor(matIconRegistry, sanitizer) {
        addIconsToRegistry(matIconRegistry, sanitizer);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MaterialModule, deps: [{ token: i2$1.MatIconRegistry }, { token: i2$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.1.1", ngImport: i0, type: MaterialModule, imports: [MatIconModule,
            CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MaterialModule, imports: [MatIconModule,
            CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: MaterialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        MatIconModule,
                        CommonModule
                    ]
                }]
        }], ctorParameters: () => [{ type: i2$1.MatIconRegistry }, { type: i2$2.DomSanitizer }] });

var KachelStatusEnum;
(function (KachelStatusEnum) {
    KachelStatusEnum["Selected"] = "selected";
    KachelStatusEnum["Pending"] = "pending";
    KachelStatusEnum["Default"] = "default";
})(KachelStatusEnum || (KachelStatusEnum = {}));
class KachelComponent {
    constructor() {
        this.id = input('');
        this.headline = input();
        this.text = input();
        this.icon = input();
        this.hideBorder = input(false, { transform: coerceBooleanProperty });
        this.info = input();
        this.status = input();
        this.select = output();
        this.KachelStatusEnum = KachelStatusEnum;
    }
    toggleSelection() {
        this.select.emit(this.id());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: KachelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: KachelComponent, isStandalone: true, selector: "bui-kachel", inputs: { id: { classPropertyName: "id", publicName: "id", isSignal: true, isRequired: false, transformFunction: null }, headline: { classPropertyName: "headline", publicName: "headline", isSignal: true, isRequired: false, transformFunction: null }, text: { classPropertyName: "text", publicName: "text", isSignal: true, isRequired: false, transformFunction: null }, icon: { classPropertyName: "icon", publicName: "icon", isSignal: true, isRequired: false, transformFunction: null }, hideBorder: { classPropertyName: "hideBorder", publicName: "hideBorder", isSignal: true, isRequired: false, transformFunction: null }, info: { classPropertyName: "info", publicName: "info", isSignal: true, isRequired: false, transformFunction: null }, status: { classPropertyName: "status", publicName: "status", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { select: "select" }, host: { listeners: { "click": "toggleSelection()" }, properties: { "class.bui-kachel": "true", "class.customIcon": "icon()", "class.hideBorder": "hideBorder()", "attr.status": "status()" } }, ngImport: i0, template: "@if (icon()) {\r\n\t<mat-icon [svgIcon]=\"icon()!\"\r\n\t          class=\"icon\"></mat-icon>\r\n\t<mat-spinner *ngIf=\"status() === KachelStatusEnum.Pending\"\r\n\t             diameter=\"27\"></mat-spinner>\r\n} @else {\r\n\t<span class=\"kachelHeadline\">{{ headline() }}</span><span class=\"kachelText\">{{ text() }}</span>\r\n}", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: MatIconModule }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "ngmodule", type: MatProgressSpinnerModule }, { kind: "component", type: i1.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "ngmodule", type: MaterialModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: KachelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-kachel', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        MatIconModule,
                        MatProgressSpinnerModule,
                        MaterialModule,
                    ], host: {
                        '[class.bui-kachel]': 'true',
                        '[class.customIcon]': 'icon()',
                        '[class.hideBorder]': 'hideBorder()',
                        '[attr.status]': 'status()',
                        '(click)': 'toggleSelection()',
                    }, template: "@if (icon()) {\r\n\t<mat-icon [svgIcon]=\"icon()!\"\r\n\t          class=\"icon\"></mat-icon>\r\n\t<mat-spinner *ngIf=\"status() === KachelStatusEnum.Pending\"\r\n\t             diameter=\"27\"></mat-spinner>\r\n} @else {\r\n\t<span class=\"kachelHeadline\">{{ headline() }}</span><span class=\"kachelText\">{{ text() }}</span>\r\n}" }]
        }], ctorParameters: () => [] });

class KachelChoiceComponent {
    constructor() {
        this.options = input([]);
        this.required = input(false, { transform: coerceBooleanProperty });
        this.multiple = input(false, { transform: coerceBooleanProperty });
        this.kachelwidth = input('');
        this.selectedIds = signal({});
        this.onChange = () => {
        };
        this.onTouched = () => {
        };
    }
    writeValue(obj) {
        const selectedIds = {};
        if (obj !== undefined && obj !== null) {
            if (obj instanceof Array) {
                obj.forEach(id => selectedIds[id] = true);
            }
            else {
                selectedIds[obj] = true;
            }
        }
        this.selectedIds.set(selectedIds);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    select(kachelId) {
        if (this.multiple()) {
            const selectedIds = { ...this.selectedIds() };
            if (selectedIds[kachelId]) {
                delete selectedIds[kachelId];
            }
            else {
                selectedIds[kachelId] = true;
            }
            this.selectedIds.set(selectedIds);
            this.onChange(Object.keys(this.selectedIds));
        }
        else {
            this.selectedIds.set({ ['' + kachelId]: true });
            this.onChange(kachelId);
        }
        this.onTouched();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: KachelChoiceComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: KachelChoiceComponent, isStandalone: true, selector: "bui-kachel-choice", inputs: { options: { classPropertyName: "options", publicName: "options", isSignal: true, isRequired: false, transformFunction: null }, required: { classPropertyName: "required", publicName: "required", isSignal: true, isRequired: false, transformFunction: null }, multiple: { classPropertyName: "multiple", publicName: "multiple", isSignal: true, isRequired: false, transformFunction: null }, kachelwidth: { classPropertyName: "kachelwidth", publicName: "kachelwidth", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-kachel-choice": "true", "attr.buiValidationControl": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => KachelChoiceComponent),
                multi: true,
            },
        ], hostDirectives: [{ directive: ValidationControlDirective }], ngImport: i0, template: "@for (option of options(); track option.id) {\r\n\t<div class=\"bui-kachel-choice__option\"\r\n\t     [ngClass]=\"kachelwidth()\">\r\n\t\t<bui-kachel [id]=\"option.id\"\r\n\t\t            [headline]=\"option.headline\"\r\n\t\t            [icon]=\"option.icon\"\r\n\t\t            [text]=\"option.text\"\r\n\t\t            [title]=\"option.title || ''\"\r\n\t\t            [status]=\"selectedIds()[option.id] ? 'selected' : 'default'\"\r\n\t\t            (select)=\"select(option.id)\"></bui-kachel>\r\n\t</div>\r\n}", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: KachelComponent, selector: "bui-kachel", inputs: ["id", "headline", "text", "icon", "hideBorder", "info", "status"], outputs: ["select"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: KachelChoiceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-kachel-choice', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        KachelComponent,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => KachelChoiceComponent),
                            multi: true,
                        },
                    ], hostDirectives: [
                        ValidationControlDirective,
                    ], host: {
                        '[class.bui-kachel-choice]': 'true',
                        '[attr.buiValidationControl]': 'true',
                    }, template: "@for (option of options(); track option.id) {\r\n\t<div class=\"bui-kachel-choice__option\"\r\n\t     [ngClass]=\"kachelwidth()\">\r\n\t\t<bui-kachel [id]=\"option.id\"\r\n\t\t            [headline]=\"option.headline\"\r\n\t\t            [icon]=\"option.icon\"\r\n\t\t            [text]=\"option.text\"\r\n\t\t            [title]=\"option.title || ''\"\r\n\t\t            [status]=\"selectedIds()[option.id] ? 'selected' : 'default'\"\r\n\t\t            (select)=\"select(option.id)\"></bui-kachel>\r\n\t</div>\r\n}" }]
        }], ctorParameters: () => [] });

class RadioComponent extends InputOption {
    constructor() {
        super(...arguments);
        this.group = inject(BUI_RADIO_GROUP);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: RadioComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: RadioComponent, isStandalone: true, selector: "bui-radio", host: { properties: { "class.bui-radio": "true" } }, usesInheritance: true, ngImport: i0, template: "<label [class.disabled]=\"disabled()\">\r\n\t<input type=\"radio\"\r\n\t       [value]=\"value()\"\r\n\t       [disabled]=\"disabled()\"\r\n\t       [checked]=\"selected()\"\r\n\t       (change)=\"_onChange()\">\r\n\t<span class=\"bui-radio__label\"><ng-content></ng-content></span>\r\n</label>\r\n", dependencies: [{ kind: "ngmodule", type: FormsModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: RadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-radio', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        FormsModule,
                    ], host: {
                        '[class.bui-radio]': 'true',
                    }, template: "<label [class.disabled]=\"disabled()\">\r\n\t<input type=\"radio\"\r\n\t       [value]=\"value()\"\r\n\t       [disabled]=\"disabled()\"\r\n\t       [checked]=\"selected()\"\r\n\t       (change)=\"_onChange()\">\r\n\t<span class=\"bui-radio__label\"><ng-content></ng-content></span>\r\n</label>\r\n" }]
        }] });

const BUI_RADIO_GROUP = new InjectionToken('BuiRadioGroupComponent');
class RadioGroupComponent extends InputOptionGroup {
    constructor() {
        super(...arguments);
        // Radio-Gruppen machen nur mit Einfachauswahl Sinn → multiple ignorieren (immer false)
        this.multiple = input(false, { transform: (value) => false });
        this.inline = input(false, { transform: coerceBooleanProperty });
        this.optionComponents = contentChildren(forwardRef(() => RadioComponent));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: RadioGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.2.0", version: "19.1.1", type: RadioGroupComponent, isStandalone: true, selector: "bui-radio-group", inputs: { multiple: { classPropertyName: "multiple", publicName: "multiple", isSignal: true, isRequired: false, transformFunction: null }, inline: { classPropertyName: "inline", publicName: "inline", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-radio-group": "true", "class.bui-radio-group--inline": "inline()", "attr.buiValidationControl": "true" } }, providers: [
            { provide: BUI_RADIO_GROUP, useExisting: RadioGroupComponent },
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RadioGroupComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "optionComponents", predicate: i0.forwardRef(() => RadioComponent), isSignal: true }], usesInheritance: true, hostDirectives: [{ directive: ValidationControlDirective }], ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: RadioGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bui-radio-group',
                    template: '<ng-content></ng-content>',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        { provide: BUI_RADIO_GROUP, useExisting: RadioGroupComponent },
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => RadioGroupComponent),
                            multi: true,
                        },
                    ],
                    hostDirectives: [
                        ValidationControlDirective,
                    ],
                    host: {
                        '[class.bui-radio-group]': 'true',
                        '[class.bui-radio-group--inline]': 'inline()',
                        '[attr.buiValidationControl]': 'true',
                    },
                }]
        }] });

class ValidationUtils {
    static addValidatorMetadata(validator, metadata) {
        return (control) => {
            const errors = validator(control);
            if (!errors) {
                return null;
            }
            Object.entries(errors)
                .forEach(([errorKey, error]) => {
                switch (typeof error) {
                    case 'object':
                        errors[errorKey] = {
                            ...errors,
                            ...metadata
                        };
                        break;
                    case 'boolean':
                        errors[errorKey] = { ...metadata };
                        break;
                    default:
                        break;
                }
            });
            return errors;
        };
    }
    static removeErrors(control, keys) {
        if (!control || !keys || keys.length === 0) {
            return;
        }
        const remainingErrors = control.errors ?? {};
        keys.forEach((key) => {
            delete remainingErrors[key];
        });
        if (Object.keys(remainingErrors).length) {
            control.setErrors(remainingErrors);
        }
        else {
            control.setErrors(null);
        }
    }
    ;
    static addErrors(control, errors) {
        if (!control || !errors || !Object.keys(errors).length) {
            return;
        }
        control.setErrors({ ...errors, ...control.errors });
    }
}

function BetweenValidator(min, max, strict = false) {
    return (control) => {
        const actual = control.value;
        if ((actual > min || (!strict && actual === min)) && (actual < max || (!strict && actual === max))) {
            return null;
        }
        return {
            between: {
                min: min,
                max: max,
                actual
            }
        };
    };
}

class RangeSliderComponent {
    constructor() {
        this.value = model(null);
        this.formControlName = input('range');
        this.min = input.required();
        this.max = input.required();
        this.unit = input();
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.disabled = linkedSignal(() => this.disabledInput());
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
        this._onValidatorChangeFn = () => {
        };
        this.destroyRef = inject(DestroyRef);
        this.fb = inject(FormBuilder);
        explicitEffect([this.min, this.max], () => this.setInternalValidators());
        explicitEffect([this.disabled], ([disabled]) => {
            if (disabled) {
                this.form?.disable();
            }
            else {
                this.form?.enable();
            }
        });
    }
    ngOnInit() {
        this.form = this.fb.group({
            slider: this.fb.control(this.value()),
            [this.formControlName()]: this.fb.control(this.value(), {
                validators: this.createInternalValidators(),
            }),
        });
        if (this.disabled()) {
            this.form.disable();
        }
        this.form.controls['slider'].valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged())
            .subscribe((value) => {
            this.form.controls[this.formControlName()].setValue(value);
            this.form.controls[this.formControlName()].markAsDirty();
            this.updateValue(value);
        });
        this.form.controls[this.formControlName()].valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged())
            .subscribe((value) => {
            this.form.controls['slider'].setValue(value);
            this.form.controls['slider'].markAsDirty();
            this.updateValue(value);
        });
    }
    setInternalValidators() {
        this.form?.controls[this.formControlName()].setValidators(this.createInternalValidators());
        this.form?.controls[this.formControlName()].updateValueAndValidity();
        this._onValidatorChangeFn();
    }
    createInternalValidators() {
        return [
            ValidationUtils.addValidatorMetadata(Validators.required, { min: this.min(), max: this.max() }),
            BetweenValidator(this.min(), this.max()),
        ];
    }
    updateValue(value) {
        this.value.set(value);
        this._onTouchedFn();
        this._onChangeFn(value);
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    registerOnValidatorChange(fn) {
        this._onValidatorChangeFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    writeValue(obj) {
        this.form?.patchValue({
            slider: obj,
            [this.formControlName()]: obj,
        });
    }
    validate(control) {
        return this.form.controls[this.formControlName()].errors;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: RangeSliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: RangeSliderComponent, isStandalone: true, selector: "bui-range-slider", inputs: { value: { classPropertyName: "value", publicName: "value", isSignal: true, isRequired: false, transformFunction: null }, formControlName: { classPropertyName: "formControlName", publicName: "formControlName", isSignal: true, isRequired: false, transformFunction: null }, min: { classPropertyName: "min", publicName: "min", isSignal: true, isRequired: true, transformFunction: null }, max: { classPropertyName: "max", publicName: "max", isSignal: true, isRequired: true, transformFunction: null }, unit: { classPropertyName: "unit", publicName: "unit", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { value: "valueChange" }, host: { properties: { "class.bui-range-slider": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: RangeSliderComponent,
                multi: true,
            }, {
                provide: NG_VALIDATORS,
                useExisting: RangeSliderComponent,
                multi: true,
            },
        ], ngImport: i0, template: "<ng-container *ngIf=\"form\"\r\n              [formGroup]=\"form\">\r\n\t<span class=\"bui-range-slider__min\">{{ min() }}</span>\r\n\t<input formControlName=\"slider\"\r\n\t       class=\"bui-range-slider__slider\"\r\n\t       type=\"range\"\r\n\t       [min]=\"min()\"\r\n\t       [max]=\"max()\">\r\n\t<span class=\"bui-range-slider__max\">{{ max() }}</span>\r\n\t<input buiValidationControl\r\n\t       [formControlName]=\"formControlName()\"\r\n\t       class=\"bui-range-slider__input col-fill\"\r\n\t       type=\"number\"\r\n\t       [min]=\"min()\"\r\n\t       [max]=\"max()\"/>\r\n\t<span *ngIf=\"unit()\"\r\n\t      class=\"bui-range-slider__unit\">{{ unit() }}</span>\r\n</ng-container>\r\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i1$2.RangeValueAccessor, selector: "input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { kind: "directive", type: i1$2.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: RangeSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-range-slider', changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        ValidationControlDirective,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: RangeSliderComponent,
                            multi: true,
                        }, {
                            provide: NG_VALIDATORS,
                            useExisting: RangeSliderComponent,
                            multi: true,
                        },
                    ], host: {
                        '[class.bui-range-slider]': 'true',
                    }, template: "<ng-container *ngIf=\"form\"\r\n              [formGroup]=\"form\">\r\n\t<span class=\"bui-range-slider__min\">{{ min() }}</span>\r\n\t<input formControlName=\"slider\"\r\n\t       class=\"bui-range-slider__slider\"\r\n\t       type=\"range\"\r\n\t       [min]=\"min()\"\r\n\t       [max]=\"max()\">\r\n\t<span class=\"bui-range-slider__max\">{{ max() }}</span>\r\n\t<input buiValidationControl\r\n\t       [formControlName]=\"formControlName()\"\r\n\t       class=\"bui-range-slider__input col-fill\"\r\n\t       type=\"number\"\r\n\t       [min]=\"min()\"\r\n\t       [max]=\"max()\"/>\r\n\t<span *ngIf=\"unit()\"\r\n\t      class=\"bui-range-slider__unit\">{{ unit() }}</span>\r\n</ng-container>\r\n" }]
        }], ctorParameters: () => [] });

class SlideToggleComponent {
    constructor() {
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.value = signal(false);
        this.disabled = linkedSignal(() => this.disabledInput());
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
    }
    onChange(value) {
        this.value.set(value);
        this._onChangeFn(value);
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    writeValue(obj) {
        this.value.set(!!obj);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SlideToggleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: SlideToggleComponent, isStandalone: true, selector: "bui-slide-toggle", inputs: { disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-slide-toggle": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SlideToggleComponent),
                multi: true,
            },
        ], ngImport: i0, template: "<mat-slide-toggle [ngModel]=\"value()\"\r\n                  (ngModelChange)=\"onChange($event)\"\r\n                  [disabled]=\"disabled()\">\r\n\t<ng-content></ng-content>\r\n</mat-slide-toggle>", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: MatSlideToggleModule }, { kind: "component", type: i2$3.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["name", "id", "labelPosition", "aria-label", "aria-labelledby", "aria-describedby", "required", "color", "disabled", "disableRipple", "tabIndex", "checked", "hideIcon", "disabledInteractive"], outputs: ["change", "toggleChange"], exportAs: ["matSlideToggle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: SlideToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-slide-toggle', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        FormsModule,
                        MatSlideToggleModule,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SlideToggleComponent),
                            multi: true,
                        },
                    ], host: {
                        '[class.bui-slide-toggle]': 'true',
                    }, template: "<mat-slide-toggle [ngModel]=\"value()\"\r\n                  (ngModelChange)=\"onChange($event)\"\r\n                  [disabled]=\"disabled()\">\r\n\t<ng-content></ng-content>\r\n</mat-slide-toggle>" }]
        }], ctorParameters: () => [] });

class TextareaComponent {
    constructor() {
        this.placeholder = input();
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.rows = input(5);
        this.disabled = linkedSignal(() => this.disabledInput());
        this.value = signal(null);
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    writeValue(value) {
        this.value.set(value);
    }
    updateValue(value) {
        this.writeValue(value);
        this._onChangeFn(value);
        this._onTouchedFn();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TextareaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: TextareaComponent, isStandalone: true, selector: "bui-textarea", inputs: { placeholder: { classPropertyName: "placeholder", publicName: "placeholder", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, rows: { classPropertyName: "rows", publicName: "rows", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-textarea": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: TextareaComponent,
                multi: true,
            },
        ], ngImport: i0, template: "<textarea buiValidationControl\r\n          [disabled]=\"disabled()\"\r\n          [placeholder]=\"placeholder() ?? ''\"\r\n          [ngModel]=\"value()\"\r\n          (ngModelChange)=\"updateValue($event)\"\r\n          [rows]=\"rows()\"></textarea>\r\n", dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TextareaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-textarea', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        FormsModule,
                        ValidationControlDirective,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: TextareaComponent,
                            multi: true,
                        },
                    ], host: {
                        '[class.bui-textarea]': 'true',
                    }, template: "<textarea buiValidationControl\r\n          [disabled]=\"disabled()\"\r\n          [placeholder]=\"placeholder() ?? ''\"\r\n          [ngModel]=\"value()\"\r\n          (ngModelChange)=\"updateValue($event)\"\r\n          [rows]=\"rows()\"></textarea>\r\n" }]
        }], ctorParameters: () => [] });

class TimespanPickerComponent {
    set min(min) {
        this._min = min;
        this._updateMinMax();
    }
    set max(max) {
        this._max = max;
        this._updateMinMax();
    }
    set disabled(disabled) {
        this.disabled$.next(coerceBooleanProperty(disabled));
    }
    set required(required) {
        this.required$.next(coerceBooleanProperty(required));
    }
    constructor(locale, fb, injector) {
        this.locale = locale;
        this.fb = fb;
        this.injector = injector;
        this._componentClass = true;
        this.valueFrom = null;
        this.valueTo = null;
        this.disabled$ = new ReplaySubject();
        this.datepickerwidth = '';
        this.fromName = 'von';
        this.toName = 'bis';
        this.required$ = new ReplaySubject();
        this.destroyed$ = new Subject();
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
        this._onValidatorChangeFn = () => {
        };
    }
    ngOnInit() {
        if (this.formControlName) {
            this.fromName = `${this.formControlName}#${this.fromName}`;
            this.toName = `${this.formControlName}#${this.toName}`;
        }
        this.form = this.fb.group({
            [this.fromName]: this.fb.control(null, {
                updateOn: 'change',
            }),
            [this.toName]: this.fb.control(null, {
                updateOn: 'change',
            }),
        }, {
            validators: [
                (form) => {
                    const fromControl = form.controls[this.fromName];
                    const toControl = form.controls[this.toName];
                    const from = fromControl.value;
                    const to = toControl.value;
                    if (!from || !to || isNaN(from.getTime()) || isNaN(to.getTime()) || from <= to) {
                        ValidationUtils.removeErrors(fromControl, ['minAtMostMax']);
                        ValidationUtils.removeErrors(toControl, ['maxAtLeastMin']);
                        return null;
                    }
                    ValidationUtils.addErrors(fromControl, {
                        minAtMostMax: {
                            max: to,
                            actual: from,
                        },
                    });
                    ValidationUtils.addErrors(toControl, {
                        maxAtLeastMin: {
                            min: from,
                            actual: to,
                        },
                    });
                    return {
                        minAtMostMax: {
                            min: from,
                            max: to,
                        },
                    };
                },
            ],
        });
        this.required$
            .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
            .subscribe((required) => this.propagateRequiredValidator(required));
        this.disabled$
            .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
            .subscribe((disabled) => this.propagateDisabledState(disabled));
    }
    ngAfterViewInit() {
        const control = this.injector.get(NgControl, null)?.control;
        if (control) {
            const markAsDirty = control.markAsDirty;
            control.markAsDirty = () => {
                markAsDirty.apply(control, arguments);
                this.form.controls[this.fromName].markAsDirty(arguments);
                this.form.controls[this.toName].markAsDirty(arguments);
            };
        }
        this.formValueChanges = this.form.valueChanges
            .pipe(takeUntil(this.destroyed$))
            .subscribe(value => this.onChange(value[this.fromName] ?? null, value[this.toName] ?? null));
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    writeValue(timespan) {
        this.valueFrom = timespan?.from ?? null;
        this.valueTo = timespan?.to ?? null;
        this.form.setValue({
            [this.fromName]: this.valueFrom,
            [this.toName]: this.valueTo,
        });
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    registerOnValidatorChange(fn) {
        this._onValidatorChangeFn = fn;
    }
    _updateMinMax() {
        const fromMaxDate = (() => {
            if (!this.valueTo || this.form.controls[this.toName].hasError('min')) {
                return this._max;
            }
            if (!this._max) {
                return this.valueTo;
            }
            return new Date(Math.min(this.valueTo.getTime(), this._max.getTime()));
        })();
        if (fromMaxDate?.getTime() !== this._fromMaxDate?.getTime()) {
            this._fromMaxDate = fromMaxDate;
        }
        const toMinDate = (() => {
            if (!this.valueFrom || this.form.controls[this.toName].hasError('max')) {
                return this._min;
            }
            if (!this._min) {
                return this.valueFrom;
            }
            return new Date(Math.max(this.valueFrom.getTime(), this._min.getTime()));
        })();
        if (toMinDate?.getTime() !== this._toMinDate?.getTime()) {
            this._toMinDate = toMinDate;
        }
    }
    onChange(from, to) {
        from?.setHours(0, 0, 0);
        to?.setHours(23, 59, 59);
        this.valueFrom = from;
        this.valueTo = to;
        this._onTouchedFn();
        this._onChangeFn({ from, to });
        this._updateMinMax();
    }
    setDisabledState(isDisabled) {
        this.disabled$.next(isDisabled);
    }
    validate(control) {
        this.required$.next(control.hasValidator(Validators.required));
        if (this.form.valid) {
            return null;
        }
        return Object.fromEntries(Object.entries(this.form.controls)
            .filter(([key, control]) => !control.valid)
            .map(([key, control]) => [key, control.errors]));
    }
    propagateRequiredValidator(required) {
        const fromControl = this.form.controls[this.fromName];
        const toControl = this.form.controls[this.toName];
        if (required) {
            fromControl.addValidators(Validators.required);
            toControl.addValidators(Validators.required);
        }
        else {
            fromControl.removeValidators(Validators.required);
            toControl.removeValidators(Validators.required);
        }
        fromControl.updateValueAndValidity();
        toControl.updateValueAndValidity();
    }
    propagateDisabledState(disabled) {
        const fromControl = this.form.controls[this.fromName];
        const toControl = this.form.controls[this.toName];
        if (disabled) {
            fromControl.disable();
            toControl.disable();
        }
        else {
            fromControl.enable();
            toControl.enable();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TimespanPickerComponent, deps: [{ token: LOCALE_ID }, { token: i1$2.FormBuilder }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.1", type: TimespanPickerComponent, isStandalone: true, selector: "bui-timespan-picker", inputs: { min: "min", max: "max", disabled: "disabled", datepickerwidth: "datepickerwidth", formControlName: "formControlName", required: "required" }, host: { properties: { "class.bui-timespan-picker": "this._componentClass" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: TimespanPickerComponent,
                multi: true,
            }, {
                provide: NG_VALIDATORS,
                useExisting: TimespanPickerComponent,
                multi: true,
            },
        ], ngImport: i0, template: "<form [formGroup]=\"form\">\r\n\t<bui-date-picker [formControlName]=\"fromName\"\r\n\t                 [min]=\"_min\"\r\n\t                 [max]=\"_fromMaxDate\"\r\n\t                 [ngClass]=\"datepickerwidth\"></bui-date-picker>\r\n\t<span class=\"bui-timespan-picker__until\">{{ 'bui.timespan-picker.until' | msgKey | async }}</span>\r\n\t<bui-date-picker [formControlName]=\"toName\"\r\n\t                 [min]=\"_toMinDate\"\r\n\t                 [max]=\"_max\"\r\n\t                 [ngClass]=\"datepickerwidth\"></bui-date-picker>\r\n</form>\r\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "component", type: DatePickerComponent, selector: "bui-date-picker", inputs: ["value", "min", "max", "disabled", "dateDisabledFn", "customDayTemplate", "customDayDataFn", "name"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TimespanPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-timespan-picker', encapsulation: ViewEncapsulation.None, imports: [
                        CommonModule,
                        DatePickerComponent,
                        ReactiveFormsModule,
                        MsgKeyPipe,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: TimespanPickerComponent,
                            multi: true,
                        }, {
                            provide: NG_VALIDATORS,
                            useExisting: TimespanPickerComponent,
                            multi: true,
                        },
                    ], template: "<form [formGroup]=\"form\">\r\n\t<bui-date-picker [formControlName]=\"fromName\"\r\n\t                 [min]=\"_min\"\r\n\t                 [max]=\"_fromMaxDate\"\r\n\t                 [ngClass]=\"datepickerwidth\"></bui-date-picker>\r\n\t<span class=\"bui-timespan-picker__until\">{{ 'bui.timespan-picker.until' | msgKey | async }}</span>\r\n\t<bui-date-picker [formControlName]=\"toName\"\r\n\t                 [min]=\"_toMinDate\"\r\n\t                 [max]=\"_max\"\r\n\t                 [ngClass]=\"datepickerwidth\"></bui-date-picker>\r\n</form>\r\n" }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }, { type: i1$2.FormBuilder }, { type: i0.Injector }], propDecorators: { _componentClass: [{
                type: HostBinding,
                args: ['class.bui-timespan-picker']
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], disabled: [{
                type: Input
            }], datepickerwidth: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], required: [{
                type: Input
            }] } });

class LeafInternComponent {
    constructor() {
        this.node = input.required();
        this.index = input('');
        this.disabled = input(false, { transform: coerceBooleanProperty });
        this.onValueChange = output();
        this.value = signal(false);
        this.root = inject((TreeComponent));
    }
    writeValue(selection) {
        if (this.node().id === undefined) {
            return;
        }
        this.value.set(selection.includes(this.node().id));
    }
    onCheckboxChange(value) {
        if (this.value() !== value) {
            this.value.set(value);
            this.onValueChange.emit();
            this.root.updateChildValue({
                id: this.node().id,
                value: this.value(),
            });
        }
    }
    setValue(value) {
        if (this.value() !== value) {
            this.value.set(value);
            this.root.updateChildValue({
                id: this.node().id,
                value: value,
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: LeafInternComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.1.1", type: LeafInternComponent, isStandalone: true, selector: "bui-leaf-intern", inputs: { node: { classPropertyName: "node", publicName: "node", isSignal: true, isRequired: true, transformFunction: null }, index: { classPropertyName: "index", publicName: "index", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { onValueChange: "onValueChange" }, ngImport: i0, template: "<li>\r\n\t<bui-checkbox [name]=\"'checkbox' + index()\"\r\n\t              [ngModel]=\"value()\"\r\n\t              (ngModelChange)=\"onCheckboxChange($event)\"\r\n\t              [disabled]=\"disabled()\">{{ node().name }}\r\n\t</bui-checkbox>\r\n</li>", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: MatIconModule }, { kind: "component", type: CheckboxComponent, selector: "bui-checkbox" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: LeafInternComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-leaf-intern', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        FormsModule,
                        MatIconModule,
                        CheckboxComponent,
                    ], template: "<li>\r\n\t<bui-checkbox [name]=\"'checkbox' + index()\"\r\n\t              [ngModel]=\"value()\"\r\n\t              (ngModelChange)=\"onCheckboxChange($event)\"\r\n\t              [disabled]=\"disabled()\">{{ node().name }}\r\n\t</bui-checkbox>\r\n</li>" }]
        }], ctorParameters: () => [] });

class TreeInternComponent {
    constructor() {
        this.node = input.required();
        this.index = input('');
        this.disabled = input(false, { transform: coerceBooleanProperty });
        this.open = input(false, { transform: coerceBooleanProperty });
        this.onValueChange = output();
        this.checkboxControl = viewChild('controlRef', { read: CheckboxComponent });
        this.collapseControl = viewChild.required('collapseRef', { read: (ElementRef) });
        this.subTrees = viewChildren('subTreeRef', { read: (TreeInternComponent) });
        this.leaves = viewChildren('leafRef', { read: (LeafInternComponent) });
        this.value = signal(false);
        this.root = inject((TreeComponent));
    }
    writeValue(selection) {
        if (this.node().id === undefined) {
            return;
        }
        this.value.set(selection.includes(this.node().id));
        this.subTrees()
            .forEach(subTree => subTree.writeValue(selection));
        this.leaves()
            .forEach(leaf => leaf.writeValue(selection));
    }
    onCheckboxChange(value) {
        this.setValue(value);
        this.root.updateChildValue({
            id: this.node().id,
            value: this.value(),
        });
    }
    setValue(value) {
        if (this.value() !== value) {
            this.value.set(value);
            if (this.node().id !== undefined) {
                this.root.updateChildValue({
                    id: this.node().id,
                    value: value,
                });
            }
        }
        this.subTrees()
            .forEach(subTree => subTree.setValue(value));
        this.leaves()
            .forEach(leaf => leaf.setValue(value));
        this.onValueChange.emit();
    }
    onChildValueChange() {
        const hasUnchecked = this.subTrees()
            .some(subTree => !subTree.value()) || this.leaves()
            .some(leaf => !leaf.value());
        if (hasUnchecked === this.value()) {
            this.value.set(!hasUnchecked);
            const valueChange = {
                id: this.node().id,
                value: this.value(),
            };
            if (this.node().id !== undefined) {
                this.root.updateChildValue(valueChange);
            }
        }
        this.onValueChange.emit();
    }
    openAll() {
        this.collapseControl().nativeElement.checked = true;
        this.subTrees()
            .forEach((child) => {
            child.openAll();
        });
    }
    closeAll() {
        this.collapseControl().nativeElement.checked = false;
        this.subTrees()
            .forEach((child) => {
            child.closeAll();
        });
    }
    determineIndeterminate() {
        let hasChecked = false;
        let hasUnchecked = false;
        for (const leaf of this.leaves()) {
            hasChecked = hasChecked || leaf.value();
            hasUnchecked = hasUnchecked || !leaf.value();
            if (hasChecked && hasUnchecked) {
                break;
            }
        }
        if (!(hasChecked && hasUnchecked)) {
            for (const subTree of this.subTrees()) {
                const subTreeIndeterminateState = subTree.determineIndeterminate();
                hasChecked = hasChecked || subTreeIndeterminateState.hasChecked;
                hasUnchecked = hasUnchecked || subTreeIndeterminateState.hasUnchecked;
            }
        }
        if (this.checkboxControl()) {
            this.checkboxControl().nativeElement().indeterminate = hasChecked && hasUnchecked;
        }
        return { hasChecked, hasUnchecked };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TreeInternComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: TreeInternComponent, isStandalone: true, selector: "bui-tree-intern", inputs: { node: { classPropertyName: "node", publicName: "node", isSignal: true, isRequired: true, transformFunction: null }, index: { classPropertyName: "index", publicName: "index", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, open: { classPropertyName: "open", publicName: "open", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { onValueChange: "onValueChange" }, viewQueries: [{ propertyName: "checkboxControl", first: true, predicate: ["controlRef"], descendants: true, read: CheckboxComponent, isSignal: true }, { propertyName: "collapseControl", first: true, predicate: ["collapseRef"], descendants: true, read: ElementRef, isSignal: true }, { propertyName: "subTrees", predicate: ["subTreeRef"], descendants: true, read: TreeInternComponent, isSignal: true }, { propertyName: "leaves", predicate: ["leafRef"], descendants: true, read: LeafInternComponent, isSignal: true }], ngImport: i0, template: "<li>\r\n\t<input #collapseRef\r\n\t       class=\"collapse\"\r\n\t       type=\"checkbox\"\r\n\t       [id]=\"'control' + index()\"\r\n\t       [checked]=\"open()\"/>\r\n\t@if (node().id !== undefined) {\r\n\t\t<bui-checkbox #controlRef\r\n\t\t              [name]=\"'checkbox' + index()\"\r\n\t\t              [ngModel]=\"value()\"\r\n\t\t              [disabled]=\"disabled()\"\r\n\t\t              (ngModelChange)=\"onCheckboxChange($event)\">{{ node().name }}\r\n\t\t</bui-checkbox>\r\n\t} @else {\r\n\t\t<span class=\"bui-tree__label\">{{ node().name }}</span>\r\n\t}\r\n\t<ul>\r\n\t\t@for (subTree of node().children; track subTree; let subTreeIndex = $index) {\r\n\t\t\t@if (subTree.children?.length) {\r\n\t\t\t\t<bui-tree-intern #subTreeRef\r\n\t\t\t\t                 [node]=\"subTree\"\r\n\t\t\t\t                 [index]=\"index() + ':' + subTreeIndex\"\r\n\t\t\t\t                 [disabled]=\"disabled()\"\r\n\t\t\t\t                 (onValueChange)=\"onChildValueChange()\"></bui-tree-intern>\r\n\t\t\t} @else {\r\n\t\t\t\t<bui-leaf-intern #leafRef\r\n\t\t\t\t                 [node]=\"subTree\"\r\n\t\t\t\t                 [index]=\"index() + ':' + subTreeIndex\"\r\n\t\t\t\t                 [disabled]=\"disabled()\"\r\n\t\t\t\t                 (onValueChange)=\"onChildValueChange()\"></bui-leaf-intern>\r\n\t\t\t}\r\n\t\t}\r\n\t</ul>\r\n</li>", dependencies: [{ kind: "component", type: TreeInternComponent, selector: "bui-tree-intern", inputs: ["node", "index", "disabled", "open"], outputs: ["onValueChange"] }, { kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: MatIconModule }, { kind: "component", type: CheckboxComponent, selector: "bui-checkbox" }, { kind: "component", type: LeafInternComponent, selector: "bui-leaf-intern", inputs: ["node", "index", "disabled"], outputs: ["onValueChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TreeInternComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-tree-intern', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        FormsModule,
                        MatIconModule,
                        CheckboxComponent,
                        LeafInternComponent,
                    ], template: "<li>\r\n\t<input #collapseRef\r\n\t       class=\"collapse\"\r\n\t       type=\"checkbox\"\r\n\t       [id]=\"'control' + index()\"\r\n\t       [checked]=\"open()\"/>\r\n\t@if (node().id !== undefined) {\r\n\t\t<bui-checkbox #controlRef\r\n\t\t              [name]=\"'checkbox' + index()\"\r\n\t\t              [ngModel]=\"value()\"\r\n\t\t              [disabled]=\"disabled()\"\r\n\t\t              (ngModelChange)=\"onCheckboxChange($event)\">{{ node().name }}\r\n\t\t</bui-checkbox>\r\n\t} @else {\r\n\t\t<span class=\"bui-tree__label\">{{ node().name }}</span>\r\n\t}\r\n\t<ul>\r\n\t\t@for (subTree of node().children; track subTree; let subTreeIndex = $index) {\r\n\t\t\t@if (subTree.children?.length) {\r\n\t\t\t\t<bui-tree-intern #subTreeRef\r\n\t\t\t\t                 [node]=\"subTree\"\r\n\t\t\t\t                 [index]=\"index() + ':' + subTreeIndex\"\r\n\t\t\t\t                 [disabled]=\"disabled()\"\r\n\t\t\t\t                 (onValueChange)=\"onChildValueChange()\"></bui-tree-intern>\r\n\t\t\t} @else {\r\n\t\t\t\t<bui-leaf-intern #leafRef\r\n\t\t\t\t                 [node]=\"subTree\"\r\n\t\t\t\t                 [index]=\"index() + ':' + subTreeIndex\"\r\n\t\t\t\t                 [disabled]=\"disabled()\"\r\n\t\t\t\t                 (onValueChange)=\"onChildValueChange()\"></bui-leaf-intern>\r\n\t\t\t}\r\n\t\t}\r\n\t</ul>\r\n</li>" }]
        }], ctorParameters: () => [] });

let counter = 0;
class TreeComponent {
    constructor() {
        this.tree = input.required();
        this.hint = input();
        this.name = input('');
        this.showRoot = input(true, { transform: coerceBooleanProperty });
        this.disabledInput = input(false, { alias: 'disabled', transform: coerceBooleanProperty });
        this.formControlName = input('bui-tree-' + counter++);
        this.disabled = linkedSignal(() => this.disabledInput());
        this.value = [];
        this.treeIntern = viewChildren('treeIntern', { read: (TreeInternComponent) });
        this._onChangeFn = () => {
        };
        this._onTouchedFn = () => {
        };
    }
    determineIndeterminate() {
        this.treeIntern()
            .forEach(tree => tree.determineIndeterminate());
    }
    updateChildValue(valueChange) {
        if (valueChange.id === undefined) {
            return;
        }
        if (valueChange.value) {
            if (!this.value.includes(valueChange.id)) {
                this.value.push(valueChange.id);
            }
        }
        else {
            const i = this.value.findIndex(v => v === valueChange.id);
            if (i >= 0) {
                this.value.splice(i, 1);
            }
        }
        this._onChangeFn(this.value);
    }
    openAll() {
        this.treeIntern()
            .forEach(tree => tree.openAll());
    }
    closeAll() {
        this.treeIntern()
            .forEach(tree => tree.closeAll());
    }
    registerOnChange(fn) {
        this._onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedFn = fn;
    }
    writeValue(obj) {
        this.value = obj ? [...obj] : [];
        this.treeIntern()
            .forEach(tree => {
            tree.writeValue(this.value);
            tree.determineIndeterminate();
        });
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    ngAfterViewInit() {
        this.treeIntern()
            .forEach(tree => {
            tree.writeValue(this.value);
            tree.determineIndeterminate();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TreeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.1.1", type: TreeComponent, isStandalone: true, selector: "bui-tree", inputs: { tree: { classPropertyName: "tree", publicName: "tree", isSignal: true, isRequired: true, transformFunction: null }, hint: { classPropertyName: "hint", publicName: "hint", isSignal: true, isRequired: false, transformFunction: null }, name: { classPropertyName: "name", publicName: "name", isSignal: true, isRequired: false, transformFunction: null }, showRoot: { classPropertyName: "showRoot", publicName: "showRoot", isSignal: true, isRequired: false, transformFunction: null }, disabledInput: { classPropertyName: "disabledInput", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, formControlName: { classPropertyName: "formControlName", publicName: "formControlName", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class.bui-tree": "true" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: TreeComponent,
                multi: true,
            },
        ], viewQueries: [{ propertyName: "treeIntern", predicate: ["treeIntern"], descendants: true, read: TreeInternComponent, isSignal: true }], ngImport: i0, template: "<div class=\"tree-actions\">\r\n\t<a (click)=\"openAll()\">\r\n\t\t<mat-icon>add</mat-icon>\r\n\t\t{{ 'bui.tree.openAll' | msgKey | async }}\r\n\t</a>\r\n\t<a (click)=\"closeAll()\">\r\n\t\t<mat-icon>remove</mat-icon>\r\n\t\t{{ 'bui.tree.closeAll' | msgKey | async }}\r\n\t</a>\r\n\t@if (hint()) {\r\n\t\t<bui-hint [hint]=\"hint()!\"></bui-hint>\r\n\t}\r\n</div>\r\n\r\n<ul buiValidationControl>\r\n\t@if (showRoot()) {\r\n\t\t<bui-tree-intern #treeIntern\r\n\t\t                 [node]=\"tree()\"\r\n\t\t                 [index]=\"formControlName() + ':0'\"\r\n\t\t                 [disabled]=\"disabled()\"\r\n\t\t                 [open]=\"true\"\r\n\t\t                 (onValueChange)=\"determineIndeterminate()\"></bui-tree-intern>\r\n\t} @else {\r\n\t\t@for (subTree of tree().children; track subTree; let i = $index) {\r\n\t\t\t@if (subTree.children?.length) {\r\n\t\t\t\t<bui-tree-intern #treeIntern\r\n\t\t\t\t                 [node]=\"subTree\"\r\n\t\t\t\t                 [index]=\"formControlName() + ':' + i\"\r\n\t\t\t\t                 [disabled]=\"disabled()\"\r\n\t\t\t\t                 (onValueChange)=\"determineIndeterminate()\"></bui-tree-intern>\r\n\t\t\t} @else {\r\n\t\t\t\t<bui-leaf-intern [node]=\"subTree\"\r\n\t\t\t\t                 [index]=\"formControlName() + ':' + i\"\r\n\t\t\t\t                 [disabled]=\"disabled()\"\r\n\t\t\t\t                 (onValueChange)=\"determineIndeterminate()\"></bui-leaf-intern>\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</ul>", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "ngmodule", type: FormsModule }, { kind: "ngmodule", type: MatIconModule }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: HintComponent, selector: "bui-hint", inputs: ["hint", "tiny", "newicon"] }, { kind: "component", type: TreeInternComponent, selector: "bui-tree-intern", inputs: ["node", "index", "disabled", "open"], outputs: ["onValueChange"] }, { kind: "component", type: LeafInternComponent, selector: "bui-leaf-intern", inputs: ["node", "index", "disabled"], outputs: ["onValueChange"] }, { kind: "directive", type: ValidationControlDirective, selector: "[buiValidationControl]", inputs: ["tooltip"], outputs: ["tooltipChange"] }, { kind: "pipe", type: MsgKeyPipe, name: "msgKey" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: TreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bui-tree', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        FormsModule,
                        MatIconModule,
                        HintComponent,
                        TreeInternComponent,
                        LeafInternComponent,
                        ValidationControlDirective,
                        MsgKeyPipe,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: TreeComponent,
                            multi: true,
                        },
                    ], host: {
                        '[class.bui-tree]': 'true',
                    }, template: "<div class=\"tree-actions\">\r\n\t<a (click)=\"openAll()\">\r\n\t\t<mat-icon>add</mat-icon>\r\n\t\t{{ 'bui.tree.openAll' | msgKey | async }}\r\n\t</a>\r\n\t<a (click)=\"closeAll()\">\r\n\t\t<mat-icon>remove</mat-icon>\r\n\t\t{{ 'bui.tree.closeAll' | msgKey | async }}\r\n\t</a>\r\n\t@if (hint()) {\r\n\t\t<bui-hint [hint]=\"hint()!\"></bui-hint>\r\n\t}\r\n</div>\r\n\r\n<ul buiValidationControl>\r\n\t@if (showRoot()) {\r\n\t\t<bui-tree-intern #treeIntern\r\n\t\t                 [node]=\"tree()\"\r\n\t\t                 [index]=\"formControlName() + ':0'\"\r\n\t\t                 [disabled]=\"disabled()\"\r\n\t\t                 [open]=\"true\"\r\n\t\t                 (onValueChange)=\"determineIndeterminate()\"></bui-tree-intern>\r\n\t} @else {\r\n\t\t@for (subTree of tree().children; track subTree; let i = $index) {\r\n\t\t\t@if (subTree.children?.length) {\r\n\t\t\t\t<bui-tree-intern #treeIntern\r\n\t\t\t\t                 [node]=\"subTree\"\r\n\t\t\t\t                 [index]=\"formControlName() + ':' + i\"\r\n\t\t\t\t                 [disabled]=\"disabled()\"\r\n\t\t\t\t                 (onValueChange)=\"determineIndeterminate()\"></bui-tree-intern>\r\n\t\t\t} @else {\r\n\t\t\t\t<bui-leaf-intern [node]=\"subTree\"\r\n\t\t\t\t                 [index]=\"formControlName() + ':' + i\"\r\n\t\t\t\t                 [disabled]=\"disabled()\"\r\n\t\t\t\t                 (onValueChange)=\"determineIndeterminate()\"></bui-leaf-intern>\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</ul>" }]
        }], ctorParameters: () => [] });

const modules = [
    DialogModule,
    MaterialModule,
];
const components = [
    ButtonComponent,
    ButtonGroupComponent,
    ButtonLineComponent,
    ButtonToggleComponent,
    ButtonToggleOptionComponent,
    CardComponent,
    CheckboxComponent,
    CheckboxGroupComponent,
    ColorPickerComponent,
    DataTableComponent,
    DatePickerComponent,
    FieldComponent,
    GroupComponent,
    HintComponent,
    InputComponent,
    InputDecimalComponent,
    KachelChoiceComponent,
    KachelComponent,
    LabelComponent,
    RadioComponent,
    RadioGroupComponent,
    RangeSliderComponent,
    SelectComponent,
    SlideToggleComponent,
    SpinnerComponent,
    TextareaComponent,
    TimespanPickerComponent,
    TreeComponent,
    UnassignableErrorsComponent,
    WysiwygComponent,
];
const directives = [
    TooltipDirective,
    ValidationContextDirective,
    OptionDirective,
];
class BuiModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: BuiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.1.1", ngImport: i0, type: BuiModule, imports: [DialogModule,
            MaterialModule, ButtonComponent,
            ButtonGroupComponent,
            ButtonLineComponent,
            ButtonToggleComponent,
            ButtonToggleOptionComponent,
            CardComponent,
            CheckboxComponent,
            CheckboxGroupComponent,
            ColorPickerComponent,
            DataTableComponent,
            DatePickerComponent,
            FieldComponent,
            GroupComponent,
            HintComponent,
            InputComponent,
            InputDecimalComponent,
            KachelChoiceComponent,
            KachelComponent,
            LabelComponent,
            RadioComponent,
            RadioGroupComponent,
            RangeSliderComponent,
            SelectComponent,
            SlideToggleComponent,
            SpinnerComponent,
            TextareaComponent,
            TimespanPickerComponent,
            TreeComponent,
            UnassignableErrorsComponent,
            WysiwygComponent, TooltipDirective,
            ValidationContextDirective,
            OptionDirective], exports: [DialogModule,
            MaterialModule, ButtonComponent,
            ButtonGroupComponent,
            ButtonLineComponent,
            ButtonToggleComponent,
            ButtonToggleOptionComponent,
            CardComponent,
            CheckboxComponent,
            CheckboxGroupComponent,
            ColorPickerComponent,
            DataTableComponent,
            DatePickerComponent,
            FieldComponent,
            GroupComponent,
            HintComponent,
            InputComponent,
            InputDecimalComponent,
            KachelChoiceComponent,
            KachelComponent,
            LabelComponent,
            RadioComponent,
            RadioGroupComponent,
            RangeSliderComponent,
            SelectComponent,
            SlideToggleComponent,
            SpinnerComponent,
            TextareaComponent,
            TimespanPickerComponent,
            TreeComponent,
            UnassignableErrorsComponent,
            WysiwygComponent, TooltipDirective,
            ValidationContextDirective,
            OptionDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: BuiModule, imports: [modules, ButtonComponent,
            ButtonToggleOptionComponent,
            CheckboxComponent,
            ColorPickerComponent,
            DataTableComponent,
            DatePickerComponent,
            FieldComponent,
            GroupComponent,
            InputComponent,
            InputDecimalComponent,
            KachelChoiceComponent,
            KachelComponent,
            LabelComponent,
            RadioComponent,
            RangeSliderComponent,
            SelectComponent,
            SlideToggleComponent,
            SpinnerComponent,
            TextareaComponent,
            TimespanPickerComponent,
            TreeComponent,
            UnassignableErrorsComponent,
            WysiwygComponent, DialogModule,
            MaterialModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.1", ngImport: i0, type: BuiModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        ...modules,
                        ...components,
                        ...directives,
                    ],
                    exports: [
                        ...modules,
                        ...components,
                        ...directives,
                    ],
                }]
        }] });

/*
 * Public API Surface of ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BUI_BUTTON_GROUP, BUI_BUTTON_TOGGLE, BUI_CHECKBOX_GROUP, BUI_MESSAGE_RESOLVER, BUI_RADIO_GROUP, BUI_TOOLTIP_CONFIG, BUI_WYSIWYG_DYNAMIC_CONFIG, BUI_WYSIWYG_STATIC_CONFIG, BUI_WYSIWYG_TIPTAP_CONFIG_SERVICE, BUI_WYSIWYG_TOOLBAR_RESOLVER, BetweenValidator, BuiModule, ButtonComponent, ButtonGroupComponent, ButtonLineComponent, ButtonToggleComponent, ButtonToggleOptionComponent, CardComponent, CheckboxComponent, CheckboxGroupComponent, ColorPickerComponent, DataTableComponent, DatePickerComponent, DialogActionDirective, DialogActionsComponent, DialogComponent, DialogContentComponent, DialogModule, DialogTitleDirective, FieldComponent, GenericErrorControlNameDirective, GroupComponent, HintComponent, InputComponent, InputDecimalComponent, KachelChoiceComponent, KachelComponent, KachelStatusEnum, LabelComponent, MaterialModule, OptionDirective, RadioComponent, RadioGroupComponent, RangeSliderComponent, SelectComponent, SlideToggleComponent, SpinnerComponent, TextareaComponent, TimespanPickerComponent, TooltipComponent, TooltipDirective, TreeComponent, UnassignableErrorsComponent, ValidationContextDirective, ValidationControlDirective, ValidationUtils, WysiwygComponent, WysiwygTiptapConfigService, createCustomElements };
